var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainanimation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 3641 3067",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "mainsvg"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uploadline",
    d: "M1032.98 1007.5L1759.39 1404.81C1772.71 1412.1 1788.98 1402.46 1788.98 1387.26V993",
    stroke: "#245591",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "uploadlight"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 11",
    x: 1794.62,
    y: 1030,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1030)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 12",
    x: 1794.62,
    y: 1055,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1055)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 13",
    x: 1794.62,
    y: 1080,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1080)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 14",
    x: 1794.62,
    y: 1105,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1105)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 15",
    x: 1794.62,
    y: 1130,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1130)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 16",
    x: 1794.62,
    y: 1155,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1155)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 17",
    x: 1794.62,
    y: 1180,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1180)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 18",
    x: 1794.62,
    y: 1205,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1205)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 19",
    x: 1794.62,
    y: 1230,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1230)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 20",
    x: 1794.62,
    y: 1255,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1255)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 21",
    x: 1794.62,
    y: 1280,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1280)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 22",
    x: 1794.62,
    y: 1305,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1305)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 23",
    x: 1794.62,
    y: 1330,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1330)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 24",
    x: 1794.62,
    y: 1355,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1355)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 25",
    x: 1794.62,
    y: 1380,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(89.799 1794.62 1380)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 26",
    x: 1782.53,
    y: 1410.35,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(175.177 1782.53 1410.35)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 27",
    x: 1752.86,
    y: 1408.68,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1752.86 1408.68)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 28",
    x: 1730.75,
    y: 1396.22,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1730.75 1396.22)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 29",
    x: 1708.65,
    y: 1384.41,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1708.65 1384.41)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 30",
    x: 1686.54,
    y: 1371.6,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1686.54 1371.6)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 31",
    x: 1664.44,
    y: 1359.78,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1664.44 1359.78)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 32",
    x: 1642.34,
    y: 1347.97,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1642.34 1347.97)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 33",
    x: 1620.23,
    y: 1335.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1620.23 1335.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 34",
    x: 1597.23,
    y: 1323.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1597.23 1323.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 35",
    x: 1574.23,
    y: 1311.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1574.23 1311.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 36",
    x: 1551.23,
    y: 1298.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1551.23 1298.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 37",
    x: 1529.22,
    y: 1286.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1529.22 1286.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 38",
    x: 1507.22,
    y: 1274.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1507.22 1274.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 39",
    x: 1484.22,
    y: 1261.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1484.22 1261.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 40",
    x: 1461.22,
    y: 1248.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1461.22 1248.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 41",
    x: 1438.22,
    y: 1235.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1438.22 1235.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 42",
    x: 1415.22,
    y: 1222.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1415.22 1222.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 43",
    x: 1389.22,
    y: 1208.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1389.22 1208.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 44",
    x: 1365.91,
    y: 1195.6,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.045 1365.91 1195.6)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 45",
    x: 1344.04,
    y: 1183.36,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.045 1344.04 1183.36)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 46",
    x: 1322.17,
    y: 1171.13,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.045 1322.17 1171.13)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 47",
    x: 1299.12,
    y: 1159.32,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.045 1299.12 1159.32)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 48",
    x: 1276.24,
    y: 1148.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1276.24 1148.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 49",
    x: 1253.24,
    y: 1135.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1253.24 1135.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 50",
    x: 1230.24,
    y: 1122.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1230.24 1122.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 51",
    x: 1204.24,
    y: 1109.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1204.24 1109.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 52",
    x: 1181.24,
    y: 1096.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1181.24 1096.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 53",
    x: 1159.24,
    y: 1084.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1159.24 1084.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 54",
    x: 1137.24,
    y: 1072.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1137.24 1072.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 55",
    x: 1114.24,
    y: 1059.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1114.24 1059.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 56",
    x: 1091.24,
    y: 1046.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1091.24 1046.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 57",
    x: 1068.24,
    y: 1033.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1068.24 1033.16)",
    fill: "#1FC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 58",
    x: 1045.24,
    y: 1020.16,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-151.657 1045.24 1020.16)",
    fill: "#1FC9FF"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "downloadline",
    d: "M2881.51 2047.5L2143.84 1611.81C2137.75 1608.21 2134.01 1601.66 2134.01 1594.59V1207",
    stroke: "#245591",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "downloadlight"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 75",
    x: 2128.35,
    y: 1257.17,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128.35 1257.17)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 76",
    x: 2128,
    y: 1282,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128 1282)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 77",
    x: 2128,
    y: 1307,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128 1307)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 78",
    x: 2128,
    y: 1332,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128 1332)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 79",
    x: 2128,
    y: 1357,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128 1357)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 80",
    x: 2128.35,
    y: 1382,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128.35 1382)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 81",
    x: 2128,
    y: 1406.83,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128 1406.83)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 82",
    x: 2128,
    y: 1431.83,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128 1431.83)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 83",
    x: 2128,
    y: 1456.83,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128 1456.83)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 84",
    x: 2128,
    y: 1481.83,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128 1481.83)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 85",
    x: 2128.35,
    y: 1507,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128.35 1507)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 86",
    x: 2128,
    y: 1531.83,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128 1531.83)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 87",
    x: 2128,
    y: 1556.83,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128 1556.83)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 88",
    x: 2128,
    y: 1581.83,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-90 2128 1581.83)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 89",
    x: 2131.22,
    y: 1608.4,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-98.0367 2131.22 1608.4)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 90",
    x: 2156.76,
    y: 1625.3,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150 2156.76 1625.3)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 91",
    x: 2177.92,
    y: 1638.58,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150 2177.92 1638.58)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 92",
    x: 2199.92,
    y: 1651.58,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150 2199.92 1651.58)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 93",
    x: 2220.92,
    y: 1664.58,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150 2220.92 1664.58)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 94",
    x: 2242.92,
    y: 1677.58,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150 2242.92 1677.58)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 95",
    x: 2265.85,
    y: 1690.74,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2265.85 1690.74)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 96",
    x: 2287.07,
    y: 1703.92,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2287.07 1703.92)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 97",
    x: 2309.13,
    y: 1716.82,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2309.13 1716.82)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 98",
    x: 2330.19,
    y: 1729.72,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2330.19 1729.72)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 99",
    x: 2352.25,
    y: 1742.62,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2352.25 1742.62)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 100",
    x: 2375.97,
    y: 1755.51,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2375.97 1755.51)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 101",
    x: 2397.2,
    y: 1768.69,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2397.2 1768.69)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 102",
    x: 2419.26,
    y: 1781.58,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2419.26 1781.58)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 103",
    x: 2440.32,
    y: 1794.49,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2440.32 1794.49)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 104",
    x: 2462.38,
    y: 1807.39,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2462.38 1807.39)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 105",
    x: 2484.97,
    y: 1820.51,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2484.97 1820.51)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 106",
    x: 2507.03,
    y: 1833.41,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2507.03 1833.41)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 107",
    x: 2528.09,
    y: 1846.31,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2528.09 1846.31)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 108",
    x: 2550.15,
    y: 1859.21,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2550.15 1859.21)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 109",
    x: 2573.97,
    y: 1872.51,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2573.97 1872.51)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 110",
    x: 2596.03,
    y: 1885.41,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2596.03 1885.41)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 111",
    x: 2617.09,
    y: 1898.31,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2617.09 1898.31)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 112",
    x: 2639.15,
    y: 1911.21,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2639.15 1911.21)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 113",
    x: 2661.97,
    y: 1925.51,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2661.97 1925.51)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 114",
    x: 2684.03,
    y: 1938.41,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2684.03 1938.41)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 115",
    x: 2705.09,
    y: 1951.31,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2705.09 1951.31)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 116",
    x: 2727.15,
    y: 1964.21,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2727.15 1964.21)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 117",
    x: 2749.97,
    y: 1977.51,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2749.97 1977.51)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 118",
    x: 2772.03,
    y: 1990.41,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2772.03 1990.41)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 119",
    x: 2793.09,
    y: 2003.31,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2793.09 2003.31)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 120",
    x: 2815.15,
    y: 2016.21,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2815.15 2016.21)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 121",
    x: 2835.97,
    y: 2028.51,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2835.97 2028.51)",
    fill: "#46FF85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "mainrect 122",
    x: 2858.03,
    y: 2041.41,
    width: 23,
    height: 11.6358,
    rx: 5.81788,
    transform: "rotate(-150.264 2858.03 2041.41)",
    fill: "#46FF85"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "mainanimcloud",
    style: {
      filter: "drop-shadow(7px 122px 73px hsl(0deg 0% 0% / 0.25))"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g4021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4029"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4037",
    d: "M1579.52 583.658C1577.13 583.358 1574.79 583.112 1572.47 582.971C1571.21 582.883 1569.96 582.83 1568.72 582.794C1566.8 582.759 1564.91 582.777 1563.04 582.847C1561.8 582.9 1560.55 582.935 1559.32 583.024C1557.63 583.165 1555.97 583.376 1554.31 583.622C1553.09 583.799 1551.87 583.94 1550.67 584.169C1549.12 584.451 1547.61 584.838 1546.11 585.208C1544.92 585.507 1543.73 585.772 1542.57 586.124C1541.11 586.582 1539.68 587.128 1538.24 587.657C1537.15 588.062 1536.03 588.432 1534.95 588.908C1533.45 589.542 1532.03 590.299 1530.59 591.039C1529.49 591.585 1528.36 592.096 1527.29 592.713L1707.61 487.927C1707.89 487.769 1708.16 487.61 1708.43 487.452C1709.23 486.994 1710.09 486.659 1710.92 486.236C1712.36 485.496 1713.79 484.739 1715.27 484.104C1715.48 484.016 1715.67 483.893 1715.88 483.823C1716.75 483.453 1717.69 483.188 1718.59 482.854C1720.01 482.325 1721.43 481.779 1722.89 481.339C1723.17 481.251 1723.44 481.127 1723.72 481.057C1724.6 480.792 1725.53 480.652 1726.44 480.422C1727.93 480.035 1729.44 479.665 1731 479.365C1731.36 479.295 1731.69 479.189 1732.07 479.119C1732.89 478.978 1733.79 478.943 1734.64 478.819C1736.29 478.59 1737.95 478.379 1739.64 478.238C1740.12 478.203 1740.59 478.097 1741.07 478.062C1741.81 478.027 1742.61 478.079 1743.37 478.044C1745.24 477.974 1747.13 477.956 1749.04 478.009C1749.71 478.027 1750.32 477.956 1750.99 477.991C1751.57 478.009 1752.2 478.132 1752.78 478.168C1755.11 478.308 1757.47 478.555 1759.83 478.872C1760.64 478.978 1761.38 478.996 1762.19 479.101C1762.53 479.154 1762.9 479.26 1763.23 479.33C1766.81 479.912 1770.42 480.616 1774.1 481.568L1593.77 586.371C1590.08 585.402 1586.47 584.697 1582.91 584.116C1581.76 583.94 1580.65 583.816 1579.52 583.658Z",
    fill: "url(#paint0_linear_71_514)"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g4039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4055",
    d: "M1858.07 511.963C1855.6 509.901 1853.12 507.784 1850.63 505.796C1846.21 502.279 1841.74 499.003 1837.29 495.781C1835.13 494.234 1833 492.577 1830.84 491.086C1824.2 486.557 1817.54 482.267 1810.86 478.42C1806.24 475.75 1801.66 473.32 1797.12 471.037C1795.78 470.356 1794.48 469.73 1793.17 469.104C1789.68 467.41 1786.22 465.845 1782.79 464.372C1781.6 463.857 1780.38 463.305 1779.2 462.826C1776.07 461.537 1772.96 460.378 1769.85 459.273C1769.01 458.978 1768.17 458.628 1767.33 458.334C1763.42 457.008 1759.54 455.812 1755.71 454.762C1755.24 454.633 1754.76 454.523 1754.29 454.412C1748.18 452.774 1742.16 451.467 1736.26 450.546L1735.97 450.509C1731.05 449.755 1726.24 449.313 1721.49 449.055C1720.53 449 1719.56 448.926 1718.6 448.889C1714.33 448.742 1710.13 448.76 1706.01 449C1705.33 449.037 1704.65 449.129 1703.97 449.184C1700.63 449.442 1697.33 449.828 1694.1 450.344C1693.09 450.491 1692.08 450.657 1691.08 450.841C1687.38 451.522 1683.74 452.314 1680.21 453.345L1679.92 453.437C1676.49 454.449 1673.18 455.646 1669.93 456.972C1669 457.34 1668.08 457.745 1667.16 458.15C1664.4 459.346 1661.71 460.672 1659.08 462.09C1658.24 462.55 1657.36 462.955 1656.53 463.452L1836.84 358.642C1837.23 358.421 1837.62 358.2 1838 357.979C1838.46 357.721 1838.96 357.555 1839.4 357.298C1842.04 355.862 1844.72 354.554 1847.48 353.358C1848 353.137 1848.46 352.842 1848.98 352.621C1849.38 352.456 1849.84 352.345 1850.25 352.18C1853.5 350.854 1856.82 349.657 1860.24 348.645L1860.48 348.553H1860.54C1864.07 347.522 1867.72 346.73 1871.42 346.049C1871.86 345.957 1872.27 345.828 1872.71 345.754C1873.26 345.644 1873.87 345.644 1874.42 345.533C1877.66 345.036 1880.94 344.65 1884.29 344.392C1884.8 344.355 1885.3 344.245 1885.82 344.208C1885.98 344.208 1886.17 344.226 1886.35 344.208C1890.45 343.969 1894.67 343.95 1898.92 344.097C1899.35 344.116 1899.75 344.079 1900.19 344.097C1900.71 344.116 1901.28 344.226 1901.83 344.263C1906.56 344.521 1911.37 344.944 1916.3 345.699L1916.38 345.717L1916.58 345.754C1922.47 346.675 1928.49 347.982 1934.6 349.602C1934.92 349.694 1935.21 349.713 1935.52 349.805C1935.69 349.86 1935.87 349.915 1936.04 349.97C1939.89 351.02 1943.75 352.216 1947.66 353.542C1948.5 353.836 1949.35 354.186 1950.18 354.481C1953.27 355.585 1956.38 356.745 1959.51 358.034C1959.95 358.2 1960.34 358.329 1960.76 358.494C1961.54 358.826 1962.33 359.231 1963.1 359.562C1966.54 361.035 1970.01 362.618 1973.5 364.312C1974.81 364.938 1976.12 365.564 1977.44 366.227C1981.99 368.528 1986.58 370.94 1991.18 373.628C1997.86 377.475 2004.53 381.747 2011.15 386.294C2013.33 387.767 2015.44 389.424 2017.58 390.97C2022.07 394.192 2026.53 397.488 2030.96 401.004C2033.45 402.992 2035.92 405.091 2038.38 407.171C2042.45 410.559 2046.48 414.038 2050.48 417.684C2053.02 419.985 2055.52 422.342 2058.04 424.735C2059.79 426.41 2061.58 427.938 2063.31 429.65C2066.97 433.277 2070.6 436.996 2074.19 440.826L1893.88 545.618C1888.58 540.003 1883.15 534.737 1877.7 529.527C1875.19 527.134 1872.69 524.777 1870.17 522.476C1866.15 518.849 1862.12 515.369 1858.07 511.963Z",
    fill: "url(#paint1_linear_71_514)"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g4057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4073",
    d: "M2442.14 1169.17C2442.14 1162.37 2441.92 1155.48 2441.46 1148.52C2441.3 1146.12 2440.96 1143.65 2440.75 1141.23C2440.35 1136.68 2440 1132.14 2439.38 1127.54C2438.22 1118.58 2436.61 1109.49 2434.73 1100.39C2434.12 1097.42 2433.44 1094.43 2432.75 1091.44C2431.68 1086.8 2430.57 1082.16 2429.33 1077.5C2428.4 1074.04 2427.45 1070.59 2426.44 1067.13C2425.37 1063.42 2424.22 1059.72 2423.05 1056.01C2421.83 1052.22 2420.58 1048.44 2419.25 1044.66C2418.15 1041.48 2417.01 1038.29 2415.81 1035.11C2414.31 1031.04 2412.73 1026.99 2411.1 1022.95C2409.97 1020.13 2408.82 1017.3 2407.65 1014.49C2405.79 1010.12 2403.84 1005.78 2401.85 1001.43C2400.74 998.996 2399.66 996.543 2398.49 994.121C2395.96 988.81 2393.29 983.532 2390.58 978.285C2389.86 976.897 2389.19 975.477 2388.45 974.088C2384.93 967.454 2381.27 960.884 2377.46 954.394C2376.33 952.457 2375.1 950.569 2373.96 948.648C2371.2 944.079 2368.42 939.511 2365.51 935.04C2363.74 932.279 2361.87 929.583 2360.04 926.855C2357.56 923.175 2355.1 919.494 2352.52 915.894C2350.19 912.601 2347.76 909.373 2345.35 906.144C2343.03 903.045 2340.73 899.946 2338.36 896.911C2334.34 891.794 2330.21 886.806 2326.01 881.866C2324.67 880.3 2323.38 878.654 2322.03 877.088C2315.34 869.436 2308.4 862.124 2301.33 855.037C2297.18 850.872 2293.03 846.724 2288.76 842.785L2469.08 737.988C2472.57 741.2 2476.01 744.477 2479.4 747.835C2480.17 748.609 2480.9 749.465 2481.66 750.24C2488.73 757.326 2495.67 764.639 2502.35 772.291C2502.53 772.484 2502.69 772.646 2502.85 772.839C2504.05 774.212 2505.16 775.697 2506.34 777.069C2510.54 782.008 2514.67 786.996 2518.69 792.114C2519.22 792.792 2519.79 793.421 2520.32 794.099C2522.14 796.472 2523.87 798.958 2525.66 801.347C2528.09 804.592 2530.51 807.804 2532.86 811.097C2533.43 811.888 2534.04 812.663 2534.61 813.47C2536.59 816.295 2538.45 819.201 2540.37 822.074C2542.21 824.786 2544.07 827.482 2545.84 830.242C2546.26 830.888 2546.71 831.501 2547.12 832.147C2549.59 835.989 2551.91 839.928 2554.27 843.85C2555.45 845.787 2556.64 847.66 2557.79 849.597C2557.95 849.888 2558.14 850.162 2558.3 850.453C2561.82 856.474 2565.21 862.576 2568.49 868.726C2568.59 868.92 2568.67 869.113 2568.78 869.291C2569.51 870.679 2570.17 872.1 2570.91 873.488C2573.25 878.024 2575.62 882.56 2577.84 887.161C2578.18 887.871 2578.48 888.597 2578.82 889.324C2579.98 891.761 2581.06 894.215 2582.18 896.669C2583.6 899.752 2585.08 902.835 2586.42 905.951C2586.97 907.194 2587.43 908.437 2587.96 909.68C2589.15 912.504 2590.28 915.329 2591.43 918.154C2592.4 920.56 2593.45 922.949 2594.38 925.37C2595 927.017 2595.53 928.679 2596.16 930.326C2597.34 933.506 2598.47 936.67 2599.58 939.85C2600.27 941.852 2601.05 943.837 2601.74 945.839C2602.32 947.631 2602.81 949.423 2603.37 951.214C2604.57 954.927 2605.7 958.624 2606.78 962.337C2607.31 964.225 2607.97 966.098 2608.49 967.97C2608.93 969.552 2609.23 971.118 2609.65 972.7C2610.88 977.365 2612.01 982.014 2613.08 986.663C2613.54 988.665 2614.14 990.667 2614.54 992.652C2614.77 993.637 2614.85 994.605 2615.06 995.59C2616.92 1004.69 2618.55 1013.77 2619.71 1022.73C2619.74 1022.87 2619.76 1023 2619.79 1023.15C2620.36 1027.65 2620.69 1032.09 2621.08 1036.56C2621.29 1038.95 2621.63 1041.37 2621.78 1043.74C2622.24 1050.68 2622.47 1057.58 2622.45 1064.37C2622.34 1106.83 2612.9 1141.44 2596.37 1166.93C2586.44 1182.21 2573.98 1194.22 2559.45 1202.68L2379.12 1307.46C2417.88 1284.95 2441.93 1237.1 2442.14 1169.17Z",
    fill: "url(#paint2_linear_71_514)"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g4075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4091",
    d: "M2278.79 802.44C2277.74 798.88 2276.66 795.32 2275.54 791.778C2274.15 787.458 2272.66 783.157 2271.15 778.856C2270.12 775.965 2269.12 773.073 2268.04 770.2C2266.18 765.248 2264.19 760.314 2262.17 755.399C2261.28 753.248 2260.45 751.116 2259.53 748.983C2256.53 742.025 2253.4 735.104 2250.09 728.255C2249.55 727.116 2248.94 725.996 2248.38 724.857C2245.56 719.164 2242.67 713.49 2239.65 707.887C2238.38 705.574 2237.08 703.279 2235.78 700.984C2233.34 696.574 2230.83 692.201 2228.24 687.882C2226.67 685.279 2225.1 682.713 2223.51 680.147C2221.03 676.171 2218.5 672.25 2215.95 668.364C2214.11 665.563 2212.25 662.78 2210.35 660.015C2207.91 656.473 2205.42 653.003 2202.89 649.533C2200.59 646.352 2198.28 643.172 2195.91 640.063C2193.65 637.099 2191.34 634.208 2189.03 631.316C2185.85 627.341 2182.65 623.401 2179.36 619.551C2177.32 617.148 2175.22 614.78 2173.14 612.413C2167.12 605.618 2160.98 599.04 2154.67 592.715C2153.7 591.739 2152.78 590.69 2151.78 589.733C2148.53 586.516 2145.17 583.516 2141.82 580.426C2139.35 578.167 2136.93 575.799 2134.43 573.594C2130.89 570.504 2127.28 567.631 2123.68 564.703C2121.28 562.733 2118.91 560.655 2116.49 558.775C2112.42 555.649 2108.3 552.757 2104.18 549.83C2102.12 548.384 2100.11 546.794 2098.02 545.402C2091.8 541.191 2085.49 537.234 2079.13 533.547C2072.55 529.752 2066.03 526.445 2059.56 523.39C2057.81 522.559 2056.05 521.764 2054.3 521.005C2048.05 518.204 2041.83 515.619 2035.72 513.523L2035.67 513.505C2029.94 511.535 2024.34 510.089 2018.79 508.734C2015.77 507.993 2012.79 507.379 2009.83 506.818C2006.01 506.095 2002.22 505.463 1998.51 505.029C1996.27 504.776 1994.09 504.523 1991.9 504.379C1987.42 504.053 1983.01 503.945 1978.69 504.053C1977.35 504.071 1975.99 503.999 1974.69 504.09C1969.18 504.361 1963.83 505.029 1958.59 506.023C1957.42 506.24 1956.26 506.565 1955.09 506.818C1950.87 507.758 1946.77 508.933 1942.78 510.324C1941.55 510.74 1940.3 511.156 1939.09 511.607C1934.14 513.559 1929.28 515.764 1924.69 518.439L2105.03 413.639C2105.41 413.422 2105.81 413.187 2106.2 412.971C2109.71 410.983 2113.32 409.211 2117.05 407.657C2117.82 407.332 2118.66 407.115 2119.43 406.826C2120.64 406.356 2121.87 405.959 2123.1 405.525C2124.89 404.892 2126.64 404.169 2128.49 403.627C2130.73 402.977 2133.09 402.543 2135.41 402.037C2136.58 401.766 2137.74 401.441 2138.91 401.224C2139.49 401.115 2140.05 400.935 2140.63 400.826C2144.9 400.085 2149.25 399.579 2153.7 399.29C2154.13 399.272 2154.58 399.308 2155.03 399.29C2156.34 399.218 2157.69 399.272 2159.01 399.254C2162.03 399.182 2165.01 399.037 2168.1 399.182C2169.44 399.236 2170.85 399.489 2172.22 399.579C2174.41 399.742 2176.61 399.977 2178.84 400.248C2180.66 400.447 2182.43 400.501 2184.27 400.772C2186.21 401.079 2188.21 401.657 2190.15 402.019C2193.11 402.597 2196.09 403.194 2199.11 403.935C2200.56 404.296 2201.95 404.459 2203.41 404.856C2207.57 405.977 2211.76 407.26 2215.99 408.705L2216.05 408.724C2220.31 410.187 2224.61 411.814 2228.93 413.603C2230.83 414.398 2232.74 415.356 2234.64 416.205C2236.39 416.982 2238.11 417.76 2239.88 418.591C2246.35 421.645 2252.86 424.952 2259.45 428.765C2265.83 432.434 2272.12 436.392 2278.36 440.603C2280.42 441.994 2282.44 443.584 2284.48 445.048C2288.6 447.958 2292.74 450.849 2296.79 453.994C2299.25 455.892 2301.63 457.97 2304.06 459.94C2307.63 462.867 2311.25 465.723 2314.75 468.795C2317.28 471.018 2319.72 473.421 2322.24 475.717C2325.53 478.771 2328.87 481.753 2332.1 484.933C2332.36 485.168 2332.61 485.385 2332.84 485.638C2333.6 486.361 2334.27 487.21 2335.03 487.933C2341.32 494.258 2347.45 500.837 2353.46 507.632C2354.42 508.698 2355.45 509.674 2356.39 510.758C2357.53 512.059 2358.58 513.451 2359.7 514.77C2362.97 518.619 2366.17 522.541 2369.35 526.517C2370.74 528.288 2372.24 529.951 2373.63 531.722C2374.52 532.878 2375.37 534.107 2376.24 535.282C2378.62 538.39 2380.92 541.553 2383.23 544.733C2384.77 546.884 2386.39 548.926 2387.93 551.095C2388.87 552.45 2389.75 553.86 2390.69 555.233C2392.57 557.98 2394.42 560.763 2396.26 563.546C2397.61 565.589 2399.02 567.576 2400.34 569.637C2401.55 571.534 2402.67 573.468 2403.83 575.365C2405.44 577.932 2407.01 580.498 2408.57 583.082C2409.49 584.654 2410.5 586.191 2411.42 587.763C2413.03 590.528 2414.53 593.365 2416.1 596.148C2417.4 598.48 2418.7 600.775 2419.97 603.106C2420.48 604.028 2420.98 604.895 2421.49 605.817C2423.98 610.515 2426.35 615.286 2428.7 620.057C2429.26 621.196 2429.87 622.317 2430.42 623.455C2430.51 623.636 2430.61 623.835 2430.69 624.015C2433.67 630.16 2436.51 636.359 2439.22 642.611C2439.43 643.136 2439.63 643.659 2439.87 644.184C2440.77 646.316 2441.6 648.467 2442.49 650.617C2444.04 654.358 2445.63 658.099 2447.1 661.876C2447.55 663.051 2447.93 664.226 2448.36 665.382C2449.45 668.292 2450.46 671.183 2451.49 674.093C2452.45 676.804 2453.49 679.496 2454.4 682.225C2454.94 683.797 2455.35 685.388 2455.86 686.96C2457 690.52 2458.07 694.098 2459.13 697.677C2459.8 699.954 2460.6 702.231 2461.21 704.526C2461.66 706.08 2461.95 707.634 2462.37 709.189C2463.6 713.833 2464.7 718.46 2465.76 723.104C2466.29 725.363 2466.96 727.604 2467.45 729.863C2468.01 732.574 2468.57 735.285 2469.07 737.995L2288.77 842.777C2287.79 837.807 2286.58 832.837 2285.44 827.867C2284.39 823.241 2283.27 818.633 2282.04 814.006C2281.03 810.157 2279.91 806.289 2278.79 802.44Z",
    fill: "url(#paint3_linear_71_514)"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g4093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4109",
    d: "M2079.14 533.546C2002.92 489.553 1933.2 495.079 1893.88 545.61C1867.62 517.75 1839.38 494.866 1810.87 478.413C1697.42 412.903 1603.77 459.614 1593.94 581.696C1529.92 565.137 1484.24 605.416 1484.02 684.074L1484 691.377C1483.72 786.647 1550.89 902.99 1633.71 950.803L2225.64 1292.55C2344.64 1361.26 2441.75 1305.91 2442.14 1169.17C2442.44 1059.17 2379.01 926 2288.77 842.775C2264.97 718.686 2179.85 591.7 2079.14 533.546Z",
    fill: "url(#paint4_linear_71_514)"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g4111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4127",
    d: "M1522.34 684.216V691.514C1522.22 773.007 1581.95 876.627 1652.95 917.567L2244.87 1259.27C2272.38 1275.26 2299.25 1283.71 2322.28 1283.71C2340.82 1283.71 2356.55 1277.95 2369.22 1267.21C2362.95 1269 2356.17 1269.88 2349.02 1269.88C2325.99 1269.88 2299.13 1261.45 2271.48 1245.45L1679.57 903.758C1608.68 862.819 1548.82 759.199 1549.07 677.706V670.408C1549.2 654.29 1551.51 631.26 1563.15 616.682C1527.96 618.992 1522.47 659.663 1522.34 684.216Z",
    fill: "url(#paint5_linear_71_514)"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g4129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4145",
    d: "M1549.06 670.423V677.717C1548.81 759.206 1608.67 862.838 1679.55 903.758L2271.47 1245.46C2299.11 1261.45 2325.97 1269.9 2349.01 1269.9C2356.16 1269.9 2362.93 1269.01 2369.23 1267.22C2391.21 1248.65 2403.62 1214.76 2403.75 1169.09C2404.01 1070.45 2346.07 947.764 2262.77 871.008L2253.44 862.453L2251.01 850.04C2229.13 735.538 2150.58 619.124 2059.89 566.808C2032.12 550.679 2005 542.246 1981.71 542.246C1974.42 542.246 1967.53 543.017 1961.13 544.805C1957.41 547.733 1954.08 551.327 1950.89 555.412L1923.38 590.722L1914.69 581.395L1896.65 604.555L1865.95 571.928C1842.4 546.98 1816.68 526.116 1791.61 511.67C1763.86 495.54 1736.86 487.107 1713.71 487.107C1706.17 487.107 1699.25 488.001 1692.98 489.667C1667.14 511.67 1660.49 550.679 1658.82 571.034L1655.25 616.442L1630.17 610.042L1628.51 630.257L1584.37 618.861C1577.98 617.213 1572.09 616.442 1566.59 616.442C1565.45 616.442 1564.29 616.442 1563.14 616.705C1551.5 631.274 1549.19 654.311 1549.06 670.423Z",
    fill: "url(#paint6_linear_71_514)"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g4147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4163",
    d: "M1960.97 549.459C1946.13 553.169 1933.71 561.363 1923.99 573.903L1896.49 609.205L1923.22 595.393L1950.74 560.075C1953.93 555.986 1957.26 552.396 1960.97 549.459Z",
    fill: "url(#paint7_linear_71_514)"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g4165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4181",
    d: "M1658.66 575.686C1660.33 555.349 1666.98 516.322 1692.82 494.322C1644.21 506.863 1634.1 563.407 1632.06 589.506L1628.36 634.927L1655.09 621.106L1658.66 575.686Z",
    fill: "url(#paint8_linear_71_514)"
  })))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "laptop2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "latopscreenback"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-188",
    d: "M475.191 964.804L998.406 1297.58C1015.44 1307.47 1050.99 1274.43 1050.99 1254.74V731.271C1050.99 709.964 1039.65 690.271 1021.23 679.578L480.652 365.725C463.091 355.525 420.514 373.458 420.514 393.765L441.084 905.564C441.084 929.977 454.078 952.55 475.191 964.804Z",
    fill: "url(#paint9_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-189",
    d: "M447.336 982.631L984.755 1294.66C1001.79 1304.55 1023.13 1292.26 1023.13 1272.56V749.098C1023.13 727.791 1011.8 708.111 993.374 697.405L452.796 383.552C435.236 373.352 413.229 386.019 413.229 406.325V923.391C413.229 947.804 426.223 970.377 447.336 982.631Z",
    fill: "url(#paint10_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "laptopscreenfront",
    d: "M999.94 1279.45C999.251 1279.45 998.583 1279.25 997.881 1278.84L460.464 966.829C445.991 958.429 437 942.802 437 926.069V409.003C437 405.59 439.985 404.003 442.003 404.003C442.824 404.003 443.624 404.23 444.452 404.71L985.035 718.576C996.823 725.416 1004.15 738.136 1004.15 751.776V1275.24C1004.15 1276.01 1004.03 1277.16 1002.95 1278.19C1002.13 1278.97 1001 1279.45 999.94 1279.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    className: "bottompanel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "mouse",
    d: "M386.451 1261.31C386.759 1261.13 387.138 1261.13 387.447 1261.31L515.82 1334.85C516.492 1335.23 516.49 1336.2 515.816 1336.58L420.373 1390.7C420.064 1390.87 419.685 1390.87 419.378 1390.69L292.497 1317.14C291.832 1316.76 291.833 1315.8 292.5 1315.41L386.451 1261.31Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bottom1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-192",
    d: "M572.917 1577.59C565.893 1577.59 558.872 1575.76 552.587 1572.12L12.8157 1259.19C5.5184 1254.96 0.191738 1237.99 0.00507133 1224.08C-0.109595 1215.53 1.71307 1208.15 6.20506 1205.57C1.81307 1213.52 4.00907 1224.32 12.8157 1229.43L552.587 1542.36C558.872 1546 565.893 1547.83 572.916 1547.83C579.86 1547.83 586.806 1546.04 593.042 1542.48L982.556 1320.68C986.759 1318.28 989.419 1314.53 990.531 1310.43C990.959 1313.96 991.159 1317.72 991.128 1321.47C991.022 1334.43 988.162 1347.24 982.556 1350.44L593.042 1572.24C586.806 1575.8 579.861 1577.59 572.917 1577.59Z",
    fill: "url(#paint11_linear_71_514)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-193",
    d: "M573.529 1547.45C566.506 1547.45 559.485 1545.63 553.2 1541.99L13.4289 1229.05C4.62222 1223.95 2.42621 1213.15 6.8182 1205.2C8.30086 1202.51 10.5342 1200.15 13.5182 1198.44L404.812 975.627C410.204 972.547 416.212 971 422.216 971C428.292 971 434.364 972.574 439.801 975.734L983.255 1290.8C990.422 1294.95 993.047 1303.03 991.144 1310.05C990.032 1314.16 987.372 1317.91 983.169 1320.31L593.656 1542.11C587.42 1545.67 580.473 1547.45 573.529 1547.45ZM387.928 1263.55C386.617 1263.55 385.305 1263.88 384.128 1264.55L298.682 1313.2C296.1 1314.68 296.09 1318.4 298.663 1319.89L416.531 1388.23C417.904 1389.01 419.436 1389.41 420.971 1389.41C422.487 1389.41 424.003 1389.03 425.365 1388.25L510.421 1339.81C512.909 1338.4 512.92 1334.81 510.44 1333.37L391.768 1264.57C390.581 1263.88 389.255 1263.55 387.928 1263.55Z",
    fill: "url(#paint12_linear_71_514)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "keys"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-194",
    d: "M429.64 1050.89L407.504 1038.07C407.021 1037.77 406.709 1033.68 407.195 1033.4L423.555 1027.67C423.999 1027.41 424.545 1027.41 424.989 1027.67L447.624 1036.99C448.089 1037.25 447.739 1041.53 447.272 1041.8L431.299 1050.89C430.784 1051.19 430.152 1051.19 429.64 1050.89Z",
    fill: "url(#paint13_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-195",
    d: "M429.64 1047.07L407.504 1034.23C407.021 1033.95 407.022 1033.25 407.508 1032.97L423.554 1023.84C423.998 1023.59 424.545 1023.59 424.989 1023.84L447.276 1036.76C447.741 1037.04 447.738 1037.71 447.271 1037.97L431.298 1047.07C430.784 1047.36 430.152 1047.36 429.64 1047.07Z",
    fill: "url(#paint14_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-196",
    d: "M465.56 1071.75L443.425 1058.92C442.941 1058.64 442.631 1054.53 443.116 1054.27L459.476 1048.52C459.92 1048.27 460.467 1048.27 460.909 1048.53L483.544 1057.84C484.01 1058.11 483.66 1062.39 483.193 1062.65L467.22 1071.76C466.705 1072.05 466.073 1072.05 465.56 1071.75Z",
    fill: "url(#paint15_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-197",
    d: "M465.56 1067.92L443.425 1055.09C442.941 1054.81 442.944 1054.11 443.429 1053.83L459.476 1044.69C459.92 1044.44 460.466 1044.44 460.909 1044.71L483.196 1057.63C483.662 1057.89 483.66 1058.56 483.193 1058.83L467.22 1067.93C466.705 1068.23 466.073 1068.21 465.56 1067.92Z",
    fill: "url(#paint16_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-198",
    d: "M501.481 1092.61L479.346 1079.77C478.862 1079.49 478.551 1075.4 479.037 1075.12L495.395 1069.39C495.841 1069.13 496.387 1069.13 496.83 1069.39L519.465 1078.69C519.931 1078.97 519.581 1083.25 519.114 1083.52L503.139 1092.61C502.626 1092.91 501.993 1092.91 501.481 1092.61Z",
    fill: "url(#paint17_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-199",
    d: "M501.481 1088.77L479.346 1075.95C478.862 1075.67 478.865 1074.97 479.349 1074.69L495.395 1065.55C495.841 1065.29 496.387 1065.31 496.83 1065.56L519.117 1078.48C519.582 1078.75 519.581 1079.43 519.114 1079.69L503.139 1088.79C502.626 1089.08 501.993 1089.08 501.481 1088.77Z",
    fill: "url(#paint18_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-200",
    d: "M537.403 1113.47L515.267 1100.63C514.784 1100.35 514.473 1096.25 514.959 1095.97L531.317 1090.24C531.763 1089.99 532.309 1089.99 532.752 1090.24L555.387 1099.56C555.852 1099.83 555.503 1104.11 555.035 1104.37L539.061 1113.47C538.547 1113.76 537.915 1113.76 537.403 1113.47Z",
    fill: "url(#paint19_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-201",
    d: "M537.403 1109.64L515.267 1096.8C514.784 1096.52 514.787 1095.83 515.271 1095.55L531.317 1086.41C531.763 1086.16 532.309 1086.16 532.752 1086.41L555.039 1099.33C555.504 1099.6 555.503 1100.28 555.035 1100.55L539.061 1109.64C538.547 1109.93 537.915 1109.93 537.403 1109.64Z",
    fill: "url(#paint20_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-202",
    d: "M573.323 1134.32L551.188 1121.49C550.705 1121.21 550.395 1117.11 550.879 1116.83L567.239 1111.09C567.683 1110.84 568.229 1110.84 568.673 1111.11L591.308 1120.41C591.773 1120.68 591.424 1124.96 590.956 1125.23L574.983 1134.33C574.468 1134.63 573.836 1134.61 573.323 1134.32Z",
    fill: "url(#paint21_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-203",
    d: "M573.322 1130.49L551.188 1117.67C550.705 1117.39 550.708 1116.68 551.192 1116.4L567.238 1107.27C567.682 1107.01 568.229 1107.01 568.673 1107.27L590.96 1120.19C591.425 1120.47 591.424 1121.13 590.956 1121.4L574.982 1130.49C574.468 1130.79 573.836 1130.79 573.322 1130.49Z",
    fill: "url(#paint22_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-204",
    d: "M609.243 1155.17L587.109 1142.35C586.626 1142.07 586.316 1137.97 586.8 1137.69L603.158 1131.96C603.603 1131.71 604.15 1131.71 604.594 1131.96L627.229 1141.27C627.694 1141.55 627.343 1145.83 626.877 1146.09L610.903 1155.19C610.389 1155.48 609.757 1155.48 609.243 1155.17Z",
    fill: "url(#paint23_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-205",
    d: "M609.244 1151.35L587.109 1138.52C586.626 1138.24 586.628 1137.55 587.113 1137.27L603.158 1128.12C603.604 1127.87 604.15 1127.88 604.594 1128.13L626.88 1141.05C627.346 1141.32 627.344 1141.99 626.877 1142.27L610.904 1151.36C610.389 1151.65 609.757 1151.65 609.244 1151.35Z",
    fill: "url(#paint24_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 89"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-206",
    d: "M645.165 1176.04L623.03 1163.2C622.546 1162.92 622.237 1158.83 622.721 1158.55L639.079 1152.81C639.525 1152.56 640.071 1152.56 640.514 1152.81L663.149 1162.13C663.615 1162.4 663.265 1166.68 662.797 1166.95L646.823 1176.04C646.31 1176.33 645.678 1176.33 645.165 1176.04Z",
    fill: "url(#paint25_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-207",
    d: "M645.165 1172.21L623.03 1159.37C622.546 1159.09 622.549 1158.4 623.034 1158.12L639.08 1148.99C639.525 1148.73 640.072 1148.73 640.514 1148.99L662.801 1161.91C663.266 1162.17 663.265 1162.85 662.797 1163.12L646.824 1172.21C646.31 1172.51 645.678 1172.51 645.165 1172.21Z",
    fill: "url(#paint26_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-208",
    d: "M681.086 1196.89L658.952 1184.07C658.468 1183.79 658.157 1179.68 658.642 1179.4L675.001 1173.67C675.446 1173.41 675.993 1173.41 676.435 1173.67L699.07 1182.99C699.537 1183.25 699.186 1187.53 698.718 1187.8L682.745 1196.89C682.232 1197.2 681.598 1197.19 681.086 1196.89Z",
    fill: "url(#paint27_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-209",
    d: "M681.086 1193.07L658.952 1180.23C658.468 1179.95 658.47 1179.25 658.954 1178.97L675.001 1169.84C675.446 1169.59 675.993 1169.59 676.435 1169.84L698.722 1182.76C699.187 1183.04 699.186 1183.71 698.718 1183.97L682.745 1193.07C682.231 1193.36 681.598 1193.36 681.086 1193.07Z",
    fill: "url(#paint28_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-210",
    d: "M717.007 1217.75L694.872 1204.92C694.389 1204.64 694.078 1200.53 694.562 1200.27L710.922 1194.53C711.367 1194.27 711.913 1194.27 712.357 1194.53L734.991 1203.84C735.457 1204.11 735.106 1208.4 734.639 1208.67L718.666 1217.76C718.151 1218.05 717.519 1218.05 717.007 1217.75Z",
    fill: "url(#paint29_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-211",
    d: "M717.007 1213.92L694.871 1201.09C694.388 1200.81 694.389 1200.11 694.875 1199.84L710.921 1190.69C711.367 1190.44 711.912 1190.44 712.356 1190.71L734.643 1203.63C735.108 1203.89 735.105 1204.56 734.639 1204.83L718.665 1213.93C718.151 1214.23 717.519 1214.23 717.007 1213.92Z",
    fill: "url(#paint30_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-214",
    d: "M788.849 1259.47L766.714 1246.64C766.231 1246.36 765.919 1242.25 766.405 1241.97L782.765 1236.24C783.209 1235.99 783.755 1235.99 784.199 1236.24L806.833 1245.56C807.299 1245.83 806.949 1250.11 806.482 1250.37L790.509 1259.47C789.994 1259.76 789.362 1259.76 788.849 1259.47Z",
    fill: "url(#paint31_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-215",
    d: "M788.848 1255.64L766.714 1242.8C766.231 1242.52 766.232 1241.83 766.716 1241.55L782.764 1232.41C783.208 1232.16 783.755 1232.16 784.199 1232.41L806.484 1245.33C806.951 1245.6 806.948 1246.28 806.482 1246.55L790.508 1255.64C789.994 1255.93 789.362 1255.93 788.848 1255.64Z",
    fill: "url(#paint32_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-216",
    d: "M824.77 1280.32L802.634 1267.49C802.151 1267.21 801.841 1263.11 802.326 1262.84L818.684 1257.09C819.13 1256.84 819.677 1256.84 820.121 1257.11L842.754 1266.41C843.219 1266.68 842.87 1270.96 842.403 1271.24L826.43 1280.33C825.915 1280.63 825.283 1280.63 824.77 1280.32Z",
    fill: "url(#paint33_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-217",
    d: "M824.77 1276.49L802.634 1263.67C802.151 1263.39 802.154 1262.68 802.638 1262.41L818.685 1253.27C819.13 1253.01 819.677 1253.01 820.121 1253.28L842.406 1266.2C842.872 1266.47 842.87 1267.13 842.403 1267.4L826.43 1276.49C825.915 1276.8 825.283 1276.79 824.77 1276.49Z",
    fill: "url(#paint34_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-218",
    d: "M860.691 1301.19L838.555 1288.35C838.072 1288.07 837.762 1283.97 838.246 1283.69L854.606 1277.96C855.05 1277.71 855.598 1277.71 856.04 1277.96L878.675 1287.27C879.14 1287.55 878.791 1291.83 878.323 1292.09L862.35 1301.19C861.835 1301.48 861.203 1301.48 860.691 1301.19Z",
    fill: "url(#paint35_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-219",
    d: "M860.691 1297.35L838.555 1284.52C838.073 1284.24 838.074 1283.55 838.559 1283.27L854.606 1274.13C855.05 1273.88 855.598 1273.88 856.041 1274.13L878.327 1287.05C878.793 1287.32 878.791 1288 878.323 1288.27L862.35 1297.36C861.835 1297.65 861.203 1297.65 860.691 1297.35Z",
    fill: "url(#paint36_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-220",
    d: "M396.991 1069.84L374.856 1057C374.373 1056.72 374.063 1052.63 374.547 1052.35L390.905 1046.61C391.351 1046.36 391.897 1046.36 392.341 1046.61L414.976 1055.92C415.441 1056.2 415.091 1060.48 414.624 1060.75L398.651 1069.84C398.136 1070.13 397.504 1070.13 396.991 1069.84Z",
    fill: "url(#paint37_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-221",
    d: "M396.991 1066.01L374.856 1053.17C374.373 1052.89 374.375 1052.2 374.86 1051.92L390.905 1042.79C391.351 1042.53 391.897 1042.53 392.341 1042.79L414.627 1055.71C415.093 1055.97 415.091 1056.65 414.624 1056.92L398.651 1066.01C398.136 1066.31 397.504 1066.31 396.991 1066.01Z",
    fill: "url(#paint38_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-222",
    d: "M432.912 1090.69L410.778 1077.87C410.294 1077.59 409.983 1073.48 410.468 1073.2L426.827 1067.47C427.272 1067.21 427.819 1067.21 428.263 1067.47L450.896 1076.79C451.363 1077.05 451.012 1081.33 450.544 1081.6L434.571 1090.69C434.058 1090.99 433.426 1090.99 432.912 1090.69Z",
    fill: "url(#paint39_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-223",
    d: "M432.912 1086.87L410.778 1074.03C410.294 1073.75 410.296 1073.05 410.782 1072.77L426.827 1063.64C427.272 1063.39 427.819 1063.39 428.263 1063.64L450.548 1076.56C451.015 1076.83 451.012 1077.51 450.544 1077.77L434.571 1086.87C434.057 1087.16 433.425 1087.16 432.912 1086.87Z",
    fill: "url(#paint40_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-224",
    d: "M468.833 1111.55L446.699 1098.72C446.215 1098.44 445.904 1094.33 446.389 1094.07L462.748 1088.32C463.193 1088.07 463.74 1088.07 464.183 1088.33L486.817 1097.64C487.283 1097.91 486.933 1102.19 486.465 1102.47L470.492 1111.56C469.979 1111.85 469.347 1111.85 468.833 1111.55Z",
    fill: "url(#paint41_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-225",
    d: "M468.833 1107.72L446.699 1094.89C446.215 1094.61 446.217 1093.91 446.701 1093.64L462.748 1084.49C463.193 1084.24 463.74 1084.24 464.183 1084.51L486.469 1097.43C486.934 1097.69 486.933 1098.36 486.465 1098.63L470.492 1107.72C469.978 1108.03 469.347 1108.01 468.833 1107.72Z",
    fill: "url(#paint42_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-226",
    d: "M504.755 1132.41L482.619 1119.57C482.136 1119.29 481.825 1115.2 482.309 1114.92L498.669 1109.19C499.115 1108.93 499.66 1108.93 500.104 1109.19L522.739 1118.49C523.204 1118.77 522.853 1123.05 522.386 1123.32L506.413 1132.41C505.899 1132.71 505.267 1132.71 504.755 1132.41Z",
    fill: "url(#paint43_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-227",
    d: "M504.755 1128.57L482.619 1115.75C482.136 1115.47 482.137 1114.77 482.623 1114.49L498.669 1105.36C499.115 1105.11 499.66 1105.11 500.104 1105.36L522.391 1118.28C522.856 1118.55 522.853 1119.23 522.387 1119.49L506.413 1128.59C505.899 1128.88 505.267 1128.88 504.755 1128.57Z",
    fill: "url(#paint44_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-228",
    d: "M540.676 1153.27L518.54 1140.44C518.057 1140.16 517.745 1136.05 518.231 1135.77L534.591 1130.04C535.035 1129.79 535.581 1129.79 536.025 1130.04L558.66 1139.36C559.125 1139.63 558.775 1143.91 558.308 1144.17L542.335 1153.27C541.82 1153.56 541.188 1153.56 540.676 1153.27Z",
    fill: "url(#paint45_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-229",
    d: "M540.676 1149.44L518.54 1136.6C518.057 1136.32 518.058 1135.63 518.544 1135.35L534.59 1126.21C535.034 1125.96 535.581 1125.96 536.025 1126.21L558.312 1139.13C558.777 1139.4 558.774 1140.08 558.308 1140.35L542.334 1149.44C541.82 1149.73 541.188 1149.73 540.676 1149.44Z",
    fill: "url(#paint46_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 87"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-230",
    d: "M576.596 1174.12L554.461 1161.29C553.978 1161.01 553.666 1156.91 554.152 1156.63L570.512 1150.89C570.956 1150.64 571.502 1150.64 571.946 1150.91L594.58 1160.21C595.045 1160.48 594.696 1164.76 594.229 1165.03L578.256 1174.13C577.741 1174.43 577.109 1174.43 576.596 1174.12Z",
    fill: "url(#paint47_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-231",
    d: "M576.595 1170.29L554.461 1157.47C553.978 1157.19 553.979 1156.48 554.463 1156.2L570.511 1147.07C570.955 1146.81 571.502 1146.81 571.946 1147.07L594.233 1159.99C594.698 1160.27 594.695 1160.93 594.229 1161.2L578.255 1170.29C577.741 1170.6 577.109 1170.59 576.595 1170.29Z",
    fill: "url(#paint48_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-87"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-232",
    d: "M612.517 1194.99L590.381 1182.15C589.899 1181.87 589.588 1177.77 590.072 1177.49L606.432 1171.76C606.877 1171.49 607.424 1171.51 607.867 1171.76L630.501 1181.07C630.967 1181.33 630.617 1185.63 630.151 1185.89L614.177 1194.99C613.661 1195.28 613.031 1195.28 612.517 1194.99Z",
    fill: "url(#paint49_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-89"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-233",
    d: "M612.517 1191.15L590.381 1178.32C589.898 1178.04 589.901 1177.35 590.385 1177.07L606.432 1167.92C606.877 1167.67 607.424 1167.67 607.866 1167.93L630.153 1180.85C630.618 1181.12 630.617 1181.8 630.15 1182.07L614.177 1191.16C613.661 1191.45 613.03 1191.45 612.517 1191.15Z",
    fill: "url(#paint50_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-234",
    d: "M648.438 1215.84L626.302 1203C625.82 1202.72 625.509 1198.63 625.993 1198.35L642.353 1192.61C642.797 1192.36 643.345 1192.36 643.788 1192.61L666.422 1201.93C666.887 1202.2 666.538 1206.48 666.07 1206.75L650.097 1215.84C649.582 1216.13 648.95 1216.13 648.438 1215.84Z",
    fill: "url(#paint51_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-235",
    d: "M648.438 1212.01L626.302 1199.17C625.82 1198.89 625.821 1198.2 626.306 1197.92L642.353 1188.79C642.797 1188.53 643.345 1188.53 643.788 1188.79L666.074 1201.71C666.54 1201.97 666.538 1202.65 666.07 1202.92L650.097 1212.01C649.582 1212.31 648.95 1212.31 648.438 1212.01Z",
    fill: "url(#paint52_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-236",
    d: "M684.359 1236.69L662.223 1223.87C661.74 1223.59 661.43 1219.48 661.914 1219.2L678.274 1213.47C678.718 1213.21 679.264 1213.21 679.708 1213.48L702.343 1222.79C702.808 1223.05 702.459 1227.33 701.991 1227.6L686.018 1236.71C685.503 1237 684.871 1236.99 684.359 1236.69Z",
    fill: "url(#paint53_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-237",
    d: "M684.359 1232.87L662.223 1220.04C661.741 1219.76 661.742 1219.05 662.227 1218.77L678.274 1209.64C678.718 1209.39 679.265 1209.39 679.709 1209.64L701.995 1222.56C702.461 1222.84 702.459 1223.51 701.991 1223.77L686.018 1232.87C685.503 1233.16 684.871 1233.16 684.359 1232.87Z",
    fill: "url(#paint54_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-238",
    d: "M720.28 1257.55L698.145 1244.72C697.661 1244.44 697.35 1240.33 697.836 1240.07L714.194 1234.32C714.64 1234.07 715.186 1234.08 715.629 1234.33L738.265 1243.64C738.73 1243.91 738.379 1248.2 737.913 1248.47L721.94 1257.56C721.425 1257.85 720.793 1257.85 720.28 1257.55Z",
    fill: "url(#paint55_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-239",
    d: "M720.279 1253.72L698.145 1240.89C697.661 1240.61 697.663 1239.91 698.149 1239.64L714.194 1230.49C714.639 1230.24 715.186 1230.24 715.629 1230.51L737.915 1243.43C738.382 1243.69 738.379 1244.36 737.913 1244.63L721.939 1253.73C721.425 1254.03 720.793 1254.03 720.279 1253.72Z",
    fill: "url(#paint56_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 132_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-99_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-100_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-238_2",
    d: "M750.688 1238.24L728.553 1225.42C728.069 1225.14 727.758 1221.03 728.244 1220.76L744.602 1215.02C745.048 1214.76 745.594 1214.78 746.037 1215.03L768.673 1224.34C769.138 1224.6 768.788 1228.9 768.321 1229.16L752.348 1238.26C751.833 1238.55 751.201 1238.55 750.688 1238.24Z",
    fill: "url(#paint57_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-101_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-102_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-239_2",
    d: "M750.688 1234.42L728.553 1221.59C728.069 1221.31 728.072 1220.6 728.557 1220.34L744.602 1211.19C745.048 1210.94 745.594 1210.94 746.037 1211.2L768.323 1224.12C768.79 1224.39 768.787 1225.06 768.321 1225.32L752.348 1234.43C751.833 1234.72 751.201 1234.72 750.688 1234.42Z",
    fill: "url(#paint58_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-240",
    d: "M756.2 1278.41L734.066 1265.57C733.582 1265.29 733.271 1261.2 733.756 1260.92L750.115 1255.19C750.56 1254.93 751.107 1254.93 751.55 1255.19L774.184 1264.49C774.651 1264.77 774.3 1269.05 773.834 1269.32L757.859 1278.41C757.346 1278.71 756.714 1278.71 756.2 1278.41Z",
    fill: "url(#paint59_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-241",
    d: "M756.2 1274.59L734.066 1261.75C733.582 1261.47 733.584 1260.77 734.07 1260.49L750.115 1251.36C750.56 1251.11 751.107 1251.11 751.55 1251.36L773.836 1264.28C774.302 1264.55 774.3 1265.23 773.834 1265.49L757.859 1274.59C757.346 1274.88 756.714 1274.88 756.2 1274.59Z",
    fill: "url(#paint60_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-242",
    d: "M792.121 1299.27L769.987 1286.44C769.503 1286.16 769.192 1282.05 769.677 1281.77L786.036 1276.04C786.481 1275.79 787.028 1275.79 787.471 1276.04L810.105 1285.36C810.571 1285.63 810.221 1289.91 809.753 1290.17L793.78 1299.27C793.265 1299.56 792.633 1299.56 792.121 1299.27Z",
    fill: "url(#paint61_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-243",
    d: "M792.121 1295.44L769.987 1282.6C769.503 1282.32 769.505 1281.63 769.989 1281.35L786.036 1272.21C786.481 1271.96 787.028 1271.96 787.471 1272.21L809.757 1285.13C810.223 1285.41 810.221 1286.08 809.753 1286.35L793.78 1295.44C793.265 1295.73 792.633 1295.73 792.121 1295.44Z",
    fill: "url(#paint62_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-244",
    d: "M828.042 1320.12L805.908 1307.29C805.425 1307.01 805.114 1302.91 805.598 1302.64L821.958 1296.89C822.404 1296.64 822.95 1296.64 823.393 1296.91L846.028 1306.21C846.493 1306.48 846.144 1310.77 845.676 1311.04L829.702 1320.13C829.188 1320.43 828.556 1320.43 828.042 1320.12Z",
    fill: "url(#paint63_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-245",
    d: "M828.042 1316.29L805.907 1303.47C805.425 1303.19 805.427 1302.48 805.911 1302.21L821.958 1293.07C822.403 1292.81 822.95 1292.81 823.393 1293.08L845.679 1306C846.145 1306.27 846.143 1306.93 845.675 1307.2L829.702 1316.31C829.187 1316.6 828.555 1316.6 828.042 1316.29Z",
    fill: "url(#paint64_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-246",
    d: "M364.343 1088.77L342.208 1075.95C341.724 1075.67 341.414 1071.56 341.899 1071.29L358.258 1065.55C358.703 1065.29 359.25 1065.31 359.694 1065.56L382.327 1074.87C382.794 1075.13 382.443 1079.43 381.976 1079.69L366.003 1088.79C365.488 1089.08 364.856 1089.08 364.343 1088.77Z",
    fill: "url(#paint65_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-247",
    d: "M364.343 1084.95L342.208 1072.12C341.724 1071.84 341.727 1071.13 342.212 1070.87L358.257 1061.72C358.703 1061.47 359.249 1061.47 359.693 1061.73L381.979 1074.65C382.445 1074.92 382.443 1075.59 381.976 1075.85L366.003 1084.96C365.488 1085.25 364.856 1085.25 364.343 1084.95Z",
    fill: "url(#paint66_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-248",
    d: "M400.264 1109.64L378.128 1096.8C377.645 1096.52 377.335 1092.43 377.82 1092.15L394.179 1086.41C394.624 1086.16 395.171 1086.16 395.613 1086.41L418.248 1095.72C418.713 1096 418.364 1100.28 417.897 1100.55L401.923 1109.64C401.408 1109.93 400.777 1109.93 400.264 1109.64Z",
    fill: "url(#paint67_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-249",
    d: "M400.264 1105.81L378.128 1092.97C377.645 1092.69 377.648 1092 378.132 1091.72L394.179 1082.59C394.624 1082.33 395.171 1082.33 395.613 1082.59L417.9 1095.51C418.365 1095.77 418.364 1096.45 417.897 1096.72L401.923 1105.81C401.408 1106.11 400.777 1106.11 400.264 1105.81Z",
    fill: "url(#paint68_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-250",
    d: "M436.185 1130.49L414.049 1117.67C413.567 1117.39 413.256 1113.28 413.74 1113L430.1 1107.27C430.544 1107.01 431.092 1107.01 431.535 1107.27L454.169 1116.59C454.634 1116.85 454.285 1121.13 453.817 1121.4L437.844 1130.49C437.329 1130.79 436.697 1130.79 436.185 1130.49Z",
    fill: "url(#paint69_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-251",
    d: "M436.185 1126.67L414.049 1113.83C413.566 1113.55 413.569 1112.85 414.053 1112.57L430.1 1103.44C430.544 1103.19 431.092 1103.19 431.534 1103.44L453.821 1116.36C454.286 1116.64 454.285 1117.31 453.817 1117.57L437.844 1126.67C437.329 1126.96 436.697 1126.96 436.185 1126.67Z",
    fill: "url(#paint70_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-252",
    d: "M472.105 1151.35L449.97 1138.52C449.488 1138.24 449.177 1134.13 449.661 1133.87L466.021 1128.12C466.465 1127.87 467.013 1127.88 467.455 1128.13L490.09 1137.44C490.555 1137.71 490.206 1141.99 489.738 1142.27L473.765 1151.36C473.25 1151.65 472.618 1151.65 472.105 1151.35Z",
    fill: "url(#paint71_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-253",
    d: "M472.105 1147.52L449.97 1134.69C449.488 1134.41 449.489 1133.71 449.974 1133.44L466.021 1124.29C466.465 1124.04 467.013 1124.04 467.456 1124.31L489.742 1137.23C490.208 1137.49 490.206 1138.16 489.738 1138.43L473.765 1147.53C473.25 1147.83 472.618 1147.83 472.105 1147.52Z",
    fill: "url(#paint72_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 80"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-254",
    d: "M508.026 1172.21L485.891 1159.37C485.407 1159.09 485.098 1155 485.582 1154.72L501.941 1148.99C502.386 1148.73 502.933 1148.73 503.375 1148.99L526.011 1158.29C526.477 1158.57 526.126 1162.85 525.659 1163.12L509.686 1172.21C509.171 1172.51 508.539 1172.51 508.026 1172.21Z",
    fill: "url(#paint73_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-255",
    d: "M508.026 1168.37L485.892 1155.55C485.408 1155.27 485.41 1154.57 485.896 1154.29L501.941 1145.16C502.386 1144.89 502.933 1144.91 503.376 1145.16L525.662 1158.08C526.129 1158.35 526.126 1159.03 525.66 1159.29L509.686 1168.39C509.172 1168.68 508.54 1168.68 508.026 1168.37Z",
    fill: "url(#paint74_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-256",
    d: "M543.948 1193.07L521.813 1180.23C521.329 1179.95 521.018 1175.85 521.504 1175.57L537.862 1169.84C538.308 1169.59 538.854 1169.59 539.297 1169.84L561.931 1179.16C562.398 1179.43 562.047 1183.71 561.581 1183.97L545.606 1193.07C545.093 1193.36 544.46 1193.36 543.948 1193.07Z",
    fill: "url(#paint75_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-257",
    d: "M543.947 1189.24L521.813 1176.4C521.329 1176.12 521.331 1175.43 521.817 1175.15L537.862 1166.01C538.307 1165.76 538.854 1165.76 539.297 1166.01L561.583 1178.93C562.049 1179.21 562.047 1179.88 561.581 1180.15L545.606 1189.24C545.093 1189.53 544.459 1189.53 543.947 1189.24Z",
    fill: "url(#paint76_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-258",
    d: "M579.869 1213.92L557.735 1201.09C557.251 1200.81 556.94 1196.71 557.425 1196.44L573.784 1190.69C574.229 1190.44 574.776 1190.44 575.219 1190.71L597.853 1200.01C598.32 1200.28 597.969 1204.56 597.501 1204.83L581.528 1213.93C581.015 1214.23 580.381 1214.23 579.869 1213.92Z",
    fill: "url(#paint77_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-259",
    d: "M579.869 1210.09L557.735 1197.27C557.251 1196.99 557.253 1196.28 557.737 1196L573.784 1186.87C574.229 1186.61 574.776 1186.61 575.219 1186.88L597.505 1199.8C597.971 1200.07 597.969 1200.73 597.501 1201L581.528 1210.11C581.015 1210.39 580.381 1210.39 579.869 1210.09Z",
    fill: "url(#paint78_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-260",
    d: "M615.79 1234.79L593.654 1221.95C593.172 1221.67 592.861 1217.57 593.346 1217.29L609.705 1211.56C610.15 1211.31 610.696 1211.31 611.14 1211.56L633.774 1220.87C634.24 1221.15 633.89 1225.43 633.422 1225.69L617.449 1234.79C616.934 1235.08 616.302 1235.08 615.79 1234.79Z",
    fill: "url(#paint79_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-261",
    d: "M615.79 1230.95L593.654 1218.12C593.171 1217.84 593.173 1217.15 593.658 1216.87L609.705 1207.72C610.15 1207.47 610.695 1207.48 611.139 1207.73L633.426 1220.65C633.891 1220.92 633.89 1221.6 633.422 1221.87L617.449 1230.96C616.934 1231.25 616.302 1231.25 615.79 1230.95Z",
    fill: "url(#paint80_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-262",
    d: "M651.71 1255.64L629.576 1242.8C629.093 1242.52 628.782 1238.43 629.266 1238.15L645.626 1232.41C646.07 1232.16 646.617 1232.16 647.061 1232.41L669.696 1241.73C670.161 1242 669.81 1246.28 669.344 1246.55L653.37 1255.64C652.856 1255.93 652.224 1255.93 651.71 1255.64Z",
    fill: "url(#paint81_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-263",
    d: "M651.71 1251.81L629.576 1238.97C629.093 1238.69 629.094 1238 629.58 1237.72L645.626 1228.59C646.07 1228.33 646.617 1228.33 647.061 1228.59L669.348 1241.51C669.813 1241.77 669.81 1242.45 669.344 1242.72L653.37 1251.81C652.856 1252.11 652.224 1252.11 651.71 1251.81Z",
    fill: "url(#paint82_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-264",
    d: "M687.631 1276.49L665.497 1263.67C665.014 1263.39 664.703 1259.28 665.187 1259L681.546 1253.27C681.991 1253.01 682.538 1253.01 682.982 1253.28L705.615 1262.59C706.082 1262.85 705.731 1267.13 705.264 1267.4L689.291 1276.49C688.776 1276.8 688.145 1276.79 687.631 1276.49Z",
    fill: "url(#paint83_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-265",
    d: "M687.632 1272.67L665.497 1259.84C665.014 1259.56 665.016 1258.85 665.5 1258.57L681.546 1249.44C681.992 1249.19 682.538 1249.19 682.982 1249.44L705.268 1262.36C705.734 1262.64 705.732 1263.31 705.265 1263.57L689.292 1272.67C688.777 1272.96 688.145 1272.96 687.632 1272.67Z",
    fill: "url(#paint84_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-266",
    d: "M723.553 1297.35L701.418 1284.52C700.934 1284.24 700.624 1280.15 701.109 1279.87L717.468 1274.13C717.913 1273.88 718.46 1273.88 718.904 1274.13L741.537 1283.44C742.004 1283.71 741.653 1288 741.185 1288.27L725.212 1297.36C724.698 1297.65 724.066 1297.65 723.553 1297.35Z",
    fill: "url(#paint85_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-267",
    d: "M723.553 1293.52L701.418 1280.69C700.934 1280.41 700.937 1279.71 701.421 1279.44L717.468 1270.29C717.913 1270.04 718.46 1270.04 718.904 1270.31L741.189 1283.23C741.654 1283.49 741.653 1284.16 741.185 1284.44L725.212 1293.53C724.698 1293.83 724.066 1293.83 723.553 1293.52Z",
    fill: "url(#paint86_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-268",
    d: "M759.473 1318.21L737.337 1305.37C736.855 1305.09 736.544 1301 737.028 1300.72L753.388 1294.99C753.833 1294.73 754.379 1294.73 754.823 1294.99L777.457 1304.29C777.923 1304.57 777.572 1308.85 777.105 1309.12L761.132 1318.21C760.617 1318.51 759.987 1318.51 759.473 1318.21Z",
    fill: "url(#paint87_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-269",
    d: "M759.474 1314.39L737.338 1301.55C736.855 1301.27 736.856 1300.57 737.342 1300.29L753.388 1291.16C753.833 1290.91 754.379 1290.91 754.823 1291.16L777.109 1304.08C777.575 1304.35 777.572 1305.03 777.105 1305.29L761.132 1314.39C760.617 1314.68 759.987 1314.68 759.474 1314.39Z",
    fill: "url(#paint88_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-159_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-160_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-268_2",
    d: "M794.688 1337.24L772.552 1324.4C772.07 1324.12 771.759 1320.03 772.243 1319.75L788.603 1314.02C789.048 1313.76 789.594 1313.76 790.038 1314.02L812.672 1323.32C813.137 1323.6 812.787 1327.88 812.32 1328.15L796.347 1337.24C795.832 1337.54 795.201 1337.54 794.688 1337.24Z",
    fill: "url(#paint89_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-161_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-162_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-269_2",
    d: "M794.688 1333.42L772.552 1320.58C772.07 1320.3 772.071 1319.6 772.556 1319.32L788.603 1310.19C789.048 1309.94 789.594 1309.94 790.038 1310.19L812.324 1323.11C812.79 1323.38 812.787 1324.06 812.32 1324.32L796.347 1333.42C795.832 1333.71 795.202 1333.71 794.688 1333.42Z",
    fill: "url(#paint90_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-272",
    d: "M331.695 1107.72L309.56 1094.89C309.076 1094.61 308.767 1090.51 309.251 1090.23L325.61 1084.49C326.055 1084.24 326.602 1084.24 327.046 1084.51L349.679 1093.81C350.146 1094.08 349.795 1098.36 349.327 1098.63L333.354 1107.72C332.84 1108.03 332.208 1108.01 331.695 1107.72Z",
    fill: "url(#paint91_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-273",
    d: "M331.694 1103.89L309.56 1091.07C309.076 1090.79 309.079 1090.08 309.563 1089.8L325.609 1080.67C326.055 1080.41 326.601 1080.41 327.045 1080.67L349.33 1093.59C349.796 1093.87 349.794 1094.53 349.326 1094.8L333.353 1103.89C332.84 1104.19 332.208 1104.19 331.694 1103.89Z",
    fill: "url(#paint92_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-274",
    d: "M367.615 1128.57L345.481 1115.75C344.997 1115.47 344.686 1111.37 345.172 1111.09L361.53 1105.36C361.975 1105.11 362.522 1105.11 362.965 1105.36L385.599 1114.67C386.066 1114.93 385.715 1119.23 385.247 1119.49L369.274 1128.59C368.761 1128.88 368.127 1128.88 367.615 1128.57Z",
    fill: "url(#paint93_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-275",
    d: "M367.615 1124.75L345.481 1111.92C344.997 1111.64 344.999 1110.93 345.483 1110.67L361.53 1101.52C361.975 1101.27 362.522 1101.27 362.965 1101.53L385.251 1114.45C385.717 1114.72 385.715 1115.39 385.247 1115.65L369.274 1124.76C368.761 1125.05 368.127 1125.05 367.615 1124.75Z",
    fill: "url(#paint94_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-276",
    d: "M403.537 1149.44L381.401 1136.6C380.919 1136.32 380.608 1132.23 381.093 1131.95L397.452 1126.21C397.897 1125.96 398.443 1125.96 398.887 1126.21L421.521 1135.52C421.987 1135.8 421.637 1140.08 421.169 1140.35L405.196 1149.44C404.681 1149.73 404.049 1149.73 403.537 1149.44Z",
    fill: "url(#paint95_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-277",
    d: "M403.537 1145.61L381.402 1132.77C380.919 1132.49 380.922 1131.8 381.406 1131.52L397.452 1122.39C397.897 1122.13 398.443 1122.13 398.887 1122.39L421.173 1135.31C421.639 1135.57 421.637 1136.25 421.169 1136.52L405.196 1145.61C404.681 1145.91 404.049 1145.91 403.537 1145.61Z",
    fill: "url(#paint96_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-278",
    d: "M439.459 1170.29L417.323 1157.47C416.84 1157.19 416.529 1153.08 417.013 1152.8L433.373 1147.07C433.817 1146.81 434.364 1146.81 434.808 1147.07L457.443 1156.39C457.908 1156.65 457.557 1160.93 457.091 1161.2L441.117 1170.29C440.603 1170.6 439.971 1170.59 439.459 1170.29Z",
    fill: "url(#paint97_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-279",
    d: "M439.459 1166.47L417.323 1153.63C416.84 1153.35 416.842 1152.65 417.327 1152.37L433.374 1143.24C433.818 1142.99 434.364 1142.99 434.808 1143.24L457.095 1156.16C457.56 1156.44 457.558 1157.11 457.091 1157.37L441.118 1166.47C440.603 1166.76 439.971 1166.76 439.459 1166.47Z",
    fill: "url(#paint98_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-280",
    d: "M475.379 1191.15L453.244 1178.32C452.762 1178.04 452.45 1173.93 452.935 1173.67L469.294 1167.92C469.739 1167.67 470.286 1167.67 470.73 1167.93L493.363 1177.24C493.829 1177.51 493.479 1181.8 493.012 1182.07L477.039 1191.16C476.524 1191.45 475.892 1191.45 475.379 1191.15Z",
    fill: "url(#paint99_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-281",
    d: "M475.379 1187.32L453.244 1174.49C452.761 1174.21 452.763 1173.51 453.247 1173.24L469.293 1164.09C469.739 1163.84 470.285 1163.84 470.729 1164.11L493.015 1177.03C493.481 1177.29 493.479 1177.96 493.012 1178.23L477.039 1187.33C476.524 1187.63 475.892 1187.61 475.379 1187.32Z",
    fill: "url(#paint100_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-282",
    d: "M511.3 1212.01L489.165 1199.17C488.681 1198.89 488.371 1194.8 488.856 1194.52L505.215 1188.79C505.66 1188.53 506.207 1188.53 506.651 1188.79L529.284 1198.09C529.749 1198.37 529.4 1202.65 528.932 1202.92L512.96 1212.01C512.445 1212.31 511.813 1212.31 511.3 1212.01Z",
    fill: "url(#paint101_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-283",
    d: "M511.3 1208.19L489.165 1195.35C488.681 1195.07 488.684 1194.37 489.168 1194.09L505.215 1184.96C505.66 1184.71 506.207 1184.71 506.651 1184.96L528.936 1197.88C529.403 1198.15 529.4 1198.83 528.932 1199.09L512.96 1208.19C512.445 1208.48 511.813 1208.48 511.3 1208.19Z",
    fill: "url(#paint102_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-284",
    d: "M547.221 1232.87L525.085 1220.04C524.603 1219.76 524.292 1215.65 524.776 1215.37L541.136 1209.64C541.581 1209.39 542.127 1209.39 542.571 1209.64L565.205 1218.96C565.671 1219.23 565.321 1223.51 564.853 1223.77L548.88 1232.87C548.365 1233.16 547.733 1233.16 547.221 1232.87Z",
    fill: "url(#paint103_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-285",
    d: "M547.221 1229.04L525.085 1216.2C524.602 1215.92 524.603 1215.23 525.089 1214.95L541.135 1205.81C541.581 1205.56 542.126 1205.56 542.57 1205.81L564.857 1218.73C565.322 1219 565.321 1219.68 564.853 1219.95L548.879 1229.04C548.365 1229.33 547.733 1229.33 547.221 1229.04Z",
    fill: "url(#paint104_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-286",
    d: "M583.142 1253.72L561.006 1240.89C560.523 1240.61 560.211 1236.51 560.697 1236.24L577.057 1230.49C577.501 1230.24 578.047 1230.24 578.491 1230.51L601.126 1239.81C601.591 1240.08 601.241 1244.36 600.774 1244.63L584.801 1253.73C584.286 1254.03 583.654 1254.03 583.142 1253.72Z",
    fill: "url(#paint105_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-287",
    d: "M583.142 1249.89L561.007 1237.07C560.524 1236.79 560.525 1236.08 561.01 1235.81L577.057 1226.67C577.501 1226.41 578.048 1226.41 578.492 1226.68L600.778 1239.6C601.244 1239.87 601.241 1240.53 600.774 1240.8L584.801 1249.89C584.286 1250.2 583.654 1250.19 583.142 1249.89Z",
    fill: "url(#paint106_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-288",
    d: "M619.062 1274.59L596.928 1261.75C596.445 1261.47 596.133 1257.37 596.618 1257.09L612.978 1251.36C613.422 1251.11 613.969 1251.11 614.413 1251.36L637.046 1260.67C637.513 1260.95 637.162 1265.23 636.696 1265.49L620.722 1274.59C620.208 1274.88 619.576 1274.88 619.062 1274.59Z",
    fill: "url(#paint107_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-289",
    d: "M619.062 1270.75L596.927 1257.92C596.445 1257.64 596.446 1256.95 596.931 1256.67L612.978 1247.53C613.422 1247.27 613.969 1247.28 614.413 1247.53L636.698 1260.45C637.165 1260.72 637.162 1261.4 636.695 1261.67L620.722 1270.76C620.207 1271.05 619.575 1271.05 619.062 1270.75Z",
    fill: "url(#paint108_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-290",
    d: "M654.984 1295.44L632.848 1282.6C632.365 1282.32 632.054 1278.23 632.54 1277.95L648.898 1272.21C649.344 1271.96 649.89 1271.96 650.333 1272.21L672.968 1281.53C673.433 1281.8 673.084 1286.08 672.617 1286.35L656.644 1295.44C656.128 1295.73 655.496 1295.73 654.984 1295.44Z",
    fill: "url(#paint109_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-291",
    d: "M654.983 1291.61L632.847 1278.77C632.364 1278.49 632.367 1277.8 632.851 1277.52L648.897 1268.39C649.343 1268.13 649.889 1268.13 650.332 1268.39L672.619 1281.31C673.085 1281.57 673.083 1282.25 672.616 1282.52L656.643 1291.61C656.127 1291.91 655.495 1291.91 654.983 1291.61Z",
    fill: "url(#paint110_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-292",
    d: "M690.905 1316.29L668.769 1303.47C668.286 1303.19 667.976 1299.08 668.46 1298.8L684.82 1293.07C685.265 1292.81 685.812 1292.81 686.254 1293.08L708.889 1302.39C709.354 1302.65 709.005 1306.93 708.537 1307.2L692.564 1316.31C692.049 1316.6 691.417 1316.6 690.905 1316.29Z",
    fill: "url(#paint111_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-293",
    d: "M690.905 1312.47L668.769 1299.64C668.286 1299.36 668.289 1298.65 668.773 1298.37L684.819 1289.24C685.265 1288.99 685.811 1288.99 686.254 1289.24L708.541 1302.16C709.006 1302.44 709.005 1303.11 708.537 1303.37L692.563 1312.47C692.049 1312.77 691.417 1312.76 690.905 1312.47Z",
    fill: "url(#paint112_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-294",
    d: "M726.826 1337.16L704.69 1324.32C704.207 1324.04 703.897 1319.93 704.381 1319.67L720.741 1313.93C721.185 1313.67 721.733 1313.68 722.175 1313.93L744.81 1323.24C745.275 1323.51 744.926 1327.8 744.458 1328.07L728.485 1337.16C727.97 1337.45 727.338 1337.45 726.826 1337.16Z",
    fill: "url(#paint113_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-295",
    d: "M726.826 1333.32L704.69 1320.49C704.207 1320.21 704.209 1319.51 704.694 1319.24L720.741 1310.09C721.185 1309.84 721.733 1309.84 722.175 1310.11L744.461 1323.03C744.927 1323.29 744.926 1323.97 744.458 1324.24L728.485 1333.33C727.97 1333.63 727.338 1333.63 726.826 1333.32Z",
    fill: "url(#paint114_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-296",
    d: "M762.746 1358.01L740.611 1345.17C740.127 1344.89 739.818 1340.8 740.302 1340.52L756.66 1334.79C757.106 1334.53 757.654 1334.53 758.096 1334.79L780.731 1344.11C781.196 1344.37 780.847 1348.65 780.379 1348.92L764.406 1358.01C763.891 1358.31 763.259 1358.31 762.746 1358.01Z",
    fill: "url(#paint115_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-297",
    d: "M762.746 1354.19L740.612 1341.35C740.128 1341.07 740.13 1340.37 740.615 1340.09L756.661 1330.96C757.106 1330.71 757.654 1330.71 758.097 1330.96L780.382 1343.88C780.849 1344.15 780.847 1344.83 780.379 1345.09L764.406 1354.19C763.891 1354.48 763.259 1354.48 762.746 1354.19Z",
    fill: "url(#paint116_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-298",
    d: "M299.047 1126.67L276.911 1113.83C276.428 1113.55 276.117 1109.45 276.601 1109.17L292.961 1103.44C293.407 1103.19 293.953 1103.19 294.396 1103.44L317.03 1112.76C317.496 1113.03 317.147 1117.31 316.68 1117.57L300.707 1126.67C300.191 1126.96 299.56 1126.96 299.047 1126.67Z",
    fill: "url(#paint117_linear_71_514)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g-221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-299",
    d: "M299.047 1122.84L276.911 1110C276.429 1109.72 276.431 1109.03 276.915 1108.75L292.962 1099.61C293.407 1099.36 293.954 1099.36 294.397 1099.61L316.683 1112.53C317.15 1112.8 317.147 1113.48 316.681 1113.75L300.707 1122.84C300.191 1123.13 299.561 1123.13 299.047 1122.84Z",
    fill: "url(#paint118_linear_71_514)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-300",
    d: "M334.968 1147.52L312.833 1134.69C312.35 1134.41 312.039 1130.31 312.523 1130.03L328.883 1124.29C329.327 1124.04 329.875 1124.04 330.318 1124.31L352.952 1133.61C353.418 1133.88 353.068 1138.16 352.6 1138.43L336.627 1147.53C336.112 1147.83 335.48 1147.83 334.968 1147.52Z",
    fill: "url(#paint119_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-301",
    d: "M334.968 1143.69L312.832 1130.87C312.349 1130.59 312.35 1129.88 312.836 1129.6L328.882 1120.47C329.326 1120.21 329.874 1120.21 330.317 1120.47L352.604 1133.39C353.069 1133.67 353.068 1134.33 352.6 1134.6L336.626 1143.69C336.112 1143.99 335.48 1143.99 334.968 1143.69Z",
    fill: "url(#paint120_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-302",
    d: "M370.889 1168.37L348.753 1155.55C348.271 1155.27 347.96 1151.16 348.444 1150.89L364.804 1145.16C365.248 1144.89 365.795 1144.91 366.239 1145.16L388.873 1154.47C389.339 1154.73 388.989 1159.03 388.521 1159.29L372.548 1168.39C372.033 1168.68 371.401 1168.68 370.889 1168.37Z",
    fill: "url(#paint121_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-303",
    d: "M370.89 1164.55L348.754 1151.72C348.271 1151.44 348.272 1150.75 348.758 1150.47L364.804 1141.32C365.248 1141.07 365.795 1141.07 366.239 1141.33L388.525 1154.25C388.991 1154.52 388.99 1155.2 388.522 1155.47L372.548 1164.56C372.034 1164.85 371.402 1164.85 370.89 1164.55Z",
    fill: "url(#paint122_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-304",
    d: "M406.809 1189.24L384.674 1176.4C384.19 1176.12 383.88 1172.03 384.365 1171.75L400.724 1166.01C401.169 1165.76 401.716 1165.76 402.16 1166.01L424.793 1175.32C425.259 1175.6 424.909 1179.88 424.442 1180.15L408.469 1189.24C407.954 1189.53 407.322 1189.53 406.809 1189.24Z",
    fill: "url(#paint123_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-305",
    d: "M406.81 1185.41L384.675 1172.57C384.191 1172.29 384.194 1171.6 384.679 1171.32L400.724 1162.19C401.17 1161.93 401.716 1161.93 402.16 1162.19L424.446 1175.11C424.912 1175.37 424.91 1176.05 424.443 1176.32L408.47 1185.41C407.955 1185.71 407.323 1185.71 406.81 1185.41Z",
    fill: "url(#paint124_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-306",
    d: "M442.731 1210.09L420.596 1197.27C420.112 1196.99 419.801 1192.88 420.287 1192.6L436.645 1186.87C437.091 1186.61 437.637 1186.61 438.08 1186.88L460.715 1196.19C461.181 1196.45 460.831 1200.73 460.364 1201L444.389 1210.11C443.876 1210.39 443.244 1210.39 442.731 1210.09Z",
    fill: "url(#paint125_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-307",
    d: "M442.731 1206.27L420.596 1193.44C420.112 1193.16 420.115 1192.45 420.599 1192.17L436.645 1183.04C437.091 1182.79 437.637 1182.79 438.08 1183.04L460.367 1195.96C460.832 1196.24 460.831 1196.91 460.364 1197.17L444.389 1206.27C443.876 1206.56 443.244 1206.56 442.731 1206.27Z",
    fill: "url(#paint126_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-308",
    d: "M478.652 1230.95L456.516 1218.12C456.033 1217.84 455.722 1213.73 456.208 1213.47L472.566 1207.72C473.012 1207.47 473.558 1207.48 474.001 1207.73L496.636 1217.04C497.101 1217.31 496.752 1221.6 496.284 1221.87L480.31 1230.96C479.796 1231.25 479.164 1231.25 478.652 1230.95Z",
    fill: "url(#paint127_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-309",
    d: "M478.652 1227.12L456.516 1214.29C456.033 1214.01 456.036 1213.31 456.52 1213.04L472.566 1203.89C473.012 1203.64 473.558 1203.64 474.001 1203.91L496.288 1216.83C496.753 1217.09 496.752 1217.76 496.284 1218.03L480.31 1227.13C479.796 1227.43 479.164 1227.43 478.652 1227.12Z",
    fill: "url(#paint128_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-310",
    d: "M514.572 1251.81L492.437 1238.97C491.954 1238.69 491.644 1234.6 492.128 1234.32L508.488 1228.59C508.932 1228.33 509.48 1228.33 509.922 1228.59L532.557 1237.89C533.022 1238.17 532.673 1242.45 532.205 1242.72L516.232 1251.81C515.717 1252.11 515.085 1252.11 514.572 1251.81Z",
    fill: "url(#paint129_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-311",
    d: "M514.571 1247.99L492.437 1235.15C491.954 1234.87 491.957 1234.17 492.441 1233.89L508.487 1224.76C508.931 1224.51 509.479 1224.51 509.922 1224.76L532.209 1237.68C532.674 1237.95 532.673 1238.63 532.205 1238.89L516.231 1247.99C515.717 1248.28 515.085 1248.28 514.571 1247.99Z",
    fill: "url(#paint130_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-312",
    d: "M550.493 1272.67L528.358 1259.84C527.875 1259.56 527.565 1255.45 528.049 1255.17L544.407 1249.44C544.853 1249.19 545.399 1249.19 545.843 1249.44L568.478 1258.76C568.943 1259.03 568.594 1263.31 568.126 1263.57L552.152 1272.67C551.638 1272.96 551.006 1272.96 550.493 1272.67Z",
    fill: "url(#paint131_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-313",
    d: "M550.493 1268.84L528.358 1256C527.875 1255.72 527.877 1255.03 528.362 1254.75L544.407 1245.61C544.853 1245.36 545.399 1245.36 545.843 1245.61L568.129 1258.53C568.595 1258.81 568.594 1259.48 568.126 1259.75L552.153 1268.84C551.638 1269.13 551.006 1269.13 550.493 1268.84Z",
    fill: "url(#paint132_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-314",
    d: "M586.414 1293.52L564.279 1280.69C563.795 1280.41 563.486 1276.31 563.97 1276.04L580.328 1270.29C580.774 1270.04 581.32 1270.04 581.764 1270.31L604.399 1279.61C604.864 1279.88 604.514 1284.16 604.047 1284.44L588.072 1293.53C587.559 1293.83 586.927 1293.83 586.414 1293.52Z",
    fill: "url(#paint133_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-315",
    d: "M586.414 1289.69L564.279 1276.87C563.795 1276.59 563.798 1275.88 564.283 1275.6L580.329 1266.47C580.774 1266.21 581.321 1266.21 581.765 1266.48L604.05 1279.4C604.515 1279.67 604.514 1280.33 604.047 1280.6L588.073 1289.71C587.559 1290 586.927 1289.99 586.414 1289.69Z",
    fill: "url(#paint134_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-316",
    d: "M622.335 1314.39L600.201 1301.55C599.717 1301.27 599.406 1297.17 599.891 1296.89L616.25 1291.16C616.695 1290.91 617.242 1290.91 617.685 1291.16L640.319 1300.47C640.786 1300.75 640.435 1305.03 639.967 1305.29L623.994 1314.39C623.481 1314.68 622.847 1314.68 622.335 1314.39Z",
    fill: "url(#paint135_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-317",
    d: "M622.335 1310.55L600.201 1297.72C599.717 1297.44 599.719 1296.75 600.203 1296.47L616.25 1287.32C616.695 1287.07 617.242 1287.08 617.684 1287.33L639.971 1300.25C640.436 1300.52 640.435 1301.2 639.967 1301.47L623.994 1310.56C623.48 1310.85 622.847 1310.85 622.335 1310.55Z",
    fill: "url(#paint136_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-318",
    d: "M658.257 1335.24L636.121 1322.4C635.638 1322.12 635.327 1318.03 635.811 1317.75L652.171 1312.01C652.617 1311.76 653.162 1311.76 653.606 1312.01L676.24 1321.33C676.706 1321.6 676.356 1325.88 675.888 1326.15L659.915 1335.24C659.401 1335.53 658.769 1335.53 658.257 1335.24Z",
    fill: "url(#paint137_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-319",
    d: "M658.257 1331.41L636.121 1318.57C635.638 1318.29 635.639 1317.6 636.125 1317.32L652.171 1308.19C652.617 1307.93 653.162 1307.93 653.606 1308.19L675.893 1321.11C676.358 1321.37 676.357 1322.05 675.889 1322.32L659.915 1331.41C659.401 1331.71 658.769 1331.71 658.257 1331.41Z",
    fill: "url(#paint138_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-320",
    d: "M694.178 1356.09L672.042 1343.27C671.56 1342.99 671.249 1338.88 671.733 1338.6L688.093 1332.87C688.538 1332.61 689.084 1332.61 689.528 1332.88L712.162 1342.19C712.628 1342.45 712.277 1346.73 711.81 1347L695.837 1356.11C695.322 1356.4 694.69 1356.39 694.178 1356.09Z",
    fill: "url(#paint139_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-321",
    d: "M694.178 1352.27L672.042 1339.44C671.559 1339.16 671.56 1338.45 672.046 1338.17L688.092 1329.04C688.538 1328.79 689.083 1328.79 689.527 1329.04L711.814 1341.96C712.279 1342.24 712.276 1342.91 711.81 1343.17L695.836 1352.27C695.322 1352.56 694.69 1352.56 694.178 1352.27Z",
    fill: "url(#paint140_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-322",
    d: "M730.098 1376.96L707.963 1364.12C707.481 1363.84 707.17 1359.75 707.654 1359.47L724.014 1353.73C724.458 1353.48 725.005 1353.48 725.449 1353.73L748.082 1363.04C748.549 1363.32 748.198 1367.6 747.731 1367.87L731.758 1376.96C731.243 1377.25 730.611 1377.25 730.098 1376.96Z",
    fill: "url(#paint141_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-323",
    d: "M730.097 1373.12L707.963 1360.29C707.48 1360.01 707.481 1359.32 707.965 1359.04L724.013 1349.89C724.457 1349.64 725.004 1349.65 725.448 1349.91L747.735 1362.83C748.2 1363.09 748.197 1363.77 747.731 1364.04L731.757 1373.13C731.243 1373.43 730.611 1373.43 730.097 1373.12Z",
    fill: "url(#paint142_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-324",
    d: "M266.688 1145.25L244.553 1132.41C244.069 1132.13 243.758 1128.04 244.244 1127.76L260.602 1122.02C261.048 1121.77 261.594 1121.77 262.037 1122.02L284.672 1131.33C285.138 1131.61 284.788 1135.89 284.32 1136.16L268.346 1145.25C267.833 1145.54 267.2 1145.54 266.688 1145.25Z",
    fill: "url(#paint143_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-325",
    d: "M266.688 1141.41L244.553 1128.58C244.069 1128.3 244.072 1127.61 244.556 1127.33L260.602 1118.18C261.048 1117.93 261.594 1117.94 262.037 1118.2L284.324 1131.12C284.789 1131.38 284.788 1132.06 284.32 1132.33L268.346 1141.42C267.833 1141.72 267.2 1141.72 266.688 1141.41Z",
    fill: "url(#paint144_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-326",
    d: "M302.321 1166.47L280.185 1153.63C279.702 1153.35 279.391 1149.25 279.877 1148.97L296.235 1143.24C296.681 1142.99 297.227 1142.99 297.67 1143.24L320.305 1152.56C320.77 1152.83 320.421 1157.11 319.953 1157.37L303.979 1166.47C303.465 1166.76 302.833 1166.76 302.321 1166.47Z",
    fill: "url(#paint145_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-327",
    d: "M302.32 1162.64L280.184 1149.8C279.701 1149.52 279.704 1148.83 280.188 1148.55L296.234 1139.41C296.68 1139.16 297.226 1139.16 297.669 1139.41L319.956 1152.33C320.421 1152.6 320.42 1153.28 319.952 1153.55L303.978 1162.64C303.464 1162.93 302.832 1162.93 302.32 1162.64Z",
    fill: "url(#paint146_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-328",
    d: "M338.24 1187.32L316.105 1174.49C315.622 1174.21 315.312 1170.11 315.796 1169.83L332.156 1164.09C332.6 1163.84 333.146 1163.84 333.59 1164.11L356.225 1173.41C356.69 1173.68 356.34 1177.96 355.873 1178.23L339.9 1187.33C339.385 1187.63 338.753 1187.61 338.24 1187.32Z",
    fill: "url(#paint147_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-329",
    d: "M338.24 1183.49L316.105 1170.67C315.622 1170.39 315.624 1169.68 316.109 1169.4L332.156 1160.27C332.6 1160.01 333.146 1160.01 333.59 1160.27L355.877 1173.19C356.342 1173.47 356.34 1174.13 355.873 1174.4L339.9 1183.49C339.385 1183.79 338.753 1183.79 338.24 1183.49Z",
    fill: "url(#paint148_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-330",
    d: "M374.161 1208.19L352.027 1195.35C351.544 1195.07 351.233 1190.97 351.717 1190.69L368.076 1184.96C368.521 1184.71 369.068 1184.71 369.512 1184.96L392.145 1194.27C392.612 1194.55 392.261 1198.83 391.795 1199.09L375.821 1208.19C375.307 1208.48 374.675 1208.48 374.161 1208.19Z",
    fill: "url(#paint149_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-331",
    d: "M374.162 1204.35L352.027 1191.52C351.545 1191.24 351.546 1190.55 352.03 1190.27L368.076 1181.12C368.522 1180.87 369.068 1180.88 369.512 1181.13L391.798 1194.05C392.264 1194.32 392.262 1194.99 391.795 1195.27L375.822 1204.36C375.307 1204.65 374.675 1204.65 374.162 1204.35Z",
    fill: "url(#paint150_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-332",
    d: "M410.082 1229.04L387.948 1216.2C387.464 1215.92 387.153 1211.83 387.638 1211.55L403.997 1205.81C404.442 1205.56 404.989 1205.56 405.432 1205.81L428.066 1215.13C428.533 1215.4 428.182 1219.68 427.714 1219.95L411.741 1229.04C411.228 1229.33 410.596 1229.33 410.082 1229.04Z",
    fill: "url(#paint151_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-333",
    d: "M410.082 1225.21L387.948 1212.37C387.464 1212.09 387.466 1211.4 387.95 1211.12L403.997 1201.99C404.442 1201.73 404.989 1201.73 405.432 1201.99L427.718 1214.91C428.184 1215.17 428.182 1215.85 427.714 1216.12L411.741 1225.21C411.228 1225.51 410.596 1225.51 410.082 1225.21Z",
    fill: "url(#paint152_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-334",
    d: "M446.004 1249.89L423.868 1237.07C423.386 1236.79 423.075 1232.68 423.56 1232.4L439.919 1226.67C440.364 1226.41 440.91 1226.41 441.354 1226.68L463.988 1235.99C464.453 1236.25 464.104 1240.53 463.636 1240.8L447.663 1249.89C447.15 1250.2 446.516 1250.19 446.004 1249.89Z",
    fill: "url(#paint153_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-335",
    d: "M446.004 1246.07L423.868 1233.24C423.385 1232.95 423.386 1232.25 423.872 1231.97L439.918 1222.84C440.364 1222.59 440.909 1222.59 441.353 1222.84L463.64 1235.76C464.105 1236.04 464.104 1236.71 463.636 1236.97L447.662 1246.07C447.149 1246.36 446.516 1246.36 446.004 1246.07Z",
    fill: "url(#paint154_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-336",
    d: "M481.924 1270.75L459.789 1257.92C459.306 1257.64 458.995 1253.55 459.479 1253.27L475.839 1247.53C476.283 1247.27 476.83 1247.28 477.274 1247.53L499.908 1256.84C500.374 1257.11 500.023 1261.4 499.556 1261.67L483.583 1270.76C483.068 1271.05 482.436 1271.05 481.924 1270.75Z",
    fill: "url(#paint155_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-337",
    d: "M481.925 1266.92L459.789 1254.09C459.306 1253.81 459.307 1253.11 459.793 1252.84L475.839 1243.69C476.283 1243.44 476.83 1243.44 477.274 1243.71L499.561 1256.63C500.026 1256.89 500.023 1257.56 499.557 1257.83L483.583 1266.93C483.069 1267.23 482.437 1267.23 481.925 1266.92Z",
    fill: "url(#paint156_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-338",
    d: "M517.846 1291.61L495.71 1278.77C495.227 1278.49 494.915 1274.4 495.401 1274.12L511.761 1268.39C512.205 1268.13 512.751 1268.13 513.195 1268.39L535.829 1277.69C536.295 1277.97 535.945 1282.25 535.478 1282.52L519.505 1291.61C518.99 1291.91 518.358 1291.91 517.846 1291.61Z",
    fill: "url(#paint157_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-339",
    d: "M517.847 1287.79L495.711 1274.95C495.228 1274.67 495.229 1273.97 495.713 1273.69L511.761 1264.56C512.205 1264.31 512.752 1264.31 513.196 1264.56L535.483 1277.48C535.948 1277.75 535.945 1278.43 535.479 1278.69L519.505 1287.79C518.991 1288.08 518.359 1288.08 517.847 1287.79Z",
    fill: "url(#paint158_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-340",
    d: "M553.766 1312.47L531.63 1299.64C531.147 1299.36 530.837 1295.25 531.322 1294.97L547.681 1289.24C548.126 1288.99 548.673 1288.99 549.115 1289.24L571.75 1298.56C572.215 1298.83 571.866 1303.11 571.399 1303.37L555.426 1312.47C554.911 1312.77 554.279 1312.76 553.766 1312.47Z",
    fill: "url(#paint159_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-341",
    d: "M553.766 1308.64L531.63 1295.8C531.147 1295.52 531.15 1294.83 531.634 1294.55L547.681 1285.41C548.126 1285.16 548.673 1285.16 549.115 1285.41L571.402 1298.33C571.869 1298.61 571.866 1299.28 571.399 1299.55L555.426 1308.64C554.911 1308.93 554.279 1308.93 553.766 1308.64Z",
    fill: "url(#paint160_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-342",
    d: "M589.687 1333.32L567.551 1320.49C567.069 1320.21 566.758 1316.11 567.242 1315.84L583.602 1310.09C584.047 1309.84 584.594 1309.84 585.037 1310.11L607.671 1319.41C608.136 1319.68 607.787 1323.97 607.32 1324.24L591.346 1333.33C590.831 1333.63 590.199 1333.63 589.687 1333.32Z",
    fill: "url(#paint161_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-343",
    d: "M589.687 1329.49L567.551 1316.67C567.069 1316.39 567.07 1315.68 567.555 1315.41L583.602 1306.27C584.047 1306.01 584.594 1306.01 585.037 1306.28L607.323 1319.2C607.789 1319.47 607.787 1320.13 607.321 1320.4L591.346 1329.51C590.831 1329.8 590.199 1329.79 589.687 1329.49Z",
    fill: "url(#paint162_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-344",
    d: "M625.609 1354.19L603.473 1341.35C602.99 1341.07 602.68 1336.97 603.164 1336.69L619.524 1330.96C619.968 1330.71 620.514 1330.71 620.958 1330.96L643.593 1340.27C644.058 1340.55 643.709 1344.83 643.241 1345.09L627.268 1354.19C626.753 1354.48 626.121 1354.48 625.609 1354.19Z",
    fill: "url(#paint163_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-345",
    d: "M625.608 1350.35L603.472 1337.52C602.99 1337.24 602.991 1336.55 603.476 1336.27L619.523 1327.13C619.967 1326.88 620.514 1326.88 620.958 1327.13L643.244 1340.05C643.71 1340.32 643.708 1341 643.24 1341.27L627.267 1350.36C626.752 1350.65 626.12 1350.65 625.608 1350.35Z",
    fill: "url(#paint164_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-346",
    d: "M661.529 1375.04L639.394 1362.21C638.91 1361.93 638.599 1357.83 639.085 1357.55L655.445 1351.81C655.889 1351.56 656.435 1351.56 656.879 1351.81L679.514 1361.13C679.979 1361.4 679.629 1365.68 679.162 1365.95L663.189 1375.04C662.674 1375.33 662.042 1375.33 661.529 1375.04Z",
    fill: "url(#paint165_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g-317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-347",
    d: "M661.528 1371.21L639.394 1358.37C638.91 1358.09 638.912 1357.4 639.398 1357.12L655.444 1347.99C655.888 1347.73 656.435 1347.73 656.879 1347.99L679.164 1360.91C679.631 1361.17 679.628 1361.85 679.162 1362.12L663.188 1371.21C662.674 1371.51 662.042 1371.51 661.528 1371.21Z",
    fill: "url(#paint166_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-348",
    d: "M697.449 1395.89L675.315 1383.07C674.831 1382.79 674.52 1378.68 675.006 1378.4L691.364 1372.67C691.809 1372.41 692.356 1372.41 692.799 1372.68L715.433 1381.99C715.9 1382.25 715.549 1386.53 715.083 1386.8L699.108 1395.91C698.595 1396.2 697.961 1396.2 697.449 1395.89Z",
    fill: "url(#paint167_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-349",
    d: "M697.45 1392.07L675.316 1379.24C674.832 1378.96 674.834 1378.25 675.32 1377.97L691.365 1368.84C691.81 1368.59 692.357 1368.59 692.8 1368.84L715.086 1381.77C715.553 1382.04 715.55 1382.71 715.084 1382.97L699.109 1392.07C698.596 1392.37 697.962 1392.36 697.45 1392.07Z",
    fill: "url(#paint168_linear_71_514)"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "groundround"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-163",
    d: "M516.931 1720.79C262.918 1720.79 57 1605.43 57 1463.12C57 1411.87 83.6973 1364.12 129.733 1324L136.053 1327.67C91.6039 1366.82 65.8467 1413.28 65.8467 1463.12C65.8467 1602.68 267.804 1715.83 516.931 1715.83C766.057 1715.83 968.014 1602.68 968.014 1463.12C968.014 1431.87 957.898 1401.96 939.39 1374.34L946.218 1370.46C966.01 1399.2 976.861 1430.46 976.861 1463.12C976.861 1605.43 770.944 1720.79 516.931 1720.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-164",
    d: "M516.931 1715.83C267.804 1715.83 65.8467 1602.68 65.8467 1463.12C65.8467 1413.28 91.6039 1366.82 136.053 1327.67L142.38 1331.34C99.5012 1369.5 74.6933 1414.7 74.6933 1463.12C74.6933 1599.95 272.69 1710.87 516.931 1710.87C761.171 1710.87 959.167 1599.95 959.167 1463.12C959.167 1433.31 949.765 1404.72 932.534 1378.24L939.39 1374.34C957.898 1401.96 968.014 1431.87 968.014 1463.12C968.014 1602.68 766.057 1715.83 516.931 1715.83Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-165",
    d: "M516.931 1710.87C272.69 1710.87 74.6934 1599.95 74.6934 1463.12C74.6934 1414.7 99.5012 1369.5 142.38 1331.34L148.716 1335C107.399 1372.19 83.54 1416.1 83.54 1463.12C83.54 1597.22 277.577 1705.92 516.931 1705.92C756.285 1705.92 950.321 1597.22 950.321 1463.12C950.321 1434.74 941.622 1407.48 925.645 1382.16L932.534 1378.24C949.765 1404.72 959.167 1433.31 959.167 1463.12C959.167 1599.95 761.171 1710.87 516.931 1710.87Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-166",
    d: "M516.931 1705.92C277.577 1705.92 83.54 1597.22 83.54 1463.12C83.54 1416.1 107.399 1372.19 148.716 1335L155.058 1338.68C115.311 1374.88 92.3879 1417.5 92.3879 1463.12C92.3879 1594.48 282.462 1700.96 516.931 1700.96C751.399 1700.96 941.473 1594.48 941.473 1463.12C941.473 1436.16 933.471 1410.26 918.723 1386.11L925.645 1382.16C941.622 1407.48 950.321 1434.74 950.321 1463.12C950.321 1597.22 756.285 1705.92 516.931 1705.92Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-167",
    d: "M516.931 1700.96C282.462 1700.96 92.3877 1594.48 92.3877 1463.12C92.3877 1417.5 115.31 1374.88 155.058 1338.68L161.41 1342.36C123.221 1377.58 101.234 1418.91 101.234 1463.12C101.234 1591.74 287.347 1696 516.931 1696C746.513 1696 932.627 1591.74 932.627 1463.12C932.627 1437.6 925.298 1413.04 911.765 1390.07L918.723 1386.11C933.471 1410.26 941.473 1436.16 941.473 1463.12C941.473 1594.48 751.398 1700.96 516.931 1700.96Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-168",
    d: "M516.931 1696C287.347 1696 101.234 1591.74 101.234 1463.12C101.234 1418.91 123.221 1377.58 161.41 1342.36L167.772 1346.06C131.14 1380.27 110.081 1420.32 110.081 1463.12C110.081 1589 292.234 1691.06 516.931 1691.06C741.626 1691.06 923.779 1589 923.779 1463.12C923.779 1439.04 917.118 1415.84 904.766 1394.06L911.765 1390.07C925.298 1413.04 932.627 1437.6 932.627 1463.12C932.627 1591.74 746.513 1696 516.931 1696Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-169",
    d: "M516.931 1691.06C292.234 1691.06 110.081 1589 110.081 1463.12C110.081 1420.32 131.14 1380.27 167.772 1346.06L174.144 1349.75C139.066 1382.96 118.928 1421.72 118.928 1463.12C118.928 1586.27 297.119 1686.1 516.931 1686.1C736.741 1686.1 914.933 1586.27 914.933 1463.12C914.933 1440.48 908.914 1418.64 897.725 1398.06L904.766 1394.06C917.118 1415.84 923.779 1439.04 923.779 1463.12C923.779 1589 741.626 1691.06 516.931 1691.06Z",
    fill: "#F9F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-170",
    d: "M516.931 1686.1C297.119 1686.1 118.928 1586.27 118.928 1463.12C118.928 1421.72 139.066 1382.96 174.144 1349.75L180.526 1353.44C146.986 1385.67 127.774 1423.14 127.774 1463.12C127.774 1583.52 302.006 1681.14 516.931 1681.14C731.854 1681.14 906.086 1583.52 906.086 1463.12C906.086 1441.94 900.693 1421.46 890.637 1402.1L897.725 1398.06C908.914 1418.64 914.933 1440.48 914.933 1463.12C914.933 1586.27 736.741 1686.1 516.931 1686.1Z",
    fill: "#F8F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-171",
    d: "M516.931 1681.14C302.006 1681.14 127.774 1583.52 127.774 1463.12C127.774 1423.14 146.986 1385.67 180.526 1353.44L186.92 1357.15C154.92 1388.36 136.621 1424.55 136.621 1463.12C136.621 1580.79 306.891 1676.18 516.931 1676.18C726.969 1676.18 897.24 1580.79 897.24 1463.12C897.24 1443.39 892.457 1424.3 883.498 1406.16L890.637 1402.1C900.693 1421.46 906.086 1441.94 906.086 1463.12C906.086 1583.52 731.854 1681.14 516.931 1681.14Z",
    fill: "#F7F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-172",
    d: "M516.931 1676.18C306.891 1676.18 136.621 1580.79 136.621 1463.12C136.621 1424.55 154.92 1388.36 186.92 1357.15L193.325 1360.87C162.856 1391.07 145.468 1425.95 145.468 1463.12C145.468 1578.06 311.777 1671.23 516.931 1671.23C722.084 1671.23 888.393 1578.06 888.393 1463.12C888.393 1444.86 884.194 1427.14 876.303 1410.26L883.498 1406.16C892.457 1424.3 897.24 1443.39 897.24 1463.12C897.24 1580.79 726.969 1676.18 516.931 1676.18Z",
    fill: "#F6F6F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-173",
    d: "M516.931 1671.23C311.777 1671.23 145.468 1578.06 145.468 1463.12C145.468 1425.95 162.856 1391.07 193.325 1360.87L199.746 1364.59C170.801 1393.78 154.316 1427.36 154.316 1463.12C154.316 1575.31 316.663 1666.27 516.931 1666.27C717.197 1666.27 879.546 1575.31 879.546 1463.12C879.546 1446.32 875.907 1430 869.047 1414.39L876.303 1410.26C884.194 1427.14 888.393 1444.86 888.393 1463.12C888.393 1578.06 722.084 1671.23 516.931 1671.23Z",
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-174",
    d: "M516.931 1666.27C316.663 1666.27 154.315 1575.31 154.315 1463.12C154.315 1427.36 170.801 1393.78 199.746 1364.59L206.179 1368.32C178.751 1396.48 163.161 1428.78 163.161 1463.12C163.161 1572.58 321.55 1661.31 516.931 1661.31C712.312 1661.31 870.699 1572.58 870.699 1463.12C870.699 1447.8 867.594 1432.88 861.722 1418.56L869.047 1414.39C875.907 1430 879.546 1446.32 879.546 1463.12C879.546 1575.31 717.197 1666.27 516.931 1666.27Z",
    fill: "#F4F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-175",
    d: "M516.931 1661.31C321.55 1661.31 163.161 1572.58 163.161 1463.12C163.161 1428.78 178.752 1396.48 206.18 1368.32L212.63 1372.06C186.706 1399.19 172.009 1430.19 172.009 1463.12C172.009 1569.84 326.436 1656.35 516.931 1656.35C707.425 1656.35 861.852 1569.84 861.852 1463.12C861.852 1449.28 859.256 1435.79 854.324 1422.78L861.722 1418.56C867.594 1432.88 870.7 1447.8 870.7 1463.12C870.7 1572.58 712.312 1661.31 516.931 1661.31Z",
    fill: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-176",
    d: "M516.931 1656.35C326.435 1656.35 172.009 1569.84 172.009 1463.12C172.009 1430.19 186.706 1399.19 212.63 1372.06L219.098 1375.8C194.671 1401.91 180.855 1431.6 180.855 1463.12C180.855 1567.11 331.321 1651.4 516.931 1651.4C702.54 1651.4 853.006 1567.11 853.006 1463.12C853.006 1450.78 850.885 1438.71 846.839 1427.04L854.323 1422.78C859.255 1435.79 861.851 1449.28 861.851 1463.12C861.851 1569.84 707.425 1656.35 516.931 1656.35Z",
    fill: "#F2F2F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-177",
    d: "M516.931 1651.4C331.321 1651.4 180.855 1567.11 180.855 1463.12C180.855 1431.6 194.671 1401.91 219.098 1375.8L225.585 1379.58C202.645 1404.63 189.702 1433.03 189.702 1463.12C189.702 1564.36 336.207 1646.44 516.931 1646.44C697.653 1646.44 844.158 1564.36 844.158 1463.12C844.158 1452.28 842.479 1441.67 839.262 1431.35L846.839 1427.04C850.885 1438.71 853.006 1450.78 853.006 1463.12C853.006 1567.11 702.54 1651.4 516.931 1651.4Z",
    fill: "#F1F1F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-178",
    d: "M516.931 1646.44C336.207 1646.44 189.702 1564.36 189.702 1463.12C189.702 1433.03 202.645 1404.63 225.585 1379.58L232.091 1383.34C210.631 1407.35 198.549 1434.44 198.549 1463.12C198.549 1561.63 341.092 1641.48 516.931 1641.48C692.768 1641.48 835.311 1561.63 835.311 1463.12C835.311 1453.8 834.035 1444.66 831.579 1435.72L839.262 1431.35C842.479 1441.67 844.158 1452.28 844.158 1463.12C844.158 1564.36 697.653 1646.44 516.931 1646.44Z",
    fill: "#F1F0EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-179",
    d: "M516.931 1641.48C341.092 1641.48 198.549 1561.63 198.549 1463.12C198.549 1434.44 210.632 1407.35 232.091 1383.34L238.622 1387.12C218.619 1410.07 207.396 1435.86 207.396 1463.12C207.396 1558.9 345.979 1636.54 516.931 1636.54C687.881 1636.54 826.465 1558.9 826.465 1463.12C826.465 1455.34 825.549 1447.68 823.777 1440.16L831.58 1435.72C834.036 1444.66 835.312 1453.8 835.312 1463.12C835.312 1561.63 692.768 1641.48 516.931 1641.48Z",
    fill: "#F0EFEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-180",
    d: "M516.931 1636.54C345.979 1636.54 207.396 1558.9 207.396 1463.12C207.396 1435.86 218.619 1410.07 238.622 1387.12L245.175 1390.92C226.621 1412.82 216.242 1437.28 216.242 1463.12C216.242 1556.15 350.864 1631.58 516.931 1631.58C682.996 1631.58 817.618 1556.15 817.618 1463.12C817.618 1456.9 817.016 1450.75 815.84 1444.68L823.777 1440.16C825.549 1447.68 826.465 1455.34 826.465 1463.12C826.465 1558.9 687.881 1636.54 516.931 1636.54Z",
    fill: "#EFEEED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-181",
    d: "M516.931 1631.58C350.865 1631.58 216.242 1556.15 216.242 1463.12C216.242 1437.28 226.621 1412.82 245.176 1390.92L251.758 1394.75C234.641 1415.55 225.089 1438.71 225.089 1463.12C225.089 1553.42 355.75 1626.62 516.931 1626.62C678.111 1626.62 808.772 1553.42 808.772 1463.12C808.772 1458.47 808.425 1453.86 807.744 1449.3L815.84 1444.68C817.016 1450.75 817.618 1456.9 817.618 1463.12C817.618 1556.15 682.996 1631.58 516.931 1631.58Z",
    fill: "#EEEDEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-182",
    d: "M516.931 1626.62C355.75 1626.62 225.089 1553.42 225.089 1463.12C225.089 1438.71 234.641 1415.55 251.758 1394.75L258.372 1398.58C242.665 1418.3 233.937 1440.14 233.937 1463.12C233.937 1550.68 360.637 1621.66 516.931 1621.66C673.224 1621.66 799.925 1550.68 799.925 1463.12C799.925 1460.07 799.77 1457.03 799.466 1454.02L807.744 1449.3C808.425 1453.86 808.772 1458.47 808.772 1463.12C808.772 1553.42 678.111 1626.62 516.931 1626.62Z",
    fill: "#ECEBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-183",
    d: "M516.931 1621.66C360.636 1621.66 233.937 1550.68 233.937 1463.12C233.937 1440.14 242.665 1418.3 258.371 1398.58L265.017 1402.43C250.711 1421.04 242.782 1441.56 242.782 1463.12C242.782 1547.95 365.523 1616.71 516.931 1616.71C668.338 1616.71 791.078 1547.95 791.078 1463.12C791.078 1461.7 791.042 1460.27 790.974 1458.84L799.466 1454.02C799.77 1457.03 799.925 1460.07 799.925 1463.12C799.925 1550.68 673.224 1621.66 516.931 1621.66Z",
    fill: "#EBEAE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-184",
    d: "M516.931 1616.71C365.523 1616.71 242.782 1547.95 242.782 1463.12C242.782 1441.56 250.712 1421.04 265.017 1402.43L271.702 1406.31C258.77 1423.8 251.63 1443 251.63 1463.12C251.63 1545.2 370.409 1611.75 516.931 1611.75C663.032 1611.75 781.549 1545.59 782.228 1463.83L790.974 1458.84C791.042 1460.27 791.078 1461.7 791.078 1463.12C791.078 1547.95 668.339 1616.71 516.931 1616.71Z",
    fill: "#EAE9E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-185",
    d: "M516.931 1611.75C370.408 1611.75 251.63 1545.2 251.63 1463.12C251.63 1443 258.77 1423.8 271.702 1406.31L278.428 1410.2C266.845 1426.58 260.477 1444.43 260.477 1463.12C260.477 1542.47 375.294 1606.79 516.931 1606.79C655.065 1606.79 767.691 1545.62 773.174 1468.98L782.227 1463.83C781.549 1545.59 663.032 1611.75 516.931 1611.75Z",
    fill: "#E9E8E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-186",
    d: "M516.931 1606.79C375.294 1606.79 260.477 1542.47 260.477 1463.12C260.477 1444.43 266.845 1426.58 278.428 1410.2L285.204 1414.14C274.939 1429.36 269.323 1445.87 269.323 1463.12C269.323 1539.74 380.18 1601.84 516.931 1601.84C646.928 1601.84 753.526 1545.71 763.737 1474.36L773.174 1468.98C767.691 1545.62 655.065 1606.79 516.931 1606.79Z",
    fill: "#E8E7E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-187",
    d: "M516.931 1601.84C380.18 1601.84 269.323 1539.74 269.323 1463.12C269.323 1445.87 274.939 1429.36 285.204 1414.14L554.577 1570.3C560.863 1573.95 567.884 1575.76 574.908 1575.76C581.852 1575.76 588.797 1573.99 595.033 1570.42L763.737 1474.36C753.526 1545.71 646.928 1601.84 516.931 1601.84Z",
    fill: "#E8E6E5"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "laptop1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "latopscreenback"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-1_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-2_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-188_2",
    d: "M2917.19 2313.03L3440.41 2645.8C3457.44 2655.7 3492.99 2622.66 3492.99 2602.96V2079.5C3492.99 2058.19 3481.65 2038.5 3463.23 2027.81L2922.65 1713.95C2905.09 1703.75 2862.51 1721.69 2862.51 1741.99L2883.08 2253.79C2883.08 2278.21 2896.08 2300.78 2917.19 2313.03Z",
    fill: "url(#paint169_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-3_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-4_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-189_2",
    d: "M2889.34 2330.86L3426.75 2642.89C3443.79 2652.78 3465.13 2640.49 3465.13 2620.79V2097.33C3465.13 2076.02 3453.8 2056.34 3435.37 2045.63L2894.8 1731.78C2877.24 1721.58 2855.23 1734.25 2855.23 1754.55V2271.62C2855.23 2296.03 2868.22 2318.61 2889.34 2330.86Z",
    fill: "url(#paint170_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "laptopscreenfront",
    d: "M3441.94 2627.68C3441.25 2627.68 3440.58 2627.48 3439.88 2627.07L2902.46 2315.06C2887.99 2306.66 2879 2291.03 2879 2274.3V1757.23C2879 1753.82 2881.99 1752.23 2884 1752.23C2884.82 1752.23 2885.62 1752.46 2886.45 1752.94L3427.03 2066.8C3438.82 2073.64 3446.15 2086.36 3446.15 2100V2623.47C3446.15 2624.24 3446.03 2625.39 3444.95 2626.42C3444.13 2627.2 3443 2627.68 3441.94 2627.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    className: "bottompanel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "mouse",
    d: "M2828.45 2609.54C2828.76 2609.36 2829.14 2609.36 2829.45 2609.54L2957.82 2683.08C2958.49 2683.46 2958.49 2684.43 2957.82 2684.82L2862.37 2738.93C2862.06 2739.1 2861.69 2739.1 2861.38 2738.92L2734.5 2665.37C2733.83 2664.99 2733.83 2664.03 2734.5 2663.64L2828.45 2609.54Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bottom1_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 132_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-8_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-192_2",
    d: "M3014.92 2925.82C3007.89 2925.82 3000.87 2923.99 2994.59 2920.35L2454.82 2607.42C2447.52 2603.19 2442.19 2586.22 2442.01 2572.31C2441.89 2563.77 2443.71 2556.38 2448.21 2553.81C2443.81 2561.75 2446.01 2572.55 2454.82 2577.66L2994.59 2890.59C3000.87 2894.23 3007.89 2896.06 3014.92 2896.06C3021.86 2896.06 3028.81 2894.27 3035.04 2890.71L3424.56 2668.91C3428.76 2666.51 3431.42 2662.77 3432.53 2658.66C3432.96 2662.19 3433.16 2665.95 3433.13 2669.7C3433.02 2682.66 3430.16 2695.47 3424.56 2698.67L3035.04 2920.47C3028.81 2924.03 3021.86 2925.82 3014.92 2925.82Z",
    fill: "url(#paint171_linear_71_514)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g-9_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-10_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-193_2",
    d: "M3015.53 2895.68C3008.51 2895.68 3001.49 2893.86 2995.2 2890.22L2455.43 2577.28C2446.62 2572.18 2444.43 2561.38 2448.82 2553.43C2450.3 2550.74 2452.53 2548.38 2455.52 2546.67L2846.81 2323.86C2852.2 2320.78 2858.21 2319.23 2864.22 2319.23C2870.29 2319.23 2876.36 2320.81 2881.8 2323.97L3425.25 2639.03C3432.42 2643.18 3435.05 2651.26 3433.14 2658.28C3432.03 2662.39 3429.37 2666.14 3425.17 2668.54L3035.66 2890.34C3029.42 2893.9 3022.47 2895.68 3015.53 2895.68ZM2829.93 2611.78C2828.62 2611.78 2827.31 2612.11 2826.13 2612.78L2740.68 2661.43C2738.1 2662.91 2738.09 2666.63 2740.66 2668.12L2858.53 2736.46C2859.9 2737.24 2861.44 2737.64 2862.97 2737.64C2864.49 2737.64 2866 2737.26 2867.37 2736.48L2952.42 2688.04C2954.91 2686.63 2954.92 2683.04 2952.44 2681.6L2833.77 2612.8C2832.58 2612.11 2831.25 2611.78 2829.93 2611.78Z",
    fill: "url(#paint172_linear_71_514)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "keys_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 58_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-11_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-12_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-194_2",
    d: "M2871.64 2399.13L2849.5 2386.3C2849.02 2386.01 2848.71 2381.91 2849.19 2381.63L2865.55 2375.9C2866 2375.65 2866.55 2375.65 2866.99 2375.9L2889.62 2385.22C2890.09 2385.49 2889.74 2389.77 2889.27 2390.03L2873.3 2399.13C2872.78 2399.42 2872.15 2399.42 2871.64 2399.13Z",
    fill: "url(#paint173_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-13_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-14_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-195_2",
    d: "M2871.64 2395.3L2849.5 2382.46C2849.02 2382.18 2849.02 2381.49 2849.51 2381.21L2865.55 2372.07C2866 2371.82 2866.54 2371.82 2866.99 2372.07L2889.28 2384.99C2889.74 2385.27 2889.74 2385.94 2889.27 2386.21L2873.3 2395.3C2872.78 2395.59 2872.15 2395.59 2871.64 2395.3Z",
    fill: "url(#paint174_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 64_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-15_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-16_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-196_2",
    d: "M2907.56 2419.98L2885.43 2407.15C2884.94 2406.87 2884.63 2402.77 2885.12 2402.5L2901.48 2396.75C2901.92 2396.5 2902.47 2396.5 2902.91 2396.77L2925.54 2406.07C2926.01 2406.34 2925.66 2410.62 2925.19 2410.89L2909.22 2419.99C2908.71 2420.29 2908.07 2420.29 2907.56 2419.98Z",
    fill: "url(#paint175_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-17_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-18_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-197_2",
    d: "M2907.56 2416.15L2885.42 2403.33C2884.94 2403.05 2884.94 2402.34 2885.43 2402.06L2901.48 2392.93C2901.92 2392.67 2902.47 2392.67 2902.91 2392.94L2925.2 2405.86C2925.66 2406.13 2925.66 2406.79 2925.19 2407.06L2909.22 2416.17C2908.7 2416.46 2908.07 2416.45 2907.56 2416.15Z",
    fill: "url(#paint176_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 70_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-19_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-20_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-198_2",
    d: "M2943.48 2440.85L2921.35 2428.01C2920.86 2427.73 2920.55 2423.63 2921.04 2423.35L2937.4 2417.62C2937.84 2417.37 2938.39 2417.37 2938.83 2417.62L2961.46 2426.93C2961.93 2427.21 2961.58 2431.49 2961.11 2431.75L2945.14 2440.85C2944.63 2441.14 2943.99 2441.14 2943.48 2440.85Z",
    fill: "url(#paint177_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-21_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-22_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-199_2",
    d: "M2943.48 2437.01L2921.35 2424.18C2920.86 2423.9 2920.86 2423.21 2921.35 2422.93L2937.4 2413.78C2937.84 2413.53 2938.39 2413.54 2938.83 2413.79L2961.12 2426.71C2961.58 2426.98 2961.58 2427.66 2961.11 2427.93L2945.14 2437.02C2944.63 2437.31 2943.99 2437.31 2943.48 2437.01Z",
    fill: "url(#paint178_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 71_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-23_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-24_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-200_2",
    d: "M2979.4 2461.7L2957.27 2448.86C2956.78 2448.58 2956.47 2444.49 2956.96 2444.21L2973.32 2438.47C2973.76 2438.22 2974.31 2438.22 2974.75 2438.47L2997.39 2447.79C2997.85 2448.06 2997.5 2452.34 2997.03 2452.61L2981.06 2461.7C2980.55 2461.99 2979.91 2461.99 2979.4 2461.7Z",
    fill: "url(#paint179_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-25_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-26_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-201_2",
    d: "M2979.4 2457.87L2957.27 2445.03C2956.78 2444.75 2956.79 2444.06 2957.27 2443.78L2973.32 2434.65C2973.76 2434.39 2974.31 2434.39 2974.75 2434.65L2997.04 2447.57C2997.5 2447.83 2997.5 2448.51 2997.03 2448.78L2981.06 2457.87C2980.55 2458.17 2979.91 2458.17 2979.4 2457.87Z",
    fill: "url(#paint180_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 82_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-27_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-28_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-202_2",
    d: "M3015.32 2482.55L2993.19 2469.73C2992.71 2469.45 2992.39 2465.34 2992.88 2465.06L3009.24 2459.33C3009.68 2459.07 3010.23 2459.07 3010.67 2459.34L3033.31 2468.65C3033.77 2468.91 3033.42 2473.19 3032.96 2473.46L3016.98 2482.57C3016.47 2482.86 3015.84 2482.85 3015.32 2482.55Z",
    fill: "url(#paint181_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-29_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-30_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-203_2",
    d: "M3015.32 2478.73L2993.19 2465.9C2992.71 2465.62 2992.71 2464.91 2993.19 2464.63L3009.24 2455.5C3009.68 2455.25 3010.23 2455.25 3010.67 2455.5L3032.96 2468.42C3033.42 2468.7 3033.42 2469.37 3032.96 2469.63L3016.98 2478.73C3016.47 2479.02 3015.84 2479.02 3015.32 2478.73Z",
    fill: "url(#paint182_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 88_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-31_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-32_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-204_2",
    d: "M3051.24 2503.41L3029.11 2490.58C3028.63 2490.3 3028.32 2486.21 3028.8 2485.93L3045.16 2480.19C3045.6 2479.94 3046.15 2479.94 3046.59 2480.19L3069.23 2489.5C3069.69 2489.78 3069.34 2494.06 3068.88 2494.33L3052.9 2503.42C3052.39 2503.71 3051.76 2503.71 3051.24 2503.41Z",
    fill: "url(#paint183_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-33_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-34_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-205_2",
    d: "M3051.24 2499.58L3029.11 2486.75C3028.63 2486.47 3028.63 2485.78 3029.11 2485.5L3045.16 2476.35C3045.6 2476.1 3046.15 2476.11 3046.59 2476.37L3068.88 2489.29C3069.35 2489.55 3069.34 2490.22 3068.88 2490.5L3052.9 2499.59C3052.39 2499.89 3051.76 2499.89 3051.24 2499.58Z",
    fill: "url(#paint184_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 89_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-35_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-36_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-206_2",
    d: "M3087.16 2524.27L3065.03 2511.43C3064.55 2511.15 3064.24 2507.06 3064.72 2506.78L3081.08 2501.05C3081.52 2500.79 3082.07 2500.79 3082.51 2501.05L3105.15 2510.37C3105.62 2510.63 3105.26 2514.91 3104.8 2515.18L3088.82 2524.27C3088.31 2524.57 3087.68 2524.57 3087.16 2524.27Z",
    fill: "url(#paint185_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-37_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-38_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-207_2",
    d: "M3087.17 2520.45L3065.03 2507.61C3064.55 2507.33 3064.55 2506.63 3065.03 2506.35L3081.08 2497.22C3081.53 2496.97 3082.07 2496.97 3082.51 2497.22L3104.8 2510.14C3105.27 2510.41 3105.27 2511.09 3104.8 2511.35L3088.82 2520.45C3088.31 2520.74 3087.68 2520.74 3087.17 2520.45Z",
    fill: "url(#paint186_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 100_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-39_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-40_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-208_2",
    d: "M3123.09 2545.13L3100.95 2532.3C3100.47 2532.02 3100.16 2527.91 3100.64 2527.63L3117 2521.9C3117.45 2521.65 3117.99 2521.65 3118.44 2521.9L3141.07 2531.22C3141.54 2531.49 3141.19 2535.77 3140.72 2536.03L3124.74 2545.13C3124.23 2545.43 3123.6 2545.42 3123.09 2545.13Z",
    fill: "url(#paint187_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-41_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-42_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-209_2",
    d: "M3123.09 2541.3L3100.95 2528.46C3100.47 2528.18 3100.47 2527.49 3100.95 2527.21L3117 2518.07C3117.45 2517.82 3117.99 2517.82 3118.44 2518.07L3140.72 2530.99C3141.19 2531.27 3141.19 2531.94 3140.72 2532.21L3124.74 2541.3C3124.23 2541.59 3123.6 2541.59 3123.09 2541.3Z",
    fill: "url(#paint188_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 106_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-43_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-44_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-210_2",
    d: "M3159.01 2565.98L3136.87 2553.15C3136.39 2552.87 3136.08 2548.77 3136.56 2548.5L3152.92 2542.77C3153.37 2542.5 3153.91 2542.5 3154.36 2542.77L3176.99 2552.07C3177.46 2552.34 3177.11 2556.63 3176.64 2556.9L3160.67 2565.99C3160.15 2566.29 3159.52 2566.29 3159.01 2565.98Z",
    fill: "url(#paint189_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-45_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-46_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-211_2",
    d: "M3159.01 2562.15L3136.87 2549.32C3136.39 2549.04 3136.39 2548.34 3136.87 2548.07L3152.92 2538.92C3153.37 2538.67 3153.91 2538.67 3154.36 2538.94L3176.64 2551.86C3177.11 2552.12 3177.11 2552.79 3176.64 2553.06L3160.67 2562.16C3160.15 2562.46 3159.52 2562.46 3159.01 2562.15Z",
    fill: "url(#paint190_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 113_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-51_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-52_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-214_2",
    d: "M3230.85 2607.7L3208.71 2594.87C3208.23 2594.59 3207.92 2590.49 3208.4 2590.21L3224.76 2584.47C3225.21 2584.22 3225.76 2584.22 3226.2 2584.47L3248.83 2593.79C3249.3 2594.06 3248.95 2598.34 3248.48 2598.61L3232.51 2607.7C3231.99 2607.99 3231.36 2607.99 3230.85 2607.7Z",
    fill: "url(#paint191_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-53_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-54_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-215_2",
    d: "M3230.85 2603.87L3208.71 2591.03C3208.23 2590.75 3208.23 2590.06 3208.72 2589.78L3224.76 2580.65C3225.21 2580.39 3225.75 2580.39 3226.2 2580.65L3248.48 2593.57C3248.95 2593.83 3248.95 2594.51 3248.48 2594.78L3232.51 2603.87C3231.99 2604.17 3231.36 2604.17 3230.85 2603.87Z",
    fill: "url(#paint192_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 124_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-55_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-56_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-216_2",
    d: "M3266.77 2628.55L3244.63 2615.73C3244.15 2615.45 3243.84 2611.34 3244.33 2611.07L3260.68 2605.33C3261.13 2605.07 3261.68 2605.07 3262.12 2605.34L3284.75 2614.65C3285.22 2614.91 3284.87 2619.19 3284.4 2619.47L3268.43 2628.57C3267.92 2628.86 3267.28 2628.86 3266.77 2628.55Z",
    fill: "url(#paint193_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-57_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-58_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-217_2",
    d: "M3266.77 2624.73L3244.63 2611.9C3244.15 2611.62 3244.15 2610.91 3244.64 2610.65L3260.68 2601.5C3261.13 2601.25 3261.68 2601.25 3262.12 2601.51L3284.41 2614.43C3284.87 2614.7 3284.87 2615.37 3284.4 2615.63L3268.43 2624.73C3267.92 2625.03 3267.28 2625.02 3266.77 2624.73Z",
    fill: "url(#paint194_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 125_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-59_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-60_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-218_2",
    d: "M3302.69 2649.42L3280.56 2636.58C3280.07 2636.3 3279.76 2632.2 3280.25 2631.92L3296.61 2626.19C3297.05 2625.94 3297.6 2625.94 3298.04 2626.19L3320.68 2635.5C3321.14 2635.78 3320.79 2640.06 3320.32 2640.32L3304.35 2649.42C3303.84 2649.71 3303.2 2649.71 3302.69 2649.42Z",
    fill: "url(#paint195_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-61_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-62_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-219_2",
    d: "M3302.69 2645.58L3280.56 2632.75C3280.07 2632.47 3280.07 2631.78 3280.56 2631.5L3296.61 2622.36C3297.05 2622.11 3297.6 2622.11 3298.04 2622.36L3320.33 2635.28C3320.79 2635.55 3320.79 2636.23 3320.32 2636.5L3304.35 2645.59C3303.84 2645.88 3303.2 2645.88 3302.69 2645.58Z",
    fill: "url(#paint196_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 57_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-63_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-64_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-220_2",
    d: "M2838.99 2418.07L2816.86 2405.23C2816.37 2404.95 2816.06 2400.86 2816.55 2400.58L2832.91 2394.85C2833.35 2394.59 2833.9 2394.59 2834.34 2394.85L2856.98 2404.15C2857.44 2404.43 2857.09 2408.71 2856.62 2408.98L2840.65 2418.07C2840.14 2418.37 2839.5 2418.37 2838.99 2418.07Z",
    fill: "url(#paint197_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-65_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-66_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-221_2",
    d: "M2838.99 2414.25L2816.86 2401.41C2816.37 2401.13 2816.37 2400.43 2816.86 2400.15L2832.91 2391.02C2833.35 2390.77 2833.9 2390.77 2834.34 2391.02L2856.63 2403.94C2857.09 2404.21 2857.09 2404.89 2856.62 2405.15L2840.65 2414.25C2840.14 2414.54 2839.5 2414.54 2838.99 2414.25Z",
    fill: "url(#paint198_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 63_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-67_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-68_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-222_2",
    d: "M2874.91 2438.93L2852.78 2426.1C2852.29 2425.82 2851.98 2421.71 2852.47 2421.43L2868.83 2415.7C2869.27 2415.45 2869.82 2415.45 2870.26 2415.7L2892.9 2425.02C2893.36 2425.29 2893.01 2429.57 2892.54 2429.83L2876.57 2438.93C2876.06 2439.22 2875.43 2439.22 2874.91 2438.93Z",
    fill: "url(#paint199_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-69_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-70_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-223_2",
    d: "M2874.91 2435.1L2852.78 2422.26C2852.29 2421.98 2852.3 2421.29 2852.78 2421.01L2868.83 2411.87C2869.27 2411.62 2869.82 2411.62 2870.26 2411.87L2892.55 2424.79C2893.01 2425.06 2893.01 2425.74 2892.54 2426.01L2876.57 2435.1C2876.06 2435.39 2875.43 2435.39 2874.91 2435.1Z",
    fill: "url(#paint200_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 69_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-71_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-72_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-224_2",
    d: "M2910.83 2459.78L2888.7 2446.95C2888.21 2446.67 2887.9 2442.57 2888.39 2442.3L2904.75 2436.55C2905.19 2436.3 2905.74 2436.3 2906.18 2436.57L2928.82 2445.87C2929.28 2446.14 2928.93 2450.42 2928.47 2450.7L2912.49 2459.79C2911.98 2460.09 2911.35 2460.09 2910.83 2459.78Z",
    fill: "url(#paint201_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-73_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-74_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-225_2",
    d: "M2910.83 2455.95L2888.7 2443.13C2888.21 2442.85 2888.22 2442.14 2888.7 2441.87L2904.75 2432.73C2905.19 2432.47 2905.74 2432.47 2906.18 2432.74L2928.47 2445.66C2928.93 2445.93 2928.93 2446.59 2928.47 2446.86L2912.49 2455.95C2911.98 2456.26 2911.35 2456.25 2910.83 2455.95Z",
    fill: "url(#paint202_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 72_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-75_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-76_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-226_2",
    d: "M2946.75 2480.65L2924.62 2467.81C2924.14 2467.53 2923.83 2463.43 2924.31 2463.15L2940.67 2457.42C2941.11 2457.17 2941.66 2457.17 2942.1 2457.42L2964.74 2466.73C2965.2 2467.01 2964.85 2471.29 2964.39 2471.55L2948.41 2480.65C2947.9 2480.94 2947.27 2480.94 2946.75 2480.65Z",
    fill: "url(#paint203_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-77_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-78_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-227_2",
    d: "M2946.75 2476.8L2924.62 2463.98C2924.14 2463.7 2924.14 2463 2924.62 2462.72L2940.67 2453.59C2941.11 2453.34 2941.66 2453.34 2942.1 2453.59L2964.39 2466.51C2964.86 2466.78 2964.85 2467.46 2964.39 2467.72L2948.41 2476.82C2947.9 2477.11 2947.27 2477.11 2946.75 2476.8Z",
    fill: "url(#paint204_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 81_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-79_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-80_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-228_2",
    d: "M2982.68 2501.5L2960.54 2488.67C2960.06 2488.39 2959.75 2484.29 2960.23 2484.01L2976.59 2478.27C2977.03 2478.02 2977.58 2478.02 2978.03 2478.27L3000.66 2487.59C3001.13 2487.86 3000.77 2492.14 3000.31 2492.4L2984.33 2501.5C2983.82 2501.79 2983.19 2501.79 2982.68 2501.5Z",
    fill: "url(#paint205_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-81_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-82_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-229_2",
    d: "M2982.68 2497.67L2960.54 2484.83C2960.06 2484.55 2960.06 2483.86 2960.54 2483.58L2976.59 2474.45C2977.03 2474.19 2977.58 2474.19 2978.02 2474.45L3000.31 2487.37C3000.78 2487.63 3000.77 2488.31 3000.31 2488.58L2984.33 2497.67C2983.82 2497.97 2983.19 2497.97 2982.68 2497.67Z",
    fill: "url(#paint206_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 87_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-83_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-84_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-230_2",
    d: "M3018.6 2522.35L2996.46 2509.53C2995.98 2509.25 2995.67 2505.14 2996.15 2504.86L3012.51 2499.13C3012.96 2498.87 3013.5 2498.87 3013.95 2499.14L3036.58 2508.45C3037.04 2508.71 3036.7 2512.99 3036.23 2513.26L3020.26 2522.37C3019.74 2522.66 3019.11 2522.66 3018.6 2522.35Z",
    fill: "url(#paint207_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-85_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-86_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-231_2",
    d: "M3018.6 2518.53L2996.46 2505.7C2995.98 2505.42 2995.98 2504.71 2996.46 2504.43L3012.51 2495.3C3012.96 2495.05 3013.5 2495.05 3013.95 2495.3L3036.23 2508.22C3036.7 2508.5 3036.7 2509.17 3036.23 2509.43L3020.26 2518.53C3019.74 2518.83 3019.11 2518.82 3018.6 2518.53Z",
    fill: "url(#paint208_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 90_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-87_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-88_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-232_2",
    d: "M3054.52 2543.22L3032.38 2530.38C3031.9 2530.1 3031.59 2526.01 3032.07 2525.73L3048.43 2519.99C3048.88 2519.73 3049.42 2519.74 3049.87 2519.99L3072.5 2529.3C3072.97 2529.57 3072.62 2533.86 3072.15 2534.13L3056.18 2543.22C3055.66 2543.51 3055.03 2543.51 3054.52 2543.22Z",
    fill: "url(#paint209_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-89_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-90_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-233_2",
    d: "M3054.52 2539.38L3032.38 2526.55C3031.9 2526.27 3031.9 2525.58 3032.38 2525.3L3048.43 2516.15C3048.88 2515.9 3049.42 2515.9 3049.87 2516.16L3072.15 2529.08C3072.62 2529.35 3072.62 2530.03 3072.15 2530.3L3056.18 2539.39C3055.66 2539.68 3055.03 2539.68 3054.52 2539.38Z",
    fill: "url(#paint210_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 99_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-91_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-92_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-234_2",
    d: "M3090.44 2564.07L3068.3 2551.23C3067.82 2550.95 3067.51 2546.86 3067.99 2546.58L3084.35 2540.84C3084.8 2540.59 3085.34 2540.59 3085.79 2540.84L3108.42 2550.16C3108.89 2550.43 3108.54 2554.71 3108.07 2554.98L3092.1 2564.07C3091.58 2564.36 3090.95 2564.36 3090.44 2564.07Z",
    fill: "url(#paint211_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-93_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-94_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-235_2",
    d: "M3090.44 2560.25L3068.3 2547.41C3067.82 2547.13 3067.82 2546.43 3068.31 2546.15L3084.35 2537.02C3084.8 2536.77 3085.35 2536.77 3085.79 2537.02L3108.07 2549.94C3108.54 2550.21 3108.54 2550.89 3108.07 2551.15L3092.1 2560.25C3091.58 2560.54 3090.95 2560.54 3090.44 2560.25Z",
    fill: "url(#paint212_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 105_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-95_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-96_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-236_2",
    d: "M3126.36 2584.93L3104.22 2572.1C3103.74 2571.82 3103.43 2567.71 3103.91 2567.43L3120.27 2561.7C3120.72 2561.45 3121.26 2561.45 3121.71 2561.71L3144.34 2571.02C3144.81 2571.29 3144.46 2575.57 3143.99 2575.83L3128.02 2584.94C3127.5 2585.23 3126.87 2585.22 3126.36 2584.93Z",
    fill: "url(#paint213_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-97_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-98_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-237_2",
    d: "M3126.36 2581.1L3104.22 2568.27C3103.74 2567.99 3103.74 2567.29 3104.23 2567.01L3120.27 2557.87C3120.72 2557.62 3121.26 2557.62 3121.71 2557.87L3144 2570.79C3144.46 2571.07 3144.46 2571.74 3143.99 2572.01L3128.02 2581.1C3127.5 2581.39 3126.87 2581.39 3126.36 2581.1Z",
    fill: "url(#paint214_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 111_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-99_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-100_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-238_3",
    d: "M3162.28 2605.78L3140.14 2592.95C3139.66 2592.67 3139.35 2588.57 3139.84 2588.3L3156.19 2582.55C3156.64 2582.3 3157.19 2582.31 3157.63 2582.57L3180.26 2591.87C3180.73 2592.14 3180.38 2596.43 3179.91 2596.7L3163.94 2605.79C3163.42 2606.09 3162.79 2606.09 3162.28 2605.78Z",
    fill: "url(#paint215_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-101_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-102_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-239_3",
    d: "M3162.28 2601.95L3140.14 2589.13C3139.66 2588.85 3139.66 2588.14 3140.15 2587.87L3156.19 2578.73C3156.64 2578.47 3157.19 2578.47 3157.63 2578.74L3179.92 2591.66C3180.38 2591.93 3180.38 2592.59 3179.91 2592.86L3163.94 2601.97C3163.42 2602.26 3162.79 2602.26 3162.28 2601.95Z",
    fill: "url(#paint216_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 132_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-99_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-100_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-238_4",
    d: "M3192.69 2586.47L3170.55 2573.65C3170.07 2573.37 3169.76 2569.26 3170.24 2568.99L3186.6 2563.25C3187.05 2562.99 3187.59 2563.01 3188.04 2563.26L3210.67 2572.57C3211.14 2572.83 3210.79 2577.13 3210.32 2577.39L3194.35 2586.49C3193.83 2586.78 3193.2 2586.78 3192.69 2586.47Z",
    fill: "url(#paint217_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-101_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-102_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-239_4",
    d: "M3192.69 2582.65L3170.55 2569.82C3170.07 2569.54 3170.07 2568.83 3170.56 2568.57L3186.6 2559.42C3187.05 2559.17 3187.59 2559.17 3188.04 2559.43L3210.32 2572.35C3210.79 2572.62 3210.79 2573.29 3210.32 2573.55L3194.35 2582.66C3193.83 2582.95 3193.2 2582.95 3192.69 2582.65Z",
    fill: "url(#paint218_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 114_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-103_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-104_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-240_2",
    d: "M3198.2 2626.64L3176.07 2613.8C3175.58 2613.52 3175.27 2609.43 3175.76 2609.15L3192.12 2603.42C3192.56 2603.16 3193.11 2603.16 3193.55 2603.42L3216.18 2612.72C3216.65 2613 3216.3 2617.28 3215.83 2617.55L3199.86 2626.64C3199.35 2626.94 3198.71 2626.94 3198.2 2626.64Z",
    fill: "url(#paint219_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-105_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-106_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-241_2",
    d: "M3198.2 2622.82L3176.07 2609.98C3175.58 2609.7 3175.58 2609 3176.07 2608.72L3192.11 2599.59C3192.56 2599.34 3193.11 2599.34 3193.55 2599.59L3215.84 2612.51C3216.3 2612.78 3216.3 2613.46 3215.83 2613.72L3199.86 2622.82C3199.35 2623.11 3198.71 2623.11 3198.2 2622.82Z",
    fill: "url(#paint220_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 123_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-107_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-108_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-242_2",
    d: "M3234.12 2647.5L3211.99 2634.67C3211.5 2634.39 3211.19 2630.29 3211.68 2630.01L3228.04 2624.27C3228.48 2624.02 3229.03 2624.02 3229.47 2624.27L3252.11 2633.59C3252.57 2633.86 3252.22 2638.14 3251.75 2638.4L3235.78 2647.5C3235.27 2647.79 3234.63 2647.79 3234.12 2647.5Z",
    fill: "url(#paint221_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-109_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-110_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-243_2",
    d: "M3234.12 2643.67L3211.99 2630.83C3211.5 2630.55 3211.51 2629.86 3211.99 2629.58L3228.04 2620.45C3228.48 2620.19 3229.03 2620.19 3229.47 2620.45L3251.76 2633.37C3252.22 2633.65 3252.22 2634.31 3251.75 2634.58L3235.78 2643.67C3235.27 2643.97 3234.63 2643.97 3234.12 2643.67Z",
    fill: "url(#paint222_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 126_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-111_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-112_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-244_2",
    d: "M3270.04 2668.35L3247.91 2655.53C3247.43 2655.25 3247.11 2651.14 3247.6 2650.87L3263.96 2645.13C3264.4 2644.87 3264.95 2644.87 3265.39 2645.14L3288.03 2654.45C3288.49 2654.71 3288.14 2659.01 3287.68 2659.27L3271.7 2668.37C3271.19 2668.66 3270.56 2668.66 3270.04 2668.35Z",
    fill: "url(#paint223_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-113_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-114_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-245_2",
    d: "M3270.04 2664.53L3247.91 2651.7C3247.42 2651.42 3247.43 2650.71 3247.91 2650.45L3263.96 2641.3C3264.4 2641.05 3264.95 2641.05 3265.39 2641.31L3287.68 2654.23C3288.14 2654.5 3288.14 2655.17 3287.68 2655.43L3271.7 2664.54C3271.19 2664.83 3270.56 2664.83 3270.04 2664.53Z",
    fill: "url(#paint224_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 56_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-115_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-116_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-246_2",
    d: "M2806.34 2437.01L2784.21 2424.18C2783.72 2423.9 2783.41 2419.79 2783.9 2419.53L2800.26 2413.78C2800.7 2413.53 2801.25 2413.54 2801.69 2413.79L2824.33 2423.1C2824.79 2423.37 2824.44 2427.66 2823.98 2427.93L2808 2437.02C2807.49 2437.31 2806.86 2437.31 2806.34 2437.01Z",
    fill: "url(#paint225_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-117_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-118_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-247_2",
    d: "M2806.34 2433.18L2784.21 2420.35C2783.72 2420.07 2783.73 2419.37 2784.21 2419.1L2800.26 2409.95C2800.7 2409.7 2801.25 2409.7 2801.69 2409.97L2823.98 2422.89C2824.45 2423.15 2824.44 2423.82 2823.98 2424.09L2808 2433.19C2807.49 2433.49 2806.86 2433.49 2806.34 2433.18Z",
    fill: "url(#paint226_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 62_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-119_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-120_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-248_2",
    d: "M2842.26 2457.87L2820.13 2445.03C2819.65 2444.75 2819.33 2440.66 2819.82 2440.38L2836.18 2434.65C2836.62 2434.39 2837.17 2434.39 2837.61 2434.65L2860.25 2443.95C2860.71 2444.23 2860.36 2448.51 2859.9 2448.78L2843.92 2457.87C2843.41 2458.17 2842.78 2458.17 2842.26 2457.87Z",
    fill: "url(#paint227_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-121_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-122_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-249_2",
    d: "M2842.26 2454.05L2820.13 2441.21C2819.65 2440.93 2819.65 2440.23 2820.13 2439.95L2836.18 2430.82C2836.62 2430.57 2837.17 2430.57 2837.61 2430.82L2859.9 2443.74C2860.37 2444.01 2860.36 2444.69 2859.9 2444.95L2843.92 2454.05C2843.41 2454.34 2842.78 2454.34 2842.26 2454.05Z",
    fill: "url(#paint228_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 68_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-123_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-124_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-250_2",
    d: "M2878.19 2478.73L2856.05 2465.9C2855.57 2465.62 2855.26 2461.51 2855.74 2461.23L2872.1 2455.5C2872.54 2455.25 2873.09 2455.25 2873.53 2455.5L2896.17 2464.82C2896.63 2465.09 2896.29 2469.37 2895.82 2469.63L2879.84 2478.73C2879.33 2479.02 2878.7 2479.02 2878.19 2478.73Z",
    fill: "url(#paint229_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-125_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-126_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-251_2",
    d: "M2878.18 2474.9L2856.05 2462.06C2855.57 2461.78 2855.57 2461.09 2856.05 2460.81L2872.1 2451.67C2872.54 2451.42 2873.09 2451.42 2873.53 2451.67L2895.82 2464.59C2896.29 2464.87 2896.28 2465.54 2895.82 2465.81L2879.84 2474.9C2879.33 2475.19 2878.7 2475.19 2878.18 2474.9Z",
    fill: "url(#paint230_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 73_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-127_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-128_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-252_2",
    d: "M2914.1 2499.58L2891.97 2486.75C2891.49 2486.47 2891.18 2482.37 2891.66 2482.1L2908.02 2476.35C2908.46 2476.1 2909.01 2476.11 2909.46 2476.37L2932.09 2485.67C2932.56 2485.94 2932.21 2490.22 2931.74 2490.5L2915.76 2499.59C2915.25 2499.89 2914.62 2499.89 2914.1 2499.58Z",
    fill: "url(#paint231_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-129_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-130_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-253_2",
    d: "M2914.1 2495.75L2891.97 2482.93C2891.49 2482.65 2891.49 2481.94 2891.97 2481.67L2908.02 2472.53C2908.47 2472.27 2909.01 2472.27 2909.46 2472.54L2931.74 2485.46C2932.21 2485.73 2932.21 2486.39 2931.74 2486.66L2915.77 2495.77C2915.25 2496.06 2914.62 2496.06 2914.1 2495.75Z",
    fill: "url(#paint232_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 80_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-131_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-132_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-254_2",
    d: "M2950.03 2520.45L2927.89 2507.61C2927.41 2507.33 2927.1 2503.23 2927.58 2502.95L2943.94 2497.22C2944.39 2496.97 2944.93 2496.97 2945.38 2497.22L2968.01 2506.53C2968.48 2506.81 2968.13 2511.09 2967.66 2511.35L2951.69 2520.45C2951.17 2520.74 2950.54 2520.74 2950.03 2520.45Z",
    fill: "url(#paint233_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-133_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-134_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-255_2",
    d: "M2950.03 2516.61L2927.89 2503.78C2927.41 2503.5 2927.41 2502.81 2927.9 2502.53L2943.94 2493.39C2944.39 2493.13 2944.93 2493.14 2945.38 2493.39L2967.66 2506.31C2968.13 2506.58 2968.13 2507.26 2967.66 2507.53L2951.69 2516.62C2951.17 2516.91 2950.54 2516.91 2950.03 2516.61Z",
    fill: "url(#paint234_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 86_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-135_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-136_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-256_2",
    d: "M2985.95 2541.3L2963.81 2528.46C2963.33 2528.18 2963.02 2524.09 2963.5 2523.81L2979.86 2518.07C2980.31 2517.82 2980.85 2517.82 2981.3 2518.07L3003.93 2527.39C3004.4 2527.66 3004.05 2531.94 3003.58 2532.21L2987.61 2541.3C2987.09 2541.59 2986.46 2541.59 2985.95 2541.3Z",
    fill: "url(#paint235_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-137_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-138_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-257_2",
    d: "M2985.95 2537.47L2963.81 2524.63C2963.33 2524.35 2963.33 2523.66 2963.82 2523.38L2979.86 2514.25C2980.31 2513.99 2980.85 2513.99 2981.3 2514.25L3003.58 2527.17C3004.05 2527.45 3004.05 2528.11 3003.58 2528.38L2987.61 2537.47C2987.09 2537.77 2986.46 2537.77 2985.95 2537.47Z",
    fill: "url(#paint236_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 91_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-139_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-140_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-258_2",
    d: "M3021.87 2562.15L2999.73 2549.32C2999.25 2549.04 2998.94 2544.94 2999.43 2544.67L3015.78 2538.92C3016.23 2538.67 3016.78 2538.67 3017.22 2538.94L3039.85 2548.24C3040.32 2548.51 3039.97 2552.79 3039.5 2553.06L3023.53 2562.16C3023.01 2562.46 3022.38 2562.46 3021.87 2562.15Z",
    fill: "url(#paint237_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-141_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-142_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-259_2",
    d: "M3021.87 2558.33L2999.73 2545.5C2999.25 2545.22 2999.25 2544.51 2999.74 2544.23L3015.78 2535.1C3016.23 2534.85 3016.78 2534.85 3017.22 2535.11L3039.51 2548.03C3039.97 2548.3 3039.97 2548.97 3039.5 2549.23L3023.53 2558.34C3023.01 2558.62 3022.38 2558.62 3021.87 2558.33Z",
    fill: "url(#paint238_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 98_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-143_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-144_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-260_2",
    d: "M3057.79 2583.02L3035.65 2570.18C3035.17 2569.9 3034.86 2565.81 3035.35 2565.53L3051.71 2559.79C3052.15 2559.54 3052.7 2559.54 3053.14 2559.79L3075.77 2569.1C3076.24 2569.38 3075.89 2573.66 3075.42 2573.93L3059.45 2583.02C3058.93 2583.31 3058.3 2583.31 3057.79 2583.02Z",
    fill: "url(#paint239_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-145_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-146_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-261_2",
    d: "M3057.79 2579.18L3035.65 2566.35C3035.17 2566.07 3035.17 2565.38 3035.66 2565.1L3051.7 2555.95C3052.15 2555.7 3052.7 2555.71 3053.14 2555.97L3075.43 2568.89C3075.89 2569.15 3075.89 2569.83 3075.42 2570.1L3059.45 2579.19C3058.93 2579.49 3058.3 2579.49 3057.79 2579.18Z",
    fill: "url(#paint240_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 104_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-147_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-148_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-262_2",
    d: "M3093.71 2603.87L3071.58 2591.03C3071.09 2590.75 3070.78 2586.66 3071.27 2586.38L3087.63 2580.65C3088.07 2580.39 3088.62 2580.39 3089.06 2580.65L3111.7 2589.97C3112.16 2590.23 3111.81 2594.51 3111.34 2594.78L3095.37 2603.87C3094.86 2604.17 3094.22 2604.17 3093.71 2603.87Z",
    fill: "url(#paint241_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-149_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-150_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-263_2",
    d: "M3093.71 2600.05L3071.58 2587.21C3071.09 2586.93 3071.09 2586.23 3071.58 2585.95L3087.63 2576.82C3088.07 2576.57 3088.62 2576.57 3089.06 2576.82L3111.35 2589.74C3111.81 2590.01 3111.81 2590.69 3111.34 2590.95L3095.37 2600.05C3094.86 2600.34 3094.22 2600.34 3093.71 2600.05Z",
    fill: "url(#paint242_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 110_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-151_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-152_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-264_2",
    d: "M3129.63 2624.73L3107.5 2611.9C3107.01 2611.62 3106.7 2607.51 3107.19 2607.23L3123.55 2601.5C3123.99 2601.25 3124.54 2601.25 3124.98 2601.51L3147.62 2610.82C3148.08 2611.09 3147.73 2615.37 3147.26 2615.63L3131.29 2624.73C3130.78 2625.03 3130.14 2625.02 3129.63 2624.73Z",
    fill: "url(#paint243_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-153_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-154_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-265_2",
    d: "M3129.63 2620.9L3107.5 2608.07C3107.01 2607.79 3107.02 2607.08 3107.5 2606.8L3123.55 2597.67C3123.99 2597.42 3124.54 2597.42 3124.98 2597.67L3147.27 2610.59C3147.73 2610.87 3147.73 2611.54 3147.26 2611.8L3131.29 2620.9C3130.78 2621.19 3130.14 2621.19 3129.63 2620.9Z",
    fill: "url(#paint244_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 115_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-155_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-156_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-266_2",
    d: "M3165.55 2645.58L3143.42 2632.75C3142.93 2632.47 3142.62 2628.38 3143.11 2628.1L3159.47 2622.37C3159.91 2622.11 3160.46 2622.11 3160.9 2622.37L3183.54 2631.67C3184 2631.94 3183.65 2636.23 3183.18 2636.5L3167.21 2645.59C3166.7 2645.89 3166.07 2645.89 3165.55 2645.58Z",
    fill: "url(#paint245_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-157_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-158_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-267_2",
    d: "M3165.55 2641.75L3143.42 2628.93C3142.93 2628.65 3142.94 2627.94 3143.42 2627.67L3159.47 2618.53C3159.91 2618.27 3160.46 2618.27 3160.9 2618.54L3183.19 2631.46C3183.65 2631.73 3183.65 2632.39 3183.18 2632.67L3167.21 2641.77C3166.7 2642.06 3166.07 2642.06 3165.55 2641.75Z",
    fill: "url(#paint246_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 122_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-159_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-160_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-268_3",
    d: "M3201.47 2666.44L3179.34 2653.6C3178.85 2653.32 3178.54 2649.23 3179.03 2648.95L3195.39 2643.22C3195.83 2642.96 3196.38 2642.96 3196.82 2643.22L3219.46 2652.52C3219.92 2652.8 3219.57 2657.08 3219.11 2657.35L3203.13 2666.44C3202.62 2666.74 3201.99 2666.74 3201.47 2666.44Z",
    fill: "url(#paint247_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-161_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-162_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-269_3",
    d: "M3201.47 2662.62L3179.34 2649.78C3178.85 2649.5 3178.86 2648.8 3179.34 2648.52L3195.39 2639.39C3195.83 2639.14 3196.38 2639.14 3196.82 2639.39L3219.11 2652.31C3219.57 2652.58 3219.57 2653.26 3219.11 2653.52L3203.13 2662.62C3202.62 2662.91 3201.99 2662.91 3201.47 2662.62Z",
    fill: "url(#paint248_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 131_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-159_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-160_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-268_4",
    d: "M3236.69 2685.48L3214.55 2672.64C3214.07 2672.36 3213.76 2668.26 3214.24 2667.98L3230.6 2662.25C3231.05 2662 3231.59 2662 3232.04 2662.25L3254.67 2671.56C3255.14 2671.84 3254.79 2676.12 3254.32 2676.38L3238.35 2685.48C3237.83 2685.77 3237.2 2685.77 3236.69 2685.48Z",
    fill: "url(#paint249_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-161_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-162_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-269_4",
    d: "M3236.69 2681.65L3214.55 2668.81C3214.07 2668.53 3214.07 2667.84 3214.56 2667.56L3230.6 2658.42C3231.05 2658.17 3231.59 2658.17 3232.04 2658.42L3254.32 2671.34C3254.79 2671.61 3254.79 2672.29 3254.32 2672.56L3238.35 2681.65C3237.83 2681.94 3237.2 2681.94 3236.69 2681.65Z",
    fill: "url(#paint250_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 55_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-167_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-168_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-272_2",
    d: "M2773.69 2455.95L2751.56 2443.13C2751.08 2442.85 2750.77 2438.74 2751.25 2438.46L2767.61 2432.73C2768.06 2432.47 2768.6 2432.47 2769.05 2432.74L2791.68 2442.05C2792.15 2442.31 2791.79 2446.59 2791.33 2446.86L2775.35 2455.95C2774.84 2456.26 2774.21 2456.25 2773.69 2455.95Z",
    fill: "url(#paint251_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-169_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-170_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-273_2",
    d: "M2773.69 2452.13L2751.56 2439.3C2751.08 2439.02 2751.08 2438.31 2751.56 2438.03L2767.61 2428.9C2768.05 2428.65 2768.6 2428.65 2769.05 2428.9L2791.33 2441.82C2791.8 2442.1 2791.79 2442.77 2791.33 2443.03L2775.35 2452.13C2774.84 2452.42 2774.21 2452.42 2773.69 2452.13Z",
    fill: "url(#paint252_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 61_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-171_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-172_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-274_2",
    d: "M2809.62 2476.8L2787.48 2463.98C2787 2463.7 2786.69 2459.6 2787.17 2459.32L2803.53 2453.59C2803.98 2453.34 2804.52 2453.34 2804.96 2453.59L2827.6 2462.9C2828.07 2463.16 2827.72 2467.46 2827.25 2467.72L2811.27 2476.82C2810.76 2477.11 2810.13 2477.11 2809.62 2476.8Z",
    fill: "url(#paint253_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-173_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-174_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-275_2",
    d: "M2809.62 2472.98L2787.48 2460.15C2787 2459.87 2787 2459.17 2787.48 2458.9L2803.53 2449.75C2803.98 2449.5 2804.52 2449.5 2804.96 2449.77L2827.25 2462.69C2827.72 2462.95 2827.72 2463.62 2827.25 2463.89L2811.27 2472.99C2810.76 2473.29 2810.13 2473.29 2809.62 2472.98Z",
    fill: "url(#paint254_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 67_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-175_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-176_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-276_2",
    d: "M2845.54 2497.67L2823.4 2484.83C2822.92 2484.55 2822.61 2480.46 2823.09 2480.18L2839.45 2474.45C2839.9 2474.19 2840.44 2474.19 2840.89 2474.45L2863.52 2483.75C2863.99 2484.03 2863.64 2488.31 2863.17 2488.58L2847.2 2497.67C2846.68 2497.97 2846.05 2497.97 2845.54 2497.67Z",
    fill: "url(#paint255_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-177_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-178_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-277_2",
    d: "M2845.54 2493.84L2823.4 2481C2822.92 2480.72 2822.92 2480.03 2823.41 2479.75L2839.45 2470.62C2839.9 2470.37 2840.44 2470.37 2840.89 2470.62L2863.17 2483.54C2863.64 2483.8 2863.64 2484.48 2863.17 2484.75L2847.2 2493.84C2846.68 2494.14 2846.05 2494.14 2845.54 2493.84Z",
    fill: "url(#paint256_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 74_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-179_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-180_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-278_2",
    d: "M2881.46 2518.53L2859.32 2505.7C2858.84 2505.42 2858.53 2501.31 2859.01 2501.03L2875.37 2495.3C2875.82 2495.05 2876.36 2495.05 2876.81 2495.3L2899.44 2504.62C2899.91 2504.89 2899.56 2509.17 2899.09 2509.43L2883.12 2518.53C2882.6 2518.83 2881.97 2518.82 2881.46 2518.53Z",
    fill: "url(#paint257_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-181_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-182_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-279_2",
    d: "M2881.46 2514.7L2859.32 2501.86C2858.84 2501.58 2858.84 2500.89 2859.33 2500.61L2875.37 2491.47C2875.82 2491.22 2876.36 2491.22 2876.81 2491.47L2899.09 2504.39C2899.56 2504.67 2899.56 2505.34 2899.09 2505.61L2883.12 2514.7C2882.6 2514.99 2881.97 2514.99 2881.46 2514.7Z",
    fill: "url(#paint258_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 79_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-183_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-184_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-280_2",
    d: "M2917.38 2539.38L2895.24 2526.55C2894.76 2526.27 2894.45 2522.16 2894.93 2521.9L2911.29 2516.15C2911.74 2515.9 2912.29 2515.9 2912.73 2516.16L2935.36 2525.47C2935.83 2525.74 2935.48 2530.03 2935.01 2530.3L2919.04 2539.39C2918.52 2539.68 2917.89 2539.68 2917.38 2539.38Z",
    fill: "url(#paint259_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-185_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-186_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-281_2",
    d: "M2917.38 2535.55L2895.24 2522.73C2894.76 2522.45 2894.76 2521.74 2895.25 2521.47L2911.29 2512.33C2911.74 2512.07 2912.29 2512.07 2912.73 2512.34L2935.01 2525.26C2935.48 2525.53 2935.48 2526.19 2935.01 2526.46L2919.04 2535.57C2918.52 2535.86 2917.89 2535.85 2917.38 2535.55Z",
    fill: "url(#paint260_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 85_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-187_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-188_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-282_2",
    d: "M2953.3 2560.25L2931.17 2547.41C2930.68 2547.13 2930.37 2543.03 2930.86 2542.75L2947.21 2537.02C2947.66 2536.77 2948.21 2536.77 2948.65 2537.02L2971.28 2546.33C2971.75 2546.61 2971.4 2550.89 2970.93 2551.15L2954.96 2560.25C2954.45 2560.54 2953.81 2560.54 2953.3 2560.25Z",
    fill: "url(#paint261_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-189_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-190_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-283_2",
    d: "M2953.3 2556.42L2931.17 2543.58C2930.68 2543.3 2930.68 2542.6 2931.17 2542.32L2947.21 2533.19C2947.66 2532.94 2948.21 2532.94 2948.65 2533.19L2970.94 2546.11C2971.4 2546.38 2971.4 2547.06 2970.93 2547.32L2954.96 2556.42C2954.45 2556.71 2953.81 2556.71 2953.3 2556.42Z",
    fill: "url(#paint262_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 92_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-191_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-192_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-284_2",
    d: "M2989.22 2581.1L2967.09 2568.27C2966.6 2567.99 2966.29 2563.89 2966.78 2563.61L2983.14 2557.87C2983.58 2557.62 2984.13 2557.62 2984.57 2557.87L3007.21 2567.19C3007.67 2567.46 3007.32 2571.74 3006.85 2572.01L2990.88 2581.1C2990.37 2581.39 2989.73 2581.39 2989.22 2581.1Z",
    fill: "url(#paint263_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-193_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-194_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-285_2",
    d: "M2989.22 2577.27L2967.08 2564.43C2966.6 2564.15 2966.6 2563.46 2967.09 2563.18L2983.14 2554.05C2983.58 2553.79 2984.13 2553.79 2984.57 2554.05L3006.86 2566.97C3007.32 2567.23 3007.32 2567.91 3006.85 2568.18L2990.88 2577.27C2990.36 2577.57 2989.73 2577.57 2989.22 2577.27Z",
    fill: "url(#paint264_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 97_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-195_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-196_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-286_2",
    d: "M3025.14 2601.95L3003.01 2589.13C3002.52 2588.85 3002.21 2584.74 3002.7 2584.47L3019.06 2578.73C3019.5 2578.47 3020.05 2578.47 3020.49 2578.74L3043.13 2588.05C3043.59 2588.31 3043.24 2592.59 3042.77 2592.86L3026.8 2601.97C3026.29 2602.26 3025.65 2602.26 3025.14 2601.95Z",
    fill: "url(#paint265_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-197_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-198_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-287_2",
    d: "M3025.14 2598.13L3003.01 2585.3C3002.52 2585.02 3002.53 2584.31 3003.01 2584.05L3019.06 2574.9C3019.5 2574.65 3020.05 2574.65 3020.49 2574.91L3042.78 2587.83C3043.24 2588.1 3043.24 2588.77 3042.77 2589.03L3026.8 2598.13C3026.29 2598.43 3025.65 2598.42 3025.14 2598.13Z",
    fill: "url(#paint266_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 103_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-199_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-200_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-288_2",
    d: "M3061.06 2622.82L3038.93 2609.98C3038.45 2609.7 3038.13 2605.61 3038.62 2605.33L3054.98 2599.59C3055.42 2599.34 3055.97 2599.34 3056.41 2599.59L3079.05 2608.9C3079.51 2609.18 3079.16 2613.46 3078.7 2613.73L3062.72 2622.82C3062.21 2623.11 3061.58 2623.11 3061.06 2622.82Z",
    fill: "url(#paint267_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-201_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-202_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-289_2",
    d: "M3061.06 2618.98L3038.93 2606.15C3038.44 2605.87 3038.45 2605.18 3038.93 2604.9L3054.98 2595.76C3055.42 2595.5 3055.97 2595.51 3056.41 2595.76L3078.7 2608.68C3079.16 2608.95 3079.16 2609.63 3078.7 2609.9L3062.72 2618.99C3062.21 2619.28 3061.58 2619.28 3061.06 2618.98Z",
    fill: "url(#paint268_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 109_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-203_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-204_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-290_2",
    d: "M3096.98 2643.67L3074.85 2630.83C3074.37 2630.55 3074.05 2626.46 3074.54 2626.18L3090.9 2620.44C3091.34 2620.19 3091.89 2620.19 3092.33 2620.44L3114.97 2629.76C3115.43 2630.03 3115.08 2634.31 3114.62 2634.58L3098.64 2643.67C3098.13 2643.96 3097.5 2643.96 3096.98 2643.67Z",
    fill: "url(#paint269_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-205_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-206_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-291_2",
    d: "M3096.98 2639.84L3074.85 2627C3074.36 2626.72 3074.37 2626.03 3074.85 2625.75L3090.9 2616.62C3091.34 2616.37 3091.89 2616.37 3092.33 2616.62L3114.62 2629.54C3115.09 2629.8 3115.08 2630.48 3114.62 2630.75L3098.64 2639.84C3098.13 2640.14 3097.49 2640.14 3096.98 2639.84Z",
    fill: "url(#paint270_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 116_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-207_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-208_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-292_2",
    d: "M3132.9 2664.52L3110.77 2651.7C3110.29 2651.42 3109.98 2647.31 3110.46 2647.03L3126.82 2641.3C3127.26 2641.04 3127.81 2641.04 3128.25 2641.31L3150.89 2650.62C3151.35 2650.88 3151 2655.16 3150.54 2655.43L3134.56 2664.54C3134.05 2664.83 3133.42 2664.83 3132.9 2664.52Z",
    fill: "url(#paint271_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-209_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-210_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-293_2",
    d: "M3132.9 2660.7L3110.77 2647.87C3110.29 2647.59 3110.29 2646.88 3110.77 2646.6L3126.82 2637.47C3127.26 2637.22 3127.81 2637.22 3128.25 2637.47L3150.54 2650.39C3151.01 2650.67 3151 2651.34 3150.54 2651.6L3134.56 2660.7C3134.05 2661 3133.42 2660.99 3132.9 2660.7Z",
    fill: "url(#paint272_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 121_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-211_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-212_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-294_2",
    d: "M3168.83 2685.39L3146.69 2672.55C3146.21 2672.27 3145.9 2668.17 3146.38 2667.9L3162.74 2662.17C3163.18 2661.9 3163.73 2661.91 3164.18 2662.17L3186.81 2671.47C3187.28 2671.74 3186.93 2676.03 3186.46 2676.3L3170.48 2685.39C3169.97 2685.69 3169.34 2685.69 3168.83 2685.39Z",
    fill: "url(#paint273_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-213_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-214_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-295_2",
    d: "M3168.83 2681.55L3146.69 2668.73C3146.21 2668.45 3146.21 2667.74 3146.69 2667.47L3162.74 2658.33C3163.18 2658.07 3163.73 2658.07 3164.18 2658.34L3186.46 2671.26C3186.93 2671.53 3186.93 2672.21 3186.46 2672.47L3170.48 2681.57C3169.97 2681.86 3169.34 2681.86 3168.83 2681.55Z",
    fill: "url(#paint274_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 128_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-215_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-216_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-296_2",
    d: "M3204.75 2706.25L3182.61 2693.41C3182.13 2693.13 3181.82 2689.03 3182.3 2688.75L3198.66 2683.02C3199.11 2682.77 3199.65 2682.77 3200.1 2683.02L3222.73 2692.34C3223.2 2692.61 3222.85 2696.89 3222.38 2697.15L3206.41 2706.25C3205.89 2706.54 3205.26 2706.54 3204.75 2706.25Z",
    fill: "url(#paint275_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-217_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-218_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-297_2",
    d: "M3204.75 2702.42L3182.61 2689.58C3182.13 2689.3 3182.13 2688.6 3182.62 2688.32L3198.66 2679.19C3199.11 2678.94 3199.65 2678.94 3200.1 2679.19L3222.38 2692.11C3222.85 2692.38 3222.85 2693.06 3222.38 2693.32L3206.41 2702.42C3205.89 2702.71 3205.26 2702.71 3204.75 2702.42Z",
    fill: "url(#paint276_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 53_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 54_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-298_2",
    d: "M2741.05 2474.9L2718.91 2462.06C2718.43 2461.78 2718.12 2457.69 2718.6 2457.41L2734.96 2451.67C2735.41 2451.42 2735.95 2451.42 2736.4 2451.67L2759.03 2460.99C2759.5 2461.26 2759.15 2465.54 2758.68 2465.81L2742.71 2474.9C2742.19 2475.19 2741.56 2475.19 2741.05 2474.9Z",
    fill: "url(#paint277_linear_71_514)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g-221_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-222_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-299_2",
    d: "M2741.05 2471.07L2718.91 2458.23C2718.43 2457.95 2718.43 2457.26 2718.92 2456.98L2734.96 2447.85C2735.41 2447.59 2735.95 2447.59 2736.4 2447.85L2758.68 2460.77C2759.15 2461.03 2759.15 2461.71 2758.68 2461.98L2742.71 2471.07C2742.19 2471.37 2741.56 2471.37 2741.05 2471.07Z",
    fill: "url(#paint278_linear_71_514)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 60_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-223_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-224_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-300_2",
    d: "M2776.97 2495.75L2754.83 2482.93C2754.35 2482.65 2754.04 2478.54 2754.52 2478.26L2770.88 2472.53C2771.33 2472.27 2771.88 2472.27 2772.32 2472.54L2794.95 2481.85C2795.42 2482.11 2795.07 2486.39 2794.6 2486.66L2778.63 2495.77C2778.11 2496.06 2777.48 2496.06 2776.97 2495.75Z",
    fill: "url(#paint279_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-225_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-226_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-301_2",
    d: "M2776.97 2491.93L2754.83 2479.1C2754.35 2478.82 2754.35 2478.11 2754.84 2477.83L2770.88 2468.7C2771.33 2468.45 2771.87 2468.45 2772.32 2468.7L2794.6 2481.62C2795.07 2481.9 2795.07 2482.57 2794.6 2482.83L2778.63 2491.93C2778.11 2492.22 2777.48 2492.22 2776.97 2491.93Z",
    fill: "url(#paint280_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 66_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-227_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-228_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-302_2",
    d: "M2812.89 2516.61L2790.75 2503.78C2790.27 2503.5 2789.96 2499.39 2790.44 2499.13L2806.8 2493.39C2807.25 2493.13 2807.79 2493.14 2808.24 2493.39L2830.87 2502.7C2831.34 2502.97 2830.99 2507.26 2830.52 2507.53L2814.55 2516.62C2814.03 2516.91 2813.4 2516.91 2812.89 2516.61Z",
    fill: "url(#paint281_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-229_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-230_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-303_2",
    d: "M2812.89 2512.78L2790.75 2499.95C2790.27 2499.67 2790.27 2498.98 2790.76 2498.7L2806.8 2489.55C2807.25 2489.3 2807.79 2489.3 2808.24 2489.57L2830.53 2502.49C2830.99 2502.75 2830.99 2503.43 2830.52 2503.7L2814.55 2512.79C2814.03 2513.09 2813.4 2513.09 2812.89 2512.78Z",
    fill: "url(#paint282_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 75_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-231_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-232_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-304_2",
    d: "M2848.81 2537.47L2826.67 2524.63C2826.19 2524.35 2825.88 2520.26 2826.36 2519.98L2842.72 2514.25C2843.17 2513.99 2843.72 2513.99 2844.16 2514.25L2866.79 2523.55C2867.26 2523.83 2866.91 2528.11 2866.44 2528.38L2850.47 2537.47C2849.95 2537.77 2849.32 2537.77 2848.81 2537.47Z",
    fill: "url(#paint283_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-233_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-234_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-305_2",
    d: "M2848.81 2533.64L2826.67 2520.8C2826.19 2520.52 2826.19 2519.83 2826.68 2519.55L2842.72 2510.42C2843.17 2510.16 2843.72 2510.16 2844.16 2510.42L2866.45 2523.34C2866.91 2523.6 2866.91 2524.28 2866.44 2524.55L2850.47 2533.64C2849.95 2533.94 2849.32 2533.94 2848.81 2533.64Z",
    fill: "url(#paint284_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 78_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-235_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-236_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-306_2",
    d: "M2884.73 2558.33L2862.6 2545.5C2862.11 2545.22 2861.8 2541.11 2862.29 2540.83L2878.65 2535.1C2879.09 2534.85 2879.64 2534.85 2880.08 2535.11L2902.71 2544.42C2903.18 2544.69 2902.83 2548.97 2902.36 2549.23L2886.39 2558.34C2885.88 2558.62 2885.24 2558.62 2884.73 2558.33Z",
    fill: "url(#paint285_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-237_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-238_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-307_2",
    d: "M2884.73 2554.5L2862.6 2541.67C2862.11 2541.39 2862.11 2540.68 2862.6 2540.4L2878.65 2531.27C2879.09 2531.02 2879.64 2531.02 2880.08 2531.27L2902.37 2544.19C2902.83 2544.47 2902.83 2545.14 2902.36 2545.4L2886.39 2554.5C2885.88 2554.79 2885.24 2554.79 2884.73 2554.5Z",
    fill: "url(#paint286_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 84_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-239_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-240_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-308_2",
    d: "M2920.65 2579.18L2898.52 2566.35C2898.03 2566.07 2897.72 2561.97 2898.21 2561.7L2914.57 2555.95C2915.01 2555.7 2915.56 2555.71 2916 2555.97L2938.64 2565.27C2939.1 2565.54 2938.75 2569.83 2938.28 2570.1L2922.31 2579.19C2921.8 2579.49 2921.16 2579.49 2920.65 2579.18Z",
    fill: "url(#paint287_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-241_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-242_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-309_2",
    d: "M2920.65 2575.35L2898.52 2562.53C2898.03 2562.25 2898.04 2561.54 2898.52 2561.27L2914.57 2552.13C2915.01 2551.87 2915.56 2551.87 2916 2552.14L2938.29 2565.06C2938.75 2565.33 2938.75 2565.99 2938.28 2566.26L2922.31 2575.37C2921.8 2575.66 2921.16 2575.66 2920.65 2575.35Z",
    fill: "url(#paint288_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 93_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-243_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-244_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-310_2",
    d: "M2956.57 2600.05L2934.44 2587.21C2933.95 2586.93 2933.64 2582.83 2934.13 2582.55L2950.49 2576.82C2950.93 2576.57 2951.48 2576.57 2951.92 2576.82L2974.56 2586.13C2975.02 2586.41 2974.67 2590.69 2974.2 2590.95L2958.23 2600.05C2957.72 2600.34 2957.08 2600.34 2956.57 2600.05Z",
    fill: "url(#paint289_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-245_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-246_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-311_2",
    d: "M2956.57 2596.22L2934.44 2583.38C2933.95 2583.1 2933.96 2582.41 2934.44 2582.13L2950.49 2572.99C2950.93 2572.74 2951.48 2572.74 2951.92 2572.99L2974.21 2585.91C2974.67 2586.18 2974.67 2586.86 2974.2 2587.13L2958.23 2596.22C2957.72 2596.51 2957.08 2596.51 2956.57 2596.22Z",
    fill: "url(#paint290_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 96_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-247_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-248_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-312_2",
    d: "M2992.49 2620.9L2970.36 2608.07C2969.88 2607.79 2969.56 2603.68 2970.05 2603.4L2986.41 2597.67C2986.85 2597.42 2987.4 2597.42 2987.84 2597.67L3010.48 2606.99C3010.94 2607.26 3010.59 2611.54 3010.13 2611.8L2994.15 2620.9C2993.64 2621.19 2993.01 2621.19 2992.49 2620.9Z",
    fill: "url(#paint291_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-249_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-250_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-313_2",
    d: "M2992.49 2617.07L2970.36 2604.23C2969.88 2603.95 2969.88 2603.26 2970.36 2602.98L2986.41 2593.84C2986.85 2593.59 2987.4 2593.59 2987.84 2593.84L3010.13 2606.76C3010.6 2607.04 3010.59 2607.71 3010.13 2607.98L2994.15 2617.07C2993.64 2617.36 2993.01 2617.36 2992.49 2617.07Z",
    fill: "url(#paint292_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 102_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-251_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-252_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-314_2",
    d: "M3028.41 2641.75L3006.28 2628.93C3005.8 2628.65 3005.49 2624.54 3005.97 2624.27L3022.33 2618.53C3022.77 2618.27 3023.32 2618.27 3023.76 2618.54L3046.4 2627.85C3046.86 2628.11 3046.51 2632.39 3046.05 2632.67L3030.07 2641.77C3029.56 2642.06 3028.93 2642.06 3028.41 2641.75Z",
    fill: "url(#paint293_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-253_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-254_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-315_2",
    d: "M3028.41 2637.93L3006.28 2625.1C3005.8 2624.82 3005.8 2624.11 3006.28 2623.83L3022.33 2614.7C3022.77 2614.45 3023.32 2614.45 3023.76 2614.71L3046.05 2627.63C3046.52 2627.9 3046.51 2628.57 3046.05 2628.83L3030.07 2637.94C3029.56 2638.23 3028.93 2638.22 3028.41 2637.93Z",
    fill: "url(#paint294_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 108_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-255_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-256_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-316_2",
    d: "M3064.34 2662.62L3042.2 2649.78C3041.72 2649.5 3041.41 2645.41 3041.89 2645.13L3058.25 2639.39C3058.7 2639.14 3059.24 2639.14 3059.68 2639.39L3082.32 2648.7C3082.79 2648.98 3082.44 2653.26 3081.97 2653.53L3065.99 2662.62C3065.48 2662.91 3064.85 2662.91 3064.34 2662.62Z",
    fill: "url(#paint295_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-257_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-258_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-317_2",
    d: "M3064.34 2658.78L3042.2 2645.95C3041.72 2645.67 3041.72 2644.98 3042.2 2644.7L3058.25 2635.55C3058.7 2635.3 3059.24 2635.31 3059.68 2635.57L3081.97 2648.49C3082.44 2648.75 3082.44 2649.43 3081.97 2649.7L3065.99 2658.79C3065.48 2659.09 3064.85 2659.09 3064.34 2658.78Z",
    fill: "url(#paint296_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 117_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-259_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-260_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-318_2",
    d: "M3100.26 2683.47L3078.12 2670.63C3077.64 2670.35 3077.33 2666.26 3077.81 2665.98L3094.17 2660.25C3094.62 2659.99 3095.16 2659.99 3095.61 2660.25L3118.24 2669.57C3118.71 2669.83 3118.36 2674.11 3117.89 2674.38L3101.92 2683.47C3101.4 2683.77 3100.77 2683.77 3100.26 2683.47Z",
    fill: "url(#paint297_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-261_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-262_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-319_2",
    d: "M3100.26 2679.65L3078.12 2666.81C3077.64 2666.53 3077.64 2665.83 3078.12 2665.55L3094.17 2656.42C3094.62 2656.17 3095.16 2656.17 3095.61 2656.42L3117.89 2669.34C3118.36 2669.61 3118.36 2670.29 3117.89 2670.55L3101.92 2679.65C3101.4 2679.94 3100.77 2679.94 3100.26 2679.65Z",
    fill: "url(#paint298_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 120_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-263_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-264_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-320_2",
    d: "M3136.18 2704.32L3114.04 2691.5C3113.56 2691.22 3113.25 2687.11 3113.73 2686.83L3130.09 2681.1C3130.54 2680.84 3131.08 2680.84 3131.53 2681.11L3154.16 2690.42C3154.63 2690.68 3154.28 2694.96 3153.81 2695.23L3137.84 2704.34C3137.32 2704.63 3136.69 2704.62 3136.18 2704.32Z",
    fill: "url(#paint299_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-265_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-266_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-321_2",
    d: "M3136.18 2700.5L3114.04 2687.67C3113.56 2687.39 3113.56 2686.68 3114.05 2686.4L3130.09 2677.27C3130.54 2677.02 3131.08 2677.02 3131.53 2677.27L3153.81 2690.19C3154.28 2690.47 3154.28 2691.14 3153.81 2691.4L3137.84 2700.5C3137.32 2700.79 3136.69 2700.79 3136.18 2700.5Z",
    fill: "url(#paint300_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 129_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-267_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-268_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-322_2",
    d: "M3172.1 2725.19L3149.96 2712.35C3149.48 2712.07 3149.17 2707.98 3149.65 2707.7L3166.01 2701.96C3166.46 2701.71 3167 2701.71 3167.45 2701.96L3190.08 2711.27C3190.55 2711.55 3190.2 2715.83 3189.73 2716.1L3173.76 2725.19C3173.24 2725.48 3172.61 2725.48 3172.1 2725.19Z",
    fill: "url(#paint301_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-269_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-270_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-323_2",
    d: "M3172.1 2721.35L3149.96 2708.53C3149.48 2708.25 3149.48 2707.55 3149.97 2707.27L3166.01 2698.13C3166.46 2697.87 3167 2697.89 3167.45 2698.14L3189.73 2711.06C3190.2 2711.33 3190.2 2712.01 3189.73 2712.27L3173.76 2721.37C3173.24 2721.66 3172.61 2721.66 3172.1 2721.35Z",
    fill: "url(#paint302_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 52_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-271_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-272_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-324_2",
    d: "M2708.69 2493.48L2686.55 2480.64C2686.07 2480.36 2685.76 2476.27 2686.24 2475.99L2702.6 2470.26C2703.05 2470 2703.59 2470 2704.04 2470.26L2726.67 2479.56C2727.14 2479.84 2726.79 2484.12 2726.32 2484.39L2710.35 2493.48C2709.83 2493.77 2709.2 2493.77 2708.69 2493.48Z",
    fill: "url(#paint303_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-273_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-274_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-325_2",
    d: "M2708.69 2489.64L2686.55 2476.82C2686.07 2476.54 2686.07 2475.84 2686.56 2475.56L2702.6 2466.42C2703.05 2466.16 2703.59 2466.18 2704.04 2466.43L2726.32 2479.35C2726.79 2479.62 2726.79 2480.3 2726.32 2480.56L2710.35 2489.66C2709.83 2489.95 2709.2 2489.95 2708.69 2489.64Z",
    fill: "url(#paint304_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 59_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-275_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-276_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-326_2",
    d: "M2744.32 2514.7L2722.18 2501.86C2721.7 2501.58 2721.39 2497.49 2721.88 2497.21L2738.24 2491.47C2738.68 2491.22 2739.23 2491.22 2739.67 2491.47L2762.3 2500.79C2762.77 2501.06 2762.42 2505.34 2761.95 2505.61L2745.98 2514.7C2745.46 2514.99 2744.83 2514.99 2744.32 2514.7Z",
    fill: "url(#paint305_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-277_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-278_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-327_2",
    d: "M2744.32 2510.87L2722.18 2498.03C2721.7 2497.75 2721.7 2497.06 2722.19 2496.78L2738.23 2487.65C2738.68 2487.39 2739.23 2487.39 2739.67 2487.65L2761.96 2500.57C2762.42 2500.83 2762.42 2501.51 2761.95 2501.78L2745.98 2510.87C2745.46 2511.17 2744.83 2511.17 2744.32 2510.87Z",
    fill: "url(#paint306_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 65_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-279_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-280_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-328_2",
    d: "M2780.24 2535.55L2758.1 2522.73C2757.62 2522.45 2757.31 2518.34 2757.8 2518.06L2774.16 2512.33C2774.6 2512.07 2775.15 2512.07 2775.59 2512.34L2798.22 2521.65C2798.69 2521.91 2798.34 2526.19 2797.87 2526.46L2781.9 2535.57C2781.38 2535.86 2780.75 2535.85 2780.24 2535.55Z",
    fill: "url(#paint307_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-281_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-282_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-329_2",
    d: "M2780.24 2531.72L2758.11 2518.9C2757.62 2518.62 2757.62 2517.91 2758.11 2517.63L2774.16 2508.5C2774.6 2508.24 2775.15 2508.24 2775.59 2508.5L2797.88 2521.42C2798.34 2521.7 2798.34 2522.36 2797.87 2522.63L2781.9 2531.72C2781.39 2532.02 2780.75 2532.02 2780.24 2531.72Z",
    fill: "url(#paint308_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 76_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-283_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-284_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-330_2",
    d: "M2816.16 2556.42L2794.03 2543.58C2793.54 2543.3 2793.23 2539.2 2793.72 2538.92L2810.08 2533.19C2810.52 2532.94 2811.07 2532.94 2811.51 2533.19L2834.15 2542.5C2834.61 2542.78 2834.26 2547.06 2833.79 2547.32L2817.82 2556.42C2817.31 2556.71 2816.67 2556.71 2816.16 2556.42Z",
    fill: "url(#paint309_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-285_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-286_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-331_2",
    d: "M2816.16 2552.58L2794.03 2539.75C2793.54 2539.47 2793.55 2538.78 2794.03 2538.5L2810.08 2529.35C2810.52 2529.1 2811.07 2529.11 2811.51 2529.37L2833.8 2542.29C2834.26 2542.55 2834.26 2543.22 2833.8 2543.5L2817.82 2552.59C2817.31 2552.89 2816.68 2552.89 2816.16 2552.58Z",
    fill: "url(#paint310_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 77_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-287_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-288_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-332_2",
    d: "M2852.08 2577.27L2829.95 2564.43C2829.46 2564.15 2829.15 2560.06 2829.64 2559.78L2846 2554.05C2846.44 2553.79 2846.99 2553.79 2847.43 2554.05L2870.07 2563.37C2870.53 2563.63 2870.18 2567.91 2869.71 2568.18L2853.74 2577.27C2853.23 2577.57 2852.6 2577.57 2852.08 2577.27Z",
    fill: "url(#paint311_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-289_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-290_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-333_2",
    d: "M2852.08 2573.45L2829.95 2560.61C2829.46 2560.33 2829.47 2559.63 2829.95 2559.35L2846 2550.22C2846.44 2549.97 2846.99 2549.97 2847.43 2550.22L2869.72 2563.14C2870.18 2563.41 2870.18 2564.09 2869.71 2564.35L2853.74 2573.45C2853.23 2573.74 2852.6 2573.74 2852.08 2573.45Z",
    fill: "url(#paint312_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 83_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-291_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-292_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-334_2",
    d: "M2888 2598.13L2865.87 2585.3C2865.39 2585.02 2865.07 2580.91 2865.56 2580.63L2881.92 2574.9C2882.36 2574.65 2882.91 2574.65 2883.35 2574.91L2905.99 2584.22C2906.45 2584.49 2906.1 2588.77 2905.64 2589.03L2889.66 2598.13C2889.15 2598.43 2888.52 2598.42 2888 2598.13Z",
    fill: "url(#paint313_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-293_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-294_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-335_2",
    d: "M2888 2594.3L2865.87 2581.47C2865.39 2581.18 2865.39 2580.49 2865.87 2580.21L2881.92 2571.07C2882.36 2570.82 2882.91 2570.82 2883.35 2571.07L2905.64 2583.99C2906.11 2584.27 2906.1 2584.94 2905.64 2585.21L2889.66 2594.3C2889.15 2594.59 2888.52 2594.59 2888 2594.3Z",
    fill: "url(#paint314_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 94_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-295_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-296_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-336_2",
    d: "M2923.92 2618.98L2901.79 2606.15C2901.31 2605.87 2901 2601.78 2901.48 2601.5L2917.84 2595.76C2918.28 2595.5 2918.83 2595.51 2919.27 2595.76L2941.91 2605.07C2942.37 2605.34 2942.02 2609.63 2941.56 2609.9L2925.58 2618.99C2925.07 2619.28 2924.44 2619.28 2923.92 2618.98Z",
    fill: "url(#paint315_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-297_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-298_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-337_2",
    d: "M2923.92 2615.15L2901.79 2602.32C2901.31 2602.04 2901.31 2601.34 2901.79 2601.07L2917.84 2591.92C2918.28 2591.67 2918.83 2591.67 2919.27 2591.94L2941.56 2604.86C2942.03 2605.12 2942.02 2605.79 2941.56 2606.06L2925.58 2615.16C2925.07 2615.46 2924.44 2615.46 2923.92 2615.15Z",
    fill: "url(#paint316_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 95_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-299_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-300_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-338_2",
    d: "M2959.85 2639.84L2937.71 2627C2937.23 2626.72 2936.92 2622.63 2937.4 2622.35L2953.76 2616.62C2954.2 2616.37 2954.75 2616.37 2955.2 2616.62L2977.83 2625.92C2978.3 2626.2 2977.94 2630.48 2977.48 2630.75L2961.5 2639.84C2960.99 2640.14 2960.36 2640.14 2959.85 2639.84Z",
    fill: "url(#paint317_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-301_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-302_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-339_2",
    d: "M2959.85 2636.02L2937.71 2623.18C2937.23 2622.9 2937.23 2622.2 2937.71 2621.92L2953.76 2612.79C2954.21 2612.54 2954.75 2612.54 2955.2 2612.79L2977.48 2625.71C2977.95 2625.98 2977.95 2626.66 2977.48 2626.92L2961.51 2636.02C2960.99 2636.31 2960.36 2636.31 2959.85 2636.02Z",
    fill: "url(#paint318_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 101_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-303_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-304_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-340_2",
    d: "M2995.77 2660.7L2973.63 2647.87C2973.15 2647.59 2972.84 2643.49 2973.32 2643.21L2989.68 2637.47C2990.13 2637.22 2990.67 2637.22 2991.12 2637.47L3013.75 2646.79C3014.22 2647.06 3013.87 2651.34 3013.4 2651.61L2997.43 2660.7C2996.91 2661 2996.28 2660.99 2995.77 2660.7Z",
    fill: "url(#paint319_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-305_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-306_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-341_2",
    d: "M2995.77 2656.87L2973.63 2644.03C2973.15 2643.75 2973.15 2643.06 2973.63 2642.78L2989.68 2633.65C2990.13 2633.39 2990.67 2633.39 2991.12 2633.65L3013.4 2646.57C3013.87 2646.85 3013.87 2647.51 3013.4 2647.78L2997.43 2656.87C2996.91 2657.17 2996.28 2657.17 2995.77 2656.87Z",
    fill: "url(#paint320_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 107_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-307_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-308_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-342_2",
    d: "M3031.69 2681.55L3009.55 2668.72C3009.07 2668.44 3008.76 2664.34 3009.24 2664.07L3025.6 2658.32C3026.05 2658.07 3026.59 2658.07 3027.04 2658.34L3049.67 2667.64C3050.14 2667.91 3049.79 2672.2 3049.32 2672.47L3033.35 2681.56C3032.83 2681.86 3032.2 2681.86 3031.69 2681.55Z",
    fill: "url(#paint321_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-309_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-310_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-343_2",
    d: "M3031.69 2677.72L3009.55 2664.9C3009.07 2664.62 3009.07 2663.91 3009.56 2663.64L3025.6 2654.5C3026.05 2654.24 3026.59 2654.24 3027.04 2654.51L3049.32 2667.43C3049.79 2667.7 3049.79 2668.36 3049.32 2668.63L3033.35 2677.74C3032.83 2678.03 3032.2 2678.02 3031.69 2677.72Z",
    fill: "url(#paint322_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 118_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-311_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-312_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-344_2",
    d: "M3067.61 2702.42L3045.47 2689.58C3044.99 2689.3 3044.68 2685.2 3045.16 2684.92L3061.52 2679.19C3061.97 2678.94 3062.51 2678.94 3062.96 2679.19L3085.59 2688.5C3086.06 2688.78 3085.71 2693.06 3085.24 2693.32L3069.27 2702.42C3068.75 2702.71 3068.12 2702.71 3067.61 2702.42Z",
    fill: "url(#paint323_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-313_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-314_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-345_2",
    d: "M3067.61 2698.58L3045.47 2685.75C3044.99 2685.47 3044.99 2684.78 3045.48 2684.5L3061.52 2675.37C3061.97 2675.11 3062.51 2675.11 3062.96 2675.37L3085.24 2688.29C3085.71 2688.55 3085.71 2689.23 3085.24 2689.5L3069.27 2698.59C3068.75 2698.89 3068.12 2698.89 3067.61 2698.58Z",
    fill: "url(#paint324_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 119_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-315_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-316_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 51_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-346_2",
    d: "M3103.53 2723.27L3081.39 2710.45C3080.91 2710.17 3080.6 2706.06 3081.08 2705.78L3097.44 2700.05C3097.89 2699.79 3098.44 2699.79 3098.88 2700.05L3121.51 2709.37C3121.98 2709.63 3121.63 2713.91 3121.16 2714.18L3105.19 2723.27C3104.67 2723.57 3104.04 2723.57 3103.53 2723.27Z",
    fill: "url(#paint325_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g-317_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-318_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-347_2",
    d: "M3103.53 2719.45L3081.39 2706.61C3080.91 2706.33 3080.91 2705.63 3081.4 2705.35L3097.44 2696.22C3097.89 2695.97 3098.44 2695.97 3098.88 2696.22L3121.16 2709.14C3121.63 2709.41 3121.63 2710.09 3121.16 2710.35L3105.19 2719.45C3104.67 2719.74 3104.04 2719.74 3103.53 2719.45Z",
    fill: "url(#paint326_linear_71_514)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 130_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-319_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-320_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-348_2",
    d: "M3139.45 2744.13L3117.31 2731.3C3116.83 2731.02 3116.52 2726.91 3117.01 2726.63L3133.36 2720.9C3133.81 2720.65 3134.36 2720.65 3134.8 2720.91L3157.43 2730.22C3157.9 2730.49 3157.55 2734.77 3157.08 2735.03L3141.11 2744.14C3140.59 2744.43 3139.96 2744.43 3139.45 2744.13Z",
    fill: "url(#paint327_linear_71_514)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-321_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-322_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-349_2",
    d: "M3139.45 2740.3L3117.32 2727.47C3116.83 2727.19 3116.83 2726.49 3117.32 2726.21L3133.36 2717.07C3133.81 2716.82 3134.36 2716.82 3134.8 2717.07L3157.09 2730.01C3157.55 2730.27 3157.55 2730.94 3157.08 2731.21L3141.11 2740.3C3140.6 2740.61 3139.96 2740.59 3139.45 2740.3Z",
    fill: "url(#paint328_linear_71_514)"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "groundround_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-163_2",
    d: "M2960.93 3066.79C2706.92 3066.79 2501 2951.43 2501 2809.12C2501 2757.87 2527.7 2710.12 2573.73 2670L2580.05 2673.67C2535.6 2712.82 2509.85 2759.28 2509.85 2809.12C2509.85 2948.68 2711.8 3061.83 2960.93 3061.83C3210.06 3061.83 3412.01 2948.68 3412.01 2809.12C3412.01 2777.87 3401.9 2747.96 3383.39 2720.34L3390.22 2716.46C3410.01 2745.2 3420.86 2776.46 3420.86 2809.12C3420.86 2951.43 3214.94 3066.79 2960.93 3066.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-164_2",
    d: "M2960.93 3061.83C2711.8 3061.83 2509.85 2948.68 2509.85 2809.12C2509.85 2759.28 2535.6 2712.82 2580.05 2673.67L2586.38 2677.34C2543.5 2715.5 2518.69 2760.7 2518.69 2809.12C2518.69 2945.95 2716.69 3056.87 2960.93 3056.87C3205.17 3056.87 3403.17 2945.95 3403.17 2809.12C3403.17 2779.31 3393.76 2750.72 3376.53 2724.24L3383.39 2720.34C3401.9 2747.96 3412.01 2777.87 3412.01 2809.12C3412.01 2948.68 3210.06 3061.83 2960.93 3061.83Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-165_2",
    d: "M2960.93 3056.87C2716.69 3056.87 2518.69 2945.95 2518.69 2809.12C2518.69 2760.7 2543.5 2715.5 2586.38 2677.34L2592.72 2681C2551.4 2718.19 2527.54 2762.1 2527.54 2809.12C2527.54 2943.22 2721.58 3051.92 2960.93 3051.92C3200.29 3051.92 3394.32 2943.22 3394.32 2809.12C3394.32 2780.74 3385.62 2753.48 3369.64 2728.16L3376.53 2724.24C3393.76 2750.72 3403.17 2779.31 3403.17 2809.12C3403.17 2945.95 3205.17 3056.87 2960.93 3056.87Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-166_2",
    d: "M2960.93 3051.92C2721.58 3051.92 2527.54 2943.22 2527.54 2809.12C2527.54 2762.1 2551.4 2718.19 2592.72 2681L2599.06 2684.68C2559.31 2720.88 2536.39 2763.5 2536.39 2809.12C2536.39 2940.48 2726.46 3046.96 2960.93 3046.96C3195.4 3046.96 3385.47 2940.48 3385.47 2809.12C3385.47 2782.16 3377.47 2756.26 3362.72 2732.11L3369.64 2728.16C3385.62 2753.48 3394.32 2780.74 3394.32 2809.12C3394.32 2943.22 3200.29 3051.92 2960.93 3051.92Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-167_2",
    d: "M2960.93 3046.96C2726.46 3046.96 2536.39 2940.48 2536.39 2809.12C2536.39 2763.5 2559.31 2720.88 2599.06 2684.68L2605.41 2688.36C2567.22 2723.58 2545.23 2764.91 2545.23 2809.12C2545.23 2937.74 2731.35 3042 2960.93 3042C3190.51 3042 3376.63 2937.74 3376.63 2809.12C3376.63 2783.6 3369.3 2759.04 3355.76 2736.07L3362.72 2732.11C3377.47 2756.26 3385.47 2782.16 3385.47 2809.12C3385.47 2940.48 3195.4 3046.96 2960.93 3046.96Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-168_2",
    d: "M2960.93 3042C2731.35 3042 2545.23 2937.74 2545.23 2809.12C2545.23 2764.91 2567.22 2723.58 2605.41 2688.36L2611.77 2692.06C2575.14 2726.27 2554.08 2766.32 2554.08 2809.12C2554.08 2935 2736.23 3037.06 2960.93 3037.06C3185.63 3037.06 3367.78 2935 3367.78 2809.12C3367.78 2785.04 3361.12 2761.84 3348.77 2740.06L3355.76 2736.07C3369.3 2759.04 3376.63 2783.6 3376.63 2809.12C3376.63 2937.74 3190.51 3042 2960.93 3042Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-169_2",
    d: "M2960.93 3037.06C2736.23 3037.06 2554.08 2935 2554.08 2809.12C2554.08 2766.32 2575.14 2726.27 2611.77 2692.06L2618.14 2695.75C2583.07 2728.96 2562.93 2767.72 2562.93 2809.12C2562.93 2932.27 2741.12 3032.1 2960.93 3032.1C3180.74 3032.1 3358.93 2932.27 3358.93 2809.12C3358.93 2786.48 3352.91 2764.64 3341.72 2744.06L3348.77 2740.06C3361.12 2761.84 3367.78 2785.04 3367.78 2809.12C3367.78 2935 3185.63 3037.06 2960.93 3037.06Z",
    fill: "#F9F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-170_2",
    d: "M2960.93 3032.1C2741.12 3032.1 2562.93 2932.27 2562.93 2809.12C2562.93 2767.72 2583.07 2728.96 2618.14 2695.75L2624.53 2699.44C2590.99 2731.67 2571.77 2769.14 2571.77 2809.12C2571.77 2929.52 2746.01 3027.14 2960.93 3027.14C3175.85 3027.14 3350.09 2929.52 3350.09 2809.12C3350.09 2787.94 3344.69 2767.46 3334.64 2748.1L3341.72 2744.06C3352.91 2764.64 3358.93 2786.48 3358.93 2809.12C3358.93 2932.27 3180.74 3032.1 2960.93 3032.1Z",
    fill: "#F8F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-171_2",
    d: "M2960.93 3027.14C2746.01 3027.14 2571.77 2929.52 2571.77 2809.12C2571.77 2769.14 2590.99 2731.67 2624.53 2699.44L2630.92 2703.15C2598.92 2734.36 2580.62 2770.55 2580.62 2809.12C2580.62 2926.79 2750.89 3022.18 2960.93 3022.18C3170.97 3022.18 3341.24 2926.79 3341.24 2809.12C3341.24 2789.39 3336.46 2770.3 3327.5 2752.16L3334.64 2748.1C3344.69 2767.46 3350.09 2787.94 3350.09 2809.12C3350.09 2929.52 3175.85 3027.14 2960.93 3027.14Z",
    fill: "#F7F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-172_2",
    d: "M2960.93 3022.18C2750.89 3022.18 2580.62 2926.79 2580.62 2809.12C2580.62 2770.55 2598.92 2734.36 2630.92 2703.15L2637.32 2706.87C2606.86 2737.07 2589.47 2771.95 2589.47 2809.12C2589.47 2924.06 2755.78 3017.23 2960.93 3017.23C3166.08 3017.23 3332.39 2924.06 3332.39 2809.12C3332.39 2790.86 3328.19 2773.14 3320.3 2756.26L3327.5 2752.16C3336.46 2770.3 3341.24 2789.39 3341.24 2809.12C3341.24 2926.79 3170.97 3022.18 2960.93 3022.18Z",
    fill: "#F6F6F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-173_2",
    d: "M2960.93 3017.23C2755.78 3017.23 2589.47 2924.06 2589.47 2809.12C2589.47 2771.95 2606.86 2737.07 2637.32 2706.87L2643.75 2710.59C2614.8 2739.78 2598.32 2773.36 2598.32 2809.12C2598.32 2921.31 2760.66 3012.27 2960.93 3012.27C3161.2 3012.27 3323.55 2921.31 3323.55 2809.12C3323.55 2792.32 3319.91 2776 3313.05 2760.39L3320.3 2756.26C3328.19 2773.14 3332.39 2790.86 3332.39 2809.12C3332.39 2924.06 3166.08 3017.23 2960.93 3017.23Z",
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-174_2",
    d: "M2960.93 3012.27C2760.66 3012.27 2598.32 2921.31 2598.32 2809.12C2598.32 2773.36 2614.8 2739.78 2643.75 2710.59L2650.18 2714.32C2622.75 2742.48 2607.16 2774.78 2607.16 2809.12C2607.16 2918.58 2765.55 3007.31 2960.93 3007.31C3156.31 3007.31 3314.7 2918.58 3314.7 2809.12C3314.7 2793.8 3311.59 2778.88 3305.72 2764.56L3313.05 2760.39C3319.91 2776 3323.55 2792.32 3323.55 2809.12C3323.55 2921.31 3161.2 3012.27 2960.93 3012.27Z",
    fill: "#F4F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-175_2",
    d: "M2960.93 3007.31C2765.55 3007.31 2607.16 2918.58 2607.16 2809.12C2607.16 2774.78 2622.75 2742.48 2650.18 2714.32L2656.63 2718.06C2630.71 2745.19 2616.01 2776.19 2616.01 2809.12C2616.01 2915.84 2770.44 3002.35 2960.93 3002.35C3151.43 3002.35 3305.85 2915.84 3305.85 2809.12C3305.85 2795.28 3303.26 2781.79 3298.32 2768.78L3305.72 2764.56C3311.59 2778.88 3314.7 2793.8 3314.7 2809.12C3314.7 2918.58 3156.31 3007.31 2960.93 3007.31Z",
    fill: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-176_2",
    d: "M2960.93 3002.35C2770.44 3002.35 2616.01 2915.84 2616.01 2809.12C2616.01 2776.19 2630.71 2745.19 2656.63 2718.06L2663.1 2721.8C2638.67 2747.91 2624.86 2777.6 2624.86 2809.12C2624.86 2913.11 2775.32 2997.4 2960.93 2997.4C3146.54 2997.4 3297.01 2913.11 3297.01 2809.12C3297.01 2796.78 3294.88 2784.71 3290.84 2773.04L3298.32 2768.78C3303.26 2781.79 3305.85 2795.28 3305.85 2809.12C3305.85 2915.84 3151.43 3002.35 2960.93 3002.35Z",
    fill: "#F2F2F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-177_2",
    d: "M2960.93 2997.4C2775.32 2997.4 2624.86 2913.11 2624.86 2809.12C2624.86 2777.6 2638.67 2747.91 2663.1 2721.8L2669.58 2725.58C2646.64 2750.63 2633.7 2779.03 2633.7 2809.12C2633.7 2910.36 2780.21 2992.44 2960.93 2992.44C3141.65 2992.44 3288.16 2910.36 3288.16 2809.12C3288.16 2798.28 3286.48 2787.67 3283.26 2777.35L3290.84 2773.04C3294.88 2784.71 3297.01 2796.78 3297.01 2809.12C3297.01 2913.11 3146.54 2997.4 2960.93 2997.4Z",
    fill: "#F1F1F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-178_2",
    d: "M2960.93 2992.44C2780.21 2992.44 2633.7 2910.36 2633.7 2809.12C2633.7 2779.03 2646.64 2750.63 2669.58 2725.58L2676.09 2729.34C2654.63 2753.35 2642.55 2780.44 2642.55 2809.12C2642.55 2907.63 2785.09 2987.48 2960.93 2987.48C3136.77 2987.48 3279.31 2907.63 3279.31 2809.12C3279.31 2799.8 3278.04 2790.66 3275.58 2781.72L3283.26 2777.35C3286.48 2787.67 3288.16 2798.28 3288.16 2809.12C3288.16 2910.36 3141.65 2992.44 2960.93 2992.44Z",
    fill: "#F1F0EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-179_2",
    d: "M2960.93 2987.48C2785.09 2987.48 2642.55 2907.63 2642.55 2809.12C2642.55 2780.44 2654.63 2753.35 2676.09 2729.34L2682.62 2733.12C2662.62 2756.07 2651.4 2781.86 2651.4 2809.12C2651.4 2904.9 2789.98 2982.54 2960.93 2982.54C3131.88 2982.54 3270.46 2904.9 3270.46 2809.12C3270.46 2801.34 3269.55 2793.68 3267.78 2786.16L3275.58 2781.72C3278.04 2790.66 3279.31 2799.8 3279.31 2809.12C3279.31 2907.63 3136.77 2987.48 2960.93 2987.48Z",
    fill: "#F0EFEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-180_2",
    d: "M2960.93 2982.54C2789.98 2982.54 2651.4 2904.9 2651.4 2809.12C2651.4 2781.86 2662.62 2756.07 2682.62 2733.12L2689.18 2736.92C2670.62 2758.82 2660.24 2783.28 2660.24 2809.12C2660.24 2902.15 2794.86 2977.58 2960.93 2977.58C3127 2977.58 3261.62 2902.15 3261.62 2809.12C3261.62 2802.9 3261.02 2796.75 3259.84 2790.68L3267.78 2786.16C3269.55 2793.68 3270.46 2801.34 3270.46 2809.12C3270.46 2904.9 3131.88 2982.54 2960.93 2982.54Z",
    fill: "#EFEEED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-181_2",
    d: "M2960.93 2977.58C2794.86 2977.58 2660.24 2902.15 2660.24 2809.12C2660.24 2783.28 2670.62 2758.82 2689.18 2736.92L2695.76 2740.75C2678.64 2761.55 2669.09 2784.71 2669.09 2809.12C2669.09 2899.42 2799.75 2972.62 2960.93 2972.62C3122.11 2972.62 3252.77 2899.42 3252.77 2809.12C3252.77 2804.47 3252.42 2799.86 3251.74 2795.3L3259.84 2790.68C3261.02 2796.75 3261.62 2802.9 3261.62 2809.12C3261.62 2902.15 3127 2977.58 2960.93 2977.58Z",
    fill: "#EEEDEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-182_2",
    d: "M2960.93 2972.62C2799.75 2972.62 2669.09 2899.42 2669.09 2809.12C2669.09 2784.71 2678.64 2761.55 2695.76 2740.75L2702.37 2744.58C2686.66 2764.3 2677.94 2786.14 2677.94 2809.12C2677.94 2896.68 2804.64 2967.66 2960.93 2967.66C3117.22 2967.66 3243.93 2896.68 3243.93 2809.12C3243.93 2806.07 3243.77 2803.03 3243.47 2800.02L3251.74 2795.3C3252.42 2799.86 3252.77 2804.47 3252.77 2809.12C3252.77 2899.42 3122.11 2972.62 2960.93 2972.62Z",
    fill: "#ECEBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-183_2",
    d: "M2960.93 2967.66C2804.64 2967.66 2677.94 2896.68 2677.94 2809.12C2677.94 2786.14 2686.66 2764.3 2702.37 2744.58L2709.02 2748.43C2694.71 2767.04 2686.78 2787.56 2686.78 2809.12C2686.78 2893.95 2809.52 2962.71 2960.93 2962.71C3112.34 2962.71 3235.08 2893.95 3235.08 2809.12C3235.08 2807.7 3235.04 2806.27 3234.97 2804.84L3243.47 2800.02C3243.77 2803.03 3243.92 2806.07 3243.92 2809.12C3243.92 2896.68 3117.22 2967.66 2960.93 2967.66Z",
    fill: "#EBEAE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-184_2",
    d: "M2960.93 2962.71C2809.52 2962.71 2686.78 2893.95 2686.78 2809.12C2686.78 2787.56 2694.71 2767.04 2709.02 2748.43L2715.7 2752.31C2702.77 2769.8 2695.63 2789 2695.63 2809.12C2695.63 2891.2 2814.41 2957.75 2960.93 2957.75C3107.03 2957.75 3225.55 2891.59 3226.23 2809.83L3234.97 2804.84C3235.04 2806.27 3235.08 2807.7 3235.08 2809.12C3235.08 2893.95 3112.34 2962.71 2960.93 2962.71Z",
    fill: "#EAE9E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-185_2",
    d: "M2960.93 2957.75C2814.41 2957.75 2695.63 2891.2 2695.63 2809.12C2695.63 2789 2702.77 2769.8 2715.7 2752.31L2722.43 2756.2C2710.84 2772.58 2704.48 2790.43 2704.48 2809.12C2704.48 2888.47 2819.29 2952.79 2960.93 2952.79C3099.06 2952.79 3211.69 2891.62 3217.17 2814.98L3226.23 2809.83C3225.55 2891.59 3107.03 2957.75 2960.93 2957.75Z",
    fill: "#E9E8E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-186_2",
    d: "M2960.93 2952.79C2819.29 2952.79 2704.48 2888.47 2704.48 2809.12C2704.48 2790.43 2710.84 2772.58 2722.43 2756.2L2729.2 2760.14C2718.94 2775.36 2713.32 2791.87 2713.32 2809.12C2713.32 2885.74 2824.18 2947.84 2960.93 2947.84C3090.93 2947.84 3197.53 2891.71 3207.74 2820.36L3217.17 2814.98C3211.69 2891.62 3099.06 2952.79 2960.93 2952.79Z",
    fill: "#E8E7E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-187_2",
    d: "M2960.93 2947.84C2824.18 2947.84 2713.32 2885.74 2713.32 2809.12C2713.32 2791.87 2718.94 2775.36 2729.2 2760.14L2998.58 2916.3C3004.86 2919.95 3011.88 2921.76 3018.91 2921.76C3025.85 2921.76 3032.8 2919.99 3039.03 2916.42L3207.74 2820.36C3197.53 2891.71 3090.93 2947.84 2960.93 2947.84Z",
    fill: "#E8E6E5"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "website"
  }, /*#__PURE__*/React.createElement("path", {
    id: "websitefront",
    d: "M999.776 1278.36C999.084 1278.36 998.414 1278.16 997.71 1277.75L458.541 965.894C444.02 957.499 435 941.88 435 925.155V408.356C435 404.945 437.995 403.359 440.019 403.359C440.843 403.359 441.646 403.586 442.476 404.065L984.822 717.769C996.648 724.606 1004 737.319 1004 750.952V1274.15C1004 1274.92 1003.87 1276.07 1002.79 1277.09C1001.97 1277.88 1000.84 1278.36 999.776 1278.36Z",
    fill: "#B4E6ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "circlechart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.112 930.872C544.21 961.053 527.052 974.517 503.918 960.858C480.796 947.384 460.396 911.954 458.298 881.773C456.2 851.592 473.201 838.139 496.336 851.798C519.458 865.272 540.014 900.691 542.112 930.872ZM532.436 925.214C530.827 902.069 515.077 874.691 497.198 864.204C479.319 853.717 466.196 864.111 467.818 887.441C469.427 910.587 485.176 937.965 503.055 948.452C520.934 958.939 534.058 948.544 532.436 925.214Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M687.598 1016.11C689.697 1046.29 672.539 1059.76 649.404 1046.1C626.282 1032.63 605.883 997.196 603.784 967.014C601.686 936.833 618.688 923.38 641.822 937.039C664.944 950.513 685.5 985.932 687.598 1016.11V1016.11ZM678.092 1010.63C676.47 987.299 660.564 959.932 642.685 949.445C624.806 938.958 611.682 949.352 613.304 972.683C614.926 996.013 630.675 1023.39 648.542 1033.69C666.421 1044.18 679.701 1033.77 678.092 1010.63Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M833.083 1101.31C835.181 1131.49 818.023 1144.96 794.901 1131.48C771.767 1117.82 751.367 1082.39 749.269 1052.21C747.183 1022.22 764.185 1008.76 787.306 1022.24C810.428 1035.71 830.985 1071.13 833.083 1101.31ZM823.576 1095.83C821.954 1072.5 806.048 1045.13 788.169 1034.64C770.29 1024.16 757.167 1034.55 758.788 1057.88C760.41 1081.21 776.16 1108.59 794.039 1119.08C811.918 1129.56 825.198 1119.16 823.576 1095.83Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.568 1186.55C980.666 1216.73 963.508 1230.2 940.386 1216.72C917.252 1203.06 896.852 1167.63 894.767 1137.64C892.668 1107.46 909.67 1094 932.791 1107.48C955.926 1121.14 976.482 1156.55 978.568 1186.55ZM969.061 1181.07C967.439 1157.74 951.533 1130.37 933.654 1119.88C915.775 1109.4 902.651 1119.79 904.273 1143.12C905.895 1166.45 921.645 1193.83 939.524 1204.32C957.403 1214.8 970.683 1204.4 969.061 1181.07Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M510.113 963.965C508.165 963.107 506.1 962.072 503.918 960.858C480.796 947.384 460.396 911.954 458.298 881.773C456.2 851.592 473.201 838.139 496.336 851.798C503.222 855.788 509.766 861.662 515.605 868.701L512.113 877.314C507.486 871.866 502.441 867.191 497.198 864.204C479.319 853.717 466.196 864.111 467.818 887.442C469.427 910.587 485.176 937.965 503.055 948.452C504.698 949.455 506.316 950.088 507.777 950.731C508.607 955.139 509.386 959.55 510.113 963.965Z",
    fill: "#FA8AC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M629.464 1015.02L624.604 1022.05C613.254 1005.91 605.066 985.447 603.779 966.931C602.595 949.896 607.447 938.212 616.102 933.707L622.835 946.824C616.164 950.447 612.385 959.453 613.299 972.599C614.29 986.856 620.577 1002.61 629.464 1015.02V1015.02Z",
    fill: "#4A63A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_3",
    d: "M749.066 1047.05C749.274 1020.62 765.647 1009.44 787.307 1022.27C793.046 1025.6 798.717 1030.23 803.84 1036.01L801.025 1045.33C796.945 1040.96 792.604 1037.35 788.17 1034.68C771.438 1024.86 758.813 1033.36 758.663 1053.83L749.066 1047.05Z",
    fill: "#8167C9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_4",
    d: "M942.341 1217.7C941.689 1217.38 941.037 1217.05 940.385 1216.72C917.251 1203.06 896.851 1167.63 894.766 1137.64C892.667 1107.46 909.669 1094 932.79 1107.48C945.414 1114.79 957.236 1128.67 965.741 1144.65L959.096 1148.64C952.57 1136.25 943.486 1125.53 933.653 1119.88C915.774 1109.4 902.65 1119.79 904.272 1143.12C905.894 1166.45 921.644 1193.83 939.523 1204.32C940.175 1204.64 940.657 1204.8 941.14 1204.95L942.341 1217.7Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "barchart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "laptopscreenfront_3",
    d: "M761.125 922.359C760.75 922.359 760.387 922.252 760.006 922.03L467.827 754.521C459.958 750.011 455.07 741.622 455.07 732.638V455.043C455.07 453.211 456.693 452.359 457.79 452.359C458.237 452.359 458.672 452.481 459.122 452.738L753.021 621.242C759.43 624.914 763.414 631.743 763.414 639.066V920.097C763.414 920.512 763.346 921.128 762.76 921.679C762.313 922.101 761.7 922.359 761.125 922.359Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_7",
    d: "M505.219 545.996L504.969 728.444L493.835 720.819L494.085 538.371C494.09 534.288 496.604 532.621 499.583 534.666C502.72 536.712 505.224 541.913 505.219 545.996Z",
    fill: "#8167C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_8",
    d: "M554.68 607.002L556.149 756.963L544.931 749.462L543.462 599.501C543.422 595.418 545.915 593.537 548.919 595.735C552.078 597.746 554.64 602.919 554.68 607.002Z",
    fill: "#4A63A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_9",
    d: "M583.874 610.1L586.743 776.007L575.468 768.59L572.6 602.683C572.526 598.415 575.008 596.701 578.025 598.691C581.2 600.679 583.801 605.832 583.874 610.1Z",
    fill: "#8167C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_10",
    d: "M528.942 624.966L528.466 742.081L517.353 734.427L517.829 617.311C517.846 613.228 520.364 611.567 523.495 613.622C526.469 615.675 528.959 620.882 528.942 624.966Z",
    fill: "#FA8AC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_11",
    d: "M612.828 694.101L613.317 789.129L602.133 781.577L601.645 686.549C601.623 682.28 604.126 680.597 607.275 682.622C610.269 684.834 612.806 689.833 612.828 694.101Z",
    fill: "#FA8AC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_12",
    d: "M663.202 771.299L663.456 818.627L652.271 811.077L652.016 763.563C651.994 759.48 654.496 757.796 657.646 759.821C660.64 761.846 663.179 767.03 663.202 771.299Z",
    fill: "#8167C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_13",
    d: "M713.642 698.082L716.366 851.739L705.089 844.327L702.365 690.67C702.293 686.587 704.771 684.687 707.949 686.859C710.967 688.847 713.57 693.999 713.642 698.082Z",
    fill: "#4A63A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_14",
    d: "M637.456 738.177L637.916 804.807L626.718 797.089L626.259 730.644C626.231 726.561 628.729 724.687 631.884 726.893C634.88 728.914 637.427 734.094 637.456 738.177Z",
    fill: "#4A63A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_15",
    d: "M685.432 705.031L687.17 833.458L675.923 825.999L674.186 697.572C674.131 693.489 676.619 691.785 679.629 693.786C682.796 695.786 685.377 700.948 685.432 705.031Z",
    fill: "#FA8AC9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "linechart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_16",
    d: "M962.966 863.683C962.993 867.395 960.807 868.896 958.125 867.06L838.542 786.649C836.018 784.997 833.788 780.559 833.76 776.847C833.734 773.321 835.92 771.82 838.445 773.657L958.026 853.882C960.709 855.718 962.939 860.156 962.966 863.683Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_17",
    d: "M951.313 921.863C951.341 925.575 949.155 927.076 946.472 925.24L839.038 853.092C836.513 851.254 834.282 846.816 834.256 843.29C834.23 839.764 836.416 838.262 838.941 840.1L946.375 912.248C949.056 913.899 951.287 918.337 951.313 921.863Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_18",
    d: "M833.512 743.73C833.485 740.018 835.671 738.517 838.196 740.354L940.898 809.382C943.579 811.032 945.652 815.472 945.679 818.998C945.707 822.71 943.677 824.21 940.995 822.374L838.293 753.346C835.769 751.694 833.539 747.256 833.512 743.73Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_19",
    d: "M834.504 876.456C834.477 872.93 836.664 871.429 839.188 873.081L909.391 920.262C912.073 922.098 914.145 926.352 914.173 930.064C914.199 933.59 912.17 935.09 909.488 933.254L839.286 886.258C836.761 884.421 834.53 879.983 834.504 876.456V876.456Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_20",
    d: "M914.669 996.363C914.696 1000.07 912.667 1001.57 909.985 999.739L839.782 952.557C837.258 950.906 835.027 946.468 835.001 942.941C834.973 939.229 837.159 937.728 839.684 939.565L909.888 986.747C912.568 988.397 914.642 992.837 914.669 996.363Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_21",
    d: "M834.007 810.005C833.981 806.479 836.167 804.978 838.692 806.815L921.358 862.256C923.882 863.908 926.112 868.346 926.14 872.058C926.166 875.584 923.98 877.085 921.455 875.248L838.789 819.807C836.264 817.97 834.035 813.717 834.007 810.005Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_22",
    d: "M926.884 971.535C926.91 975.061 924.724 976.562 922.2 974.91L839.535 919.469C837.01 917.632 834.779 913.194 834.753 909.667C834.725 905.955 836.911 904.454 839.436 906.291L922.102 961.733C924.627 963.57 926.858 968.008 926.884 971.535Z",
    fill: "#31B8CC"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "website"
  }, /*#__PURE__*/React.createElement("path", {
    id: "websitefront_2",
    d: "M3443.78 2626.36C3443.08 2626.36 3442.41 2626.16 3441.71 2625.75L2902.54 2313.89C2888.02 2305.5 2879 2289.88 2879 2273.16V1756.36C2879 1752.94 2882 1751.36 2884.02 1751.36C2884.84 1751.36 2885.65 1751.59 2886.48 1752.07L3428.82 2065.77C3440.65 2072.61 3448 2085.32 3448 2098.95V2622.15C3448 2622.92 3447.87 2624.07 3446.79 2625.09C3445.97 2625.88 3444.84 2626.36 3443.78 2626.36Z",
    fill: "#B4E6ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "circlechart_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2986.11 2278.87C2988.21 2309.05 2971.05 2322.52 2947.92 2308.86C2924.8 2295.38 2904.4 2259.95 2902.3 2229.77C2900.2 2199.59 2917.2 2186.14 2940.34 2199.8C2963.46 2213.27 2984.01 2248.69 2986.11 2278.87ZM2976.44 2273.21C2974.83 2250.07 2959.08 2222.69 2941.2 2212.2C2923.32 2201.72 2910.2 2212.11 2911.82 2235.44C2913.43 2258.59 2929.18 2285.97 2947.06 2296.45C2964.93 2306.94 2978.06 2296.54 2976.44 2273.21Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3131.6 2364.11C3133.7 2394.29 3116.54 2407.76 3093.4 2394.1C3070.28 2380.63 3049.88 2345.2 3047.78 2315.01C3045.69 2284.83 3062.69 2271.38 3085.82 2285.04C3108.94 2298.51 3129.5 2333.93 3131.6 2364.11V2364.11ZM3122.09 2358.63C3120.47 2335.3 3104.56 2307.93 3086.68 2297.44C3068.81 2286.96 3055.68 2297.35 3057.3 2320.68C3058.93 2344.01 3074.68 2371.39 3092.54 2381.69C3110.42 2392.18 3123.7 2381.77 3122.09 2358.63Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3277.08 2449.31C3279.18 2479.49 3262.02 2492.96 3238.9 2479.48C3215.77 2465.82 3195.37 2430.39 3193.27 2400.21C3191.18 2370.22 3208.19 2356.76 3231.31 2370.24C3254.43 2383.71 3274.99 2419.13 3277.08 2449.31ZM3267.58 2443.83C3265.95 2420.5 3250.05 2393.13 3232.17 2382.64C3214.29 2372.16 3201.17 2382.55 3202.79 2405.88C3204.41 2429.21 3220.16 2456.59 3238.04 2467.08C3255.92 2477.56 3269.2 2467.16 3267.58 2443.83Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3422.57 2534.55C3424.67 2564.73 3407.51 2578.2 3384.39 2564.72C3361.25 2551.06 3340.85 2515.63 3338.77 2485.64C3336.67 2455.46 3353.67 2442 3376.79 2455.48C3399.93 2469.14 3420.48 2504.55 3422.57 2534.55ZM3413.06 2529.07C3411.44 2505.74 3395.53 2478.37 3377.65 2467.88C3359.77 2457.4 3346.65 2467.79 3348.27 2491.12C3349.9 2514.45 3365.64 2541.83 3383.52 2552.32C3401.4 2562.8 3414.68 2552.4 3413.06 2529.07Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_23",
    d: "M2954.11 2311.97C2952.16 2311.11 2950.1 2310.07 2947.92 2308.86C2924.8 2295.38 2904.4 2259.95 2902.3 2229.77C2900.2 2199.59 2917.2 2186.14 2940.34 2199.8C2947.22 2203.79 2953.77 2209.66 2959.61 2216.7L2956.11 2225.31C2951.49 2219.87 2946.44 2215.19 2941.2 2212.2C2923.32 2201.72 2910.2 2212.11 2911.82 2235.44C2913.43 2258.59 2929.18 2285.97 2947.06 2296.45C2948.7 2297.45 2950.32 2298.09 2951.78 2298.73C2952.61 2303.14 2953.39 2307.55 2954.11 2311.97Z",
    fill: "#FA8AC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_24",
    d: "M3073.46 2363.02L3068.6 2370.05C3057.25 2353.91 3049.07 2333.45 3047.78 2314.93C3046.59 2297.9 3051.45 2286.21 3060.1 2281.71L3066.84 2294.82C3060.16 2298.45 3056.38 2307.45 3057.3 2320.6C3058.29 2334.86 3064.58 2350.61 3073.46 2363.02V2363.02Z",
    fill: "#4A63A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_25",
    d: "M3193.07 2395.05C3193.27 2368.62 3209.65 2357.44 3231.31 2370.27C3237.05 2373.6 3242.72 2378.23 3247.84 2384.01L3245.03 2393.33C3240.95 2388.96 3236.6 2385.35 3232.17 2382.68C3215.44 2372.86 3202.81 2381.36 3202.66 2401.83L3193.07 2395.05Z",
    fill: "#8167C9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_26",
    d: "M3386.34 2565.7C3385.69 2565.38 3385.04 2565.05 3384.39 2564.72C3361.25 2551.06 3340.85 2515.63 3338.77 2485.64C3336.67 2455.46 3353.67 2442 3376.79 2455.48C3389.41 2462.79 3401.24 2476.67 3409.74 2492.65L3403.1 2496.64C3396.57 2484.25 3387.49 2473.53 3377.65 2467.88C3359.77 2457.4 3346.65 2467.79 3348.27 2491.12C3349.89 2514.45 3365.64 2541.83 3383.52 2552.32C3384.18 2552.64 3384.66 2552.8 3385.14 2552.95L3386.34 2565.7Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "barchartanim"
  }, /*#__PURE__*/React.createElement("path", {
    id: "laptopscreenfront_4",
    d: "M3205.12 2270.36C3204.75 2270.36 3204.39 2270.25 3204.01 2270.03L2911.83 2102.52C2903.96 2098.01 2899.07 2089.62 2899.07 2080.64V1803.04C2899.07 1801.21 2900.69 1800.36 2901.79 1800.36C2902.24 1800.36 2902.67 1800.48 2903.12 1800.74L3197.02 1969.24C3203.43 1972.91 3207.41 1979.74 3207.41 1987.07V2268.1C3207.41 2268.51 3207.35 2269.13 3206.76 2269.68C3206.31 2270.1 3205.7 2270.36 3205.12 2270.36Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "barsanim"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_29",
    d: "M2949.22 1894L2948.97 2076.44L2937.84 2068.82L2938.08 1886.37C2938.09 1882.29 2940.6 1880.62 2943.58 1882.67C2946.72 1884.71 2949.22 1889.91 2949.22 1894Z",
    fill: "#8167C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_30",
    d: "M2998.68 1955L3000.15 2104.96L2988.93 2097.46L2987.46 1947.5C2987.42 1943.42 2989.91 1941.54 2992.92 1943.74C2996.08 1945.75 2998.64 1950.92 2998.68 1955Z",
    fill: "#4A63A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_31",
    d: "M3027.87 1958.1L3030.74 2124.01L3019.47 2116.59L3016.6 1950.68C3016.53 1946.41 3019.01 1944.7 3022.03 1946.69C3025.2 1948.68 3027.8 1953.83 3027.87 1958.1Z",
    fill: "#8167C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_32",
    d: "M2972.94 1972.97L2972.47 2090.08L2961.35 2082.43L2961.83 1965.31C2961.85 1961.23 2964.36 1959.57 2967.49 1961.62C2970.47 1963.68 2972.96 1968.88 2972.94 1972.97Z",
    fill: "#FA8AC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_33",
    d: "M3056.83 2042.1L3057.32 2137.13L3046.13 2129.58L3045.64 2034.55C3045.62 2030.28 3048.13 2028.6 3051.28 2030.62C3054.27 2032.83 3056.81 2037.83 3056.83 2042.1Z",
    fill: "#FA8AC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_34",
    d: "M3107.2 2119.3L3107.46 2166.63L3096.27 2159.08L3096.02 2111.56C3095.99 2107.48 3098.5 2105.8 3101.65 2107.82C3104.64 2109.85 3107.18 2115.03 3107.2 2119.3Z",
    fill: "#8167C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_35",
    d: "M3157.64 2046.08L3160.37 2199.74L3149.09 2192.33L3146.37 2038.67C3146.29 2034.59 3148.77 2032.69 3151.95 2034.86C3154.97 2036.85 3157.57 2042 3157.64 2046.08Z",
    fill: "#4A63A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_36",
    d: "M3081.46 2086.18L3081.92 2152.81L3070.72 2145.09L3070.26 2078.64C3070.23 2074.56 3072.73 2072.69 3075.88 2074.89C3078.88 2076.91 3081.43 2082.09 3081.46 2086.18Z",
    fill: "#4A63A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_37",
    d: "M3129.43 2053.03L3131.17 2181.46L3119.92 2174L3118.19 2045.57C3118.13 2041.49 3120.62 2039.78 3123.63 2041.79C3126.8 2043.79 3129.38 2048.95 3129.43 2053.03Z",
    fill: "#FA8AC9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "linechart_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_38",
    d: "M3406.97 2211.68C3406.99 2215.39 3404.81 2216.9 3402.12 2215.06L3282.54 2134.65C3280.02 2133 3277.79 2128.56 3277.76 2124.85C3277.73 2121.32 3279.92 2119.82 3282.45 2121.66L3402.03 2201.88C3404.71 2203.72 3406.94 2208.16 3406.97 2211.68Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_39",
    d: "M3395.31 2269.86C3395.34 2273.58 3393.15 2275.08 3390.47 2273.24L3283.04 2201.09C3280.51 2199.25 3278.28 2194.82 3278.26 2191.29C3278.23 2187.76 3280.42 2186.26 3282.94 2188.1L3390.38 2260.25C3393.06 2261.9 3395.29 2266.34 3395.31 2269.86Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_40",
    d: "M3277.51 2091.73C3277.49 2088.02 3279.67 2086.52 3282.2 2088.35L3384.9 2157.38C3387.58 2159.03 3389.65 2163.47 3389.68 2167C3389.71 2170.71 3387.68 2172.21 3385 2170.37L3282.29 2101.35C3279.77 2099.69 3277.54 2095.26 3277.51 2091.73Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_41",
    d: "M3278.5 2224.46C3278.48 2220.93 3280.66 2219.43 3283.19 2221.08L3353.39 2268.26C3356.07 2270.1 3358.15 2274.35 3358.17 2278.06C3358.2 2281.59 3356.17 2283.09 3353.49 2281.25L3283.29 2234.26C3280.76 2232.42 3278.53 2227.98 3278.5 2224.46V2224.46Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_42",
    d: "M3358.67 2344.36C3358.7 2348.07 3356.67 2349.57 3353.98 2347.74L3283.78 2300.56C3281.26 2298.91 3279.03 2294.47 3279 2290.94C3278.97 2287.23 3281.16 2285.73 3283.68 2287.57L3353.89 2334.75C3356.57 2336.4 3358.64 2340.84 3358.67 2344.36Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_43",
    d: "M3278.01 2158.01C3277.98 2154.48 3280.17 2152.98 3282.69 2154.82L3365.36 2210.26C3367.88 2211.91 3370.11 2216.35 3370.14 2220.06C3370.17 2223.58 3367.98 2225.09 3365.46 2223.25L3282.79 2167.81C3280.26 2165.97 3278.04 2161.72 3278.01 2158.01Z",
    fill: "#31B8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_44",
    d: "M3370.88 2319.53C3370.91 2323.06 3368.72 2324.56 3366.2 2322.91L3283.53 2267.47C3281.01 2265.63 3278.78 2261.19 3278.75 2257.67C3278.72 2253.96 3280.91 2252.45 3283.44 2254.29L3366.1 2309.73C3368.63 2311.57 3370.86 2316.01 3370.88 2319.53Z",
    fill: "#31B8CC"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_514",
    x1: 2057.87,
    y1: -492.368,
    x2: 2209.66,
    y2: -340.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_514",
    x1: 2443.69,
    y1: -759.422,
    x2: 2684.45,
    y2: -570.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_71_514",
    x1: 2781.6,
    y1: 279.346,
    x2: 3150.4,
    y2: 846.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_71_514",
    x1: 2828.54,
    y1: -579.327,
    x2: 3290.12,
    y2: -43.6636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_71_514",
    x1: 3257.25,
    y1: 67.4449,
    x2: 1980.46,
    y2: 67.4449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_71_514",
    x1: 2976.3,
    y1: 338.878,
    x2: 1913.21,
    y2: 338.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C6FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B4F87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_71_514",
    x1: 3163.48,
    y1: 101.823,
    x2: 2039.63,
    y2: 101.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C6FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA3D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_71_514",
    x1: 2529.03,
    y1: -219.492,
    x2: 2445.96,
    y2: -219.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C6FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B4F87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_71_514",
    x1: 2226.73,
    y1: -309.109,
    x2: 2142.03,
    y2: -309.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C6FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B4F87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_71_514",
    x1: 955.489,
    y1: 1216.7,
    x2: 570.14,
    y2: 485.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_71_514",
    x1: 541.057,
    y1: 508.272,
    x2: 926.947,
    y2: 1225.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEADAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_71_514",
    x1: 225.251,
    y1: 1286.8,
    x2: 913.806,
    y2: 1293.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_71_514",
    x1: 577.164,
    y1: 1472.56,
    x2: 427.617,
    y2: 1069.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_71_514",
    x1: 416.227,
    y1: 1039.19,
    x2: 444.632,
    y2: 1039.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_71_514",
    x1: 430.622,
    y1: 1044.21,
    x2: 424.49,
    y2: 1027.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_71_514",
    x1: 452.148,
    y1: 1060.05,
    x2: 480.553,
    y2: 1060.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_71_514",
    x1: 466.542,
    y1: 1065.08,
    x2: 460.41,
    y2: 1048.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_71_514",
    x1: 488.069,
    y1: 1080.91,
    x2: 516.474,
    y2: 1081.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_71_514",
    x1: 502.463,
    y1: 1085.93,
    x2: 496.331,
    y2: 1069.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_71_514",
    x1: 523.989,
    y1: 1101.76,
    x2: 552.394,
    y2: 1102.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_71_514",
    x1: 538.385,
    y1: 1106.79,
    x2: 532.253,
    y2: 1090.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_71_514",
    x1: 559.911,
    y1: 1122.63,
    x2: 588.316,
    y2: 1122.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_71_514",
    x1: 574.306,
    y1: 1127.64,
    x2: 568.174,
    y2: 1111.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_71_514",
    x1: 595.832,
    y1: 1143.48,
    x2: 624.237,
    y2: 1143.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_71_514",
    x1: 610.226,
    y1: 1148.51,
    x2: 604.094,
    y2: 1131.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_71_514",
    x1: 631.753,
    y1: 1164.33,
    x2: 660.158,
    y2: 1164.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_71_514",
    x1: 646.148,
    y1: 1169.36,
    x2: 640.015,
    y2: 1152.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_71_514",
    x1: 667.674,
    y1: 1185.2,
    x2: 696.079,
    y2: 1185.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_71_514",
    x1: 682.069,
    y1: 1190.21,
    x2: 675.936,
    y2: 1173.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_71_514",
    x1: 703.594,
    y1: 1206.05,
    x2: 731.999,
    y2: 1206.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_71_514",
    x1: 717.989,
    y1: 1211.08,
    x2: 711.857,
    y2: 1194.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_71_514",
    x1: 775.437,
    y1: 1247.76,
    x2: 803.842,
    y2: 1248.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_71_514",
    x1: 789.831,
    y1: 1252.79,
    x2: 783.698,
    y2: 1236.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_71_514",
    x1: 811.358,
    y1: 1268.63,
    x2: 839.763,
    y2: 1268.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_71_514",
    x1: 825.753,
    y1: 1273.65,
    x2: 819.62,
    y2: 1257.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_71_514",
    x1: 847.278,
    y1: 1289.48,
    x2: 875.683,
    y2: 1289.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_71_514",
    x1: 861.674,
    y1: 1294.51,
    x2: 855.541,
    y2: 1277.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_71_514",
    x1: 383.579,
    y1: 1058.13,
    x2: 411.984,
    y2: 1058.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_71_514",
    x1: 397.973,
    y1: 1063.16,
    x2: 391.841,
    y2: 1046.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_71_514",
    x1: 419.5,
    y1: 1078.99,
    x2: 447.906,
    y2: 1079.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_71_514",
    x1: 433.895,
    y1: 1084.01,
    x2: 427.762,
    y2: 1067.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_71_514",
    x1: 455.421,
    y1: 1099.85,
    x2: 483.826,
    y2: 1100.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_71_514",
    x1: 469.816,
    y1: 1104.88,
    x2: 463.683,
    y2: 1088.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_71_514",
    x1: 491.341,
    y1: 1120.71,
    x2: 519.746,
    y2: 1120.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_71_514",
    x1: 505.737,
    y1: 1125.73,
    x2: 499.605,
    y2: 1109.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_71_514",
    x1: 527.263,
    y1: 1141.56,
    x2: 555.668,
    y2: 1141.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_71_514",
    x1: 541.658,
    y1: 1146.59,
    x2: 535.526,
    y2: 1130.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_71_514",
    x1: 563.184,
    y1: 1162.43,
    x2: 591.589,
    y2: 1162.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_71_514",
    x1: 577.578,
    y1: 1167.45,
    x2: 571.445,
    y2: 1150.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_71_514",
    x1: 599.105,
    y1: 1183.28,
    x2: 627.51,
    y2: 1183.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_71_514",
    x1: 613.5,
    y1: 1188.31,
    x2: 607.367,
    y2: 1171.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_71_514",
    x1: 635.025,
    y1: 1204.13,
    x2: 663.43,
    y2: 1204.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_71_514",
    x1: 649.421,
    y1: 1209.16,
    x2: 643.288,
    y2: 1192.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_71_514",
    x1: 670.946,
    y1: 1225,
    x2: 699.351,
    y2: 1225.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_71_514",
    x1: 685.342,
    y1: 1230.01,
    x2: 679.209,
    y2: 1213.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_71_514",
    x1: 706.868,
    y1: 1245.85,
    x2: 735.273,
    y2: 1246.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_71_514",
    x1: 721.262,
    y1: 1250.88,
    x2: 715.129,
    y2: 1234.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_71_514",
    x1: 737.276,
    y1: 1226.55,
    x2: 765.681,
    y2: 1226.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_71_514",
    x1: 751.67,
    y1: 1231.58,
    x2: 745.538,
    y2: 1215.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_71_514",
    x1: 742.788,
    y1: 1266.71,
    x2: 771.194,
    y2: 1266.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_71_514",
    x1: 757.183,
    y1: 1271.73,
    x2: 751.05,
    y2: 1255.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_71_514",
    x1: 778.708,
    y1: 1287.56,
    x2: 807.113,
    y2: 1287.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_71_514",
    x1: 793.104,
    y1: 1292.59,
    x2: 786.971,
    y2: 1276.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_71_514",
    x1: 814.63,
    y1: 1308.43,
    x2: 843.035,
    y2: 1308.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_71_514",
    x1: 829.026,
    y1: 1313.45,
    x2: 822.893,
    y2: 1296.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_71_514",
    x1: 350.931,
    y1: 1077.08,
    x2: 379.336,
    y2: 1077.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_71_514",
    x1: 365.325,
    y1: 1082.11,
    x2: 359.193,
    y2: 1065.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_71_514",
    x1: 386.852,
    y1: 1097.93,
    x2: 415.257,
    y2: 1098.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_71_514",
    x1: 401.247,
    y1: 1102.96,
    x2: 395.114,
    y2: 1086.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_71_514",
    x1: 422.772,
    y1: 1118.79,
    x2: 451.177,
    y2: 1119.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_71_514",
    x1: 437.168,
    y1: 1123.81,
    x2: 431.035,
    y2: 1107.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_71_514",
    x1: 458.693,
    y1: 1139.65,
    x2: 487.098,
    y2: 1139.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_71_514",
    x1: 473.089,
    y1: 1144.68,
    x2: 466.956,
    y2: 1128.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_71_514",
    x1: 494.614,
    y1: 1160.51,
    x2: 523.019,
    y2: 1160.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_71_514",
    x1: 509.009,
    y1: 1165.53,
    x2: 502.876,
    y2: 1149.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_71_514",
    x1: 530.536,
    y1: 1181.36,
    x2: 558.941,
    y2: 1181.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_71_514",
    x1: 544.93,
    y1: 1186.39,
    x2: 538.797,
    y2: 1169.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_71_514",
    x1: 566.456,
    y1: 1202.23,
    x2: 594.861,
    y2: 1202.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_71_514",
    x1: 580.852,
    y1: 1207.25,
    x2: 574.719,
    y2: 1190.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_71_514",
    x1: 602.377,
    y1: 1223.08,
    x2: 630.782,
    y2: 1223.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_71_514",
    x1: 616.773,
    y1: 1228.11,
    x2: 610.64,
    y2: 1211.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_71_514",
    x1: 638.298,
    y1: 1243.93,
    x2: 666.703,
    y2: 1244.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_71_514",
    x1: 652.694,
    y1: 1248.96,
    x2: 646.562,
    y2: 1232.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_71_514",
    x1: 674.219,
    y1: 1264.8,
    x2: 702.624,
    y2: 1265.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_71_514",
    x1: 688.614,
    y1: 1269.81,
    x2: 682.482,
    y2: 1253.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_71_514",
    x1: 710.141,
    y1: 1285.65,
    x2: 738.546,
    y2: 1285.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_71_514",
    x1: 724.536,
    y1: 1290.68,
    x2: 718.403,
    y2: 1274.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_71_514",
    x1: 746.06,
    y1: 1306.51,
    x2: 774.465,
    y2: 1306.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_71_514",
    x1: 760.456,
    y1: 1311.53,
    x2: 754.323,
    y2: 1295.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_71_514",
    x1: 781.275,
    y1: 1325.54,
    x2: 809.68,
    y2: 1325.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_71_514",
    x1: 795.671,
    y1: 1330.56,
    x2: 789.538,
    y2: 1314.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_71_514",
    x1: 318.283,
    y1: 1096.03,
    x2: 346.688,
    y2: 1096.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_71_514",
    x1: 332.677,
    y1: 1101.04,
    x2: 326.544,
    y2: 1084.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_71_514",
    x1: 354.204,
    y1: 1116.88,
    x2: 382.609,
    y2: 1117.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_71_514",
    x1: 368.598,
    y1: 1121.91,
    x2: 362.465,
    y2: 1105.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_71_514",
    x1: 390.124,
    y1: 1137.73,
    x2: 418.529,
    y2: 1138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_71_514",
    x1: 404.52,
    y1: 1142.76,
    x2: 398.387,
    y2: 1126.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_71_514",
    x1: 426.045,
    y1: 1158.6,
    x2: 454.451,
    y2: 1158.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_71_514",
    x1: 440.442,
    y1: 1163.61,
    x2: 434.309,
    y2: 1147.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_71_514",
    x1: 461.967,
    y1: 1179.45,
    x2: 490.372,
    y2: 1179.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_71_514",
    x1: 476.361,
    y1: 1184.48,
    x2: 470.229,
    y2: 1167.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_71_514",
    x1: 497.888,
    y1: 1200.31,
    x2: 526.293,
    y2: 1200.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_71_514",
    x1: 512.283,
    y1: 1205.33,
    x2: 506.15,
    y2: 1188.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_71_514",
    x1: 533.808,
    y1: 1221.16,
    x2: 562.213,
    y2: 1221.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_71_514",
    x1: 548.203,
    y1: 1226.19,
    x2: 542.071,
    y2: 1209.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_71_514",
    x1: 569.729,
    y1: 1242.03,
    x2: 598.134,
    y2: 1242.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_71_514",
    x1: 584.125,
    y1: 1247.05,
    x2: 577.992,
    y2: 1230.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_71_514",
    x1: 605.65,
    y1: 1262.88,
    x2: 634.056,
    y2: 1263.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_71_514",
    x1: 620.045,
    y1: 1267.91,
    x2: 613.912,
    y2: 1251.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_71_514",
    x1: 641.572,
    y1: 1283.73,
    x2: 669.977,
    y2: 1284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_71_514",
    x1: 655.965,
    y1: 1288.76,
    x2: 649.833,
    y2: 1272.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_71_514",
    x1: 677.492,
    y1: 1304.6,
    x2: 705.897,
    y2: 1304.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_71_514",
    x1: 691.887,
    y1: 1309.61,
    x2: 685.755,
    y2: 1293.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_71_514",
    x1: 713.413,
    y1: 1325.45,
    x2: 741.818,
    y2: 1325.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_71_514",
    x1: 727.809,
    y1: 1330.48,
    x2: 721.676,
    y2: 1313.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_71_514",
    x1: 749.334,
    y1: 1346.31,
    x2: 777.739,
    y2: 1346.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_71_514",
    x1: 763.73,
    y1: 1351.33,
    x2: 757.597,
    y2: 1334.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_71_514",
    x1: 285.635,
    y1: 1114.96,
    x2: 314.04,
    y2: 1115.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_71_514",
    x1: 300.03,
    y1: 1119.99,
    x2: 293.897,
    y2: 1103.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_71_514",
    x1: 321.555,
    y1: 1135.83,
    x2: 349.96,
    y2: 1136.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_71_514",
    x1: 335.95,
    y1: 1140.84,
    x2: 329.818,
    y2: 1124.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_71_514",
    x1: 357.476,
    y1: 1156.68,
    x2: 385.881,
    y2: 1156.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_71_514",
    x1: 371.872,
    y1: 1161.71,
    x2: 365.74,
    y2: 1145.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_71_514",
    x1: 393.397,
    y1: 1177.53,
    x2: 421.802,
    y2: 1177.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_71_514",
    x1: 407.792,
    y1: 1182.56,
    x2: 401.66,
    y2: 1166.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_71_514",
    x1: 429.319,
    y1: 1198.4,
    x2: 457.724,
    y2: 1198.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_71_514",
    x1: 443.713,
    y1: 1203.41,
    x2: 437.581,
    y2: 1186.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_71_514",
    x1: 465.238,
    y1: 1219.25,
    x2: 493.643,
    y2: 1219.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_71_514",
    x1: 479.634,
    y1: 1224.28,
    x2: 473.502,
    y2: 1207.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_71_514",
    x1: 501.16,
    y1: 1240.11,
    x2: 529.565,
    y2: 1240.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_71_514",
    x1: 515.555,
    y1: 1245.13,
    x2: 509.423,
    y2: 1228.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_71_514",
    x1: 537.081,
    y1: 1260.96,
    x2: 565.486,
    y2: 1261.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_71_514",
    x1: 551.477,
    y1: 1265.99,
    x2: 545.344,
    y2: 1249.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_71_514",
    x1: 573.002,
    y1: 1281.83,
    x2: 601.407,
    y2: 1282.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_71_514",
    x1: 587.397,
    y1: 1286.85,
    x2: 581.264,
    y2: 1270.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_71_514",
    x1: 608.923,
    y1: 1302.68,
    x2: 637.328,
    y2: 1302.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_71_514",
    x1: 623.318,
    y1: 1307.71,
    x2: 617.185,
    y2: 1291.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_71_514",
    x1: 644.843,
    y1: 1323.53,
    x2: 673.248,
    y2: 1323.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_71_514",
    x1: 659.239,
    y1: 1328.56,
    x2: 653.107,
    y2: 1312.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_71_514",
    x1: 680.765,
    y1: 1344.4,
    x2: 709.17,
    y2: 1344.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_71_514",
    x1: 695.16,
    y1: 1349.43,
    x2: 689.028,
    y2: 1332.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_71_514",
    x1: 716.686,
    y1: 1365.25,
    x2: 745.091,
    y2: 1365.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_71_514",
    x1: 731.08,
    y1: 1370.28,
    x2: 724.947,
    y2: 1353.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_71_514",
    x1: 253.274,
    y1: 1133.54,
    x2: 281.68,
    y2: 1133.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_71_514",
    x1: 267.67,
    y1: 1138.57,
    x2: 261.538,
    y2: 1122.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_71_514",
    x1: 288.907,
    y1: 1154.76,
    x2: 317.312,
    y2: 1155.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_71_514",
    x1: 303.302,
    y1: 1159.79,
    x2: 297.17,
    y2: 1143.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_71_514",
    x1: 324.828,
    y1: 1175.63,
    x2: 353.233,
    y2: 1175.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_71_514",
    x1: 339.224,
    y1: 1180.65,
    x2: 333.091,
    y2: 1164.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_71_514",
    x1: 360.749,
    y1: 1196.48,
    x2: 389.155,
    y2: 1196.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_71_514",
    x1: 375.144,
    y1: 1201.51,
    x2: 369.012,
    y2: 1184.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_71_514",
    x1: 396.67,
    y1: 1217.33,
    x2: 425.075,
    y2: 1217.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_71_514",
    x1: 411.065,
    y1: 1222.36,
    x2: 404.932,
    y2: 1205.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_71_514",
    x1: 432.591,
    y1: 1238.2,
    x2: 460.996,
    y2: 1238.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_71_514",
    x1: 446.986,
    y1: 1243.21,
    x2: 440.854,
    y2: 1226.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_71_514",
    x1: 468.511,
    y1: 1259.05,
    x2: 496.916,
    y2: 1259.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_71_514",
    x1: 482.907,
    y1: 1264.08,
    x2: 476.775,
    y2: 1247.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_71_514",
    x1: 504.433,
    y1: 1279.91,
    x2: 532.838,
    y2: 1280.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_71_514",
    x1: 518.828,
    y1: 1284.93,
    x2: 512.695,
    y2: 1268.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_71_514",
    x1: 540.354,
    y1: 1300.76,
    x2: 568.759,
    y2: 1301.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_71_514",
    x1: 554.749,
    y1: 1305.79,
    x2: 548.616,
    y2: 1289.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_71_514",
    x1: 576.274,
    y1: 1321.63,
    x2: 604.679,
    y2: 1321.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_71_514",
    x1: 590.67,
    y1: 1326.65,
    x2: 584.537,
    y2: 1310.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_71_514",
    x1: 612.196,
    y1: 1342.48,
    x2: 640.601,
    y2: 1342.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_71_514",
    x1: 626.591,
    y1: 1347.51,
    x2: 620.458,
    y2: 1330.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_71_514",
    x1: 648.117,
    y1: 1363.33,
    x2: 676.522,
    y2: 1363.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_71_514",
    x1: 662.512,
    y1: 1368.36,
    x2: 656.38,
    y2: 1351.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_71_514",
    x1: 684.037,
    y1: 1384.2,
    x2: 712.443,
    y2: 1384.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_71_514",
    x1: 698.433,
    y1: 1389.23,
    x2: 692.3,
    y2: 1372.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_71_514",
    x1: 3397.49,
    y1: 2564.93,
    x2: 3012.14,
    y2: 1834.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_71_514",
    x1: 2983.06,
    y1: 1856.5,
    x2: 3368.95,
    y2: 2573.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEADAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_71_514",
    x1: 2667.25,
    y1: 2635.03,
    x2: 3355.81,
    y2: 2641.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_71_514",
    x1: 3019.16,
    y1: 2820.79,
    x2: 2869.62,
    y2: 2417.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_71_514",
    x1: 2858.23,
    y1: 2387.42,
    x2: 2886.63,
    y2: 2387.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_71_514",
    x1: 2872.62,
    y1: 2392.45,
    x2: 2866.49,
    y2: 2375.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_71_514",
    x1: 2894.15,
    y1: 2408.29,
    x2: 2922.55,
    y2: 2408.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_71_514",
    x1: 2908.54,
    y1: 2413.31,
    x2: 2902.41,
    y2: 2396.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_71_514",
    x1: 2930.07,
    y1: 2429.14,
    x2: 2958.47,
    y2: 2429.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_71_514",
    x1: 2944.46,
    y1: 2434.17,
    x2: 2938.33,
    y2: 2417.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_71_514",
    x1: 2965.99,
    y1: 2449.99,
    x2: 2994.39,
    y2: 2450.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_71_514",
    x1: 2980.39,
    y1: 2455.02,
    x2: 2974.25,
    y2: 2438.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_71_514",
    x1: 3001.91,
    y1: 2470.86,
    x2: 3030.32,
    y2: 2471.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_71_514",
    x1: 3016.31,
    y1: 2475.87,
    x2: 3010.17,
    y2: 2459.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_71_514",
    x1: 3037.83,
    y1: 2491.71,
    x2: 3066.24,
    y2: 2491.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_71_514",
    x1: 3052.23,
    y1: 2496.74,
    x2: 3046.09,
    y2: 2480.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_71_514",
    x1: 3073.75,
    y1: 2512.57,
    x2: 3102.16,
    y2: 2512.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_71_514",
    x1: 3088.15,
    y1: 2517.59,
    x2: 3082.02,
    y2: 2501.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_71_514",
    x1: 3109.67,
    y1: 2533.43,
    x2: 3138.08,
    y2: 2533.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_71_514",
    x1: 3124.07,
    y1: 2538.45,
    x2: 3117.94,
    y2: 2521.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_71_514",
    x1: 3145.59,
    y1: 2554.29,
    x2: 3174,
    y2: 2554.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_71_514",
    x1: 3159.99,
    y1: 2559.31,
    x2: 3153.86,
    y2: 2542.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_71_514",
    x1: 3217.44,
    y1: 2595.99,
    x2: 3245.84,
    y2: 2596.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_71_514",
    x1: 3231.83,
    y1: 2601.02,
    x2: 3225.7,
    y2: 2584.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_71_514",
    x1: 3253.36,
    y1: 2616.86,
    x2: 3281.76,
    y2: 2617.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_71_514",
    x1: 3267.75,
    y1: 2621.89,
    x2: 3261.62,
    y2: 2605.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_71_514",
    x1: 3289.28,
    y1: 2637.71,
    x2: 3317.68,
    y2: 2637.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_71_514",
    x1: 3303.67,
    y1: 2642.74,
    x2: 3297.54,
    y2: 2626.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_71_514",
    x1: 2825.58,
    y1: 2406.37,
    x2: 2853.98,
    y2: 2406.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_71_514",
    x1: 2839.97,
    y1: 2411.39,
    x2: 2833.84,
    y2: 2394.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_71_514",
    x1: 2861.5,
    y1: 2427.22,
    x2: 2889.91,
    y2: 2427.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_71_514",
    x1: 2875.89,
    y1: 2432.25,
    x2: 2869.76,
    y2: 2415.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_71_514",
    x1: 2897.42,
    y1: 2448.09,
    x2: 2925.83,
    y2: 2448.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_71_514",
    x1: 2911.82,
    y1: 2453.11,
    x2: 2905.68,
    y2: 2436.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_71_514",
    x1: 2933.34,
    y1: 2468.94,
    x2: 2961.75,
    y2: 2469.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_71_514",
    x1: 2947.74,
    y1: 2473.96,
    x2: 2941.6,
    y2: 2457.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_71_514",
    x1: 2969.26,
    y1: 2489.79,
    x2: 2997.67,
    y2: 2490.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_71_514",
    x1: 2983.66,
    y1: 2494.82,
    x2: 2977.53,
    y2: 2478.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_71_514",
    x1: 3005.18,
    y1: 2510.66,
    x2: 3033.59,
    y2: 2510.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_71_514",
    x1: 3019.58,
    y1: 2515.69,
    x2: 3013.45,
    y2: 2499.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_71_514",
    x1: 3041.11,
    y1: 2531.51,
    x2: 3069.51,
    y2: 2531.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_71_514",
    x1: 3055.5,
    y1: 2536.54,
    x2: 3049.37,
    y2: 2520.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_71_514",
    x1: 3077.02,
    y1: 2552.36,
    x2: 3105.43,
    y2: 2552.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_71_514",
    x1: 3091.42,
    y1: 2557.39,
    x2: 3085.29,
    y2: 2540.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_71_514",
    x1: 3112.95,
    y1: 2573.23,
    x2: 3141.35,
    y2: 2573.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_71_514",
    x1: 3127.34,
    y1: 2578.25,
    x2: 3121.21,
    y2: 2561.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_71_514",
    x1: 3148.87,
    y1: 2594.09,
    x2: 3177.27,
    y2: 2594.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_71_514",
    x1: 3163.26,
    y1: 2599.11,
    x2: 3157.13,
    y2: 2582.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_71_514",
    x1: 3179.28,
    y1: 2574.78,
    x2: 3207.68,
    y2: 2575.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_71_514",
    x1: 3193.67,
    y1: 2579.81,
    x2: 3187.54,
    y2: 2563.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_71_514",
    x1: 3184.79,
    y1: 2614.94,
    x2: 3213.19,
    y2: 2615.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_71_514",
    x1: 3199.18,
    y1: 2619.96,
    x2: 3193.05,
    y2: 2603.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_71_514",
    x1: 3220.71,
    y1: 2635.79,
    x2: 3249.11,
    y2: 2636.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_71_514",
    x1: 3235.1,
    y1: 2640.82,
    x2: 3228.97,
    y2: 2624.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_71_514",
    x1: 3256.63,
    y1: 2656.66,
    x2: 3285.04,
    y2: 2656.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_71_514",
    x1: 3271.03,
    y1: 2661.69,
    x2: 3264.89,
    y2: 2645.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_71_514",
    x1: 2792.93,
    y1: 2425.31,
    x2: 2821.34,
    y2: 2425.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_71_514",
    x1: 2807.33,
    y1: 2430.34,
    x2: 2801.19,
    y2: 2413.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_71_514",
    x1: 2828.85,
    y1: 2446.17,
    x2: 2857.26,
    y2: 2446.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_71_514",
    x1: 2843.25,
    y1: 2451.19,
    x2: 2837.11,
    y2: 2434.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_71_514",
    x1: 2864.77,
    y1: 2467.02,
    x2: 2893.18,
    y2: 2467.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_71_514",
    x1: 2879.17,
    y1: 2472.05,
    x2: 2873.03,
    y2: 2455.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_71_514",
    x1: 2900.69,
    y1: 2487.89,
    x2: 2929.1,
    y2: 2488.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_71_514",
    x1: 2915.09,
    y1: 2492.91,
    x2: 2908.96,
    y2: 2476.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_71_514",
    x1: 2936.61,
    y1: 2508.74,
    x2: 2965.02,
    y2: 2509.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_71_514",
    x1: 2951.01,
    y1: 2513.77,
    x2: 2944.88,
    y2: 2497.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_71_514",
    x1: 2972.54,
    y1: 2529.59,
    x2: 3000.94,
    y2: 2529.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_71_514",
    x1: 2986.93,
    y1: 2534.62,
    x2: 2980.8,
    y2: 2518.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_71_514",
    x1: 3008.46,
    y1: 2550.46,
    x2: 3036.86,
    y2: 2550.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_71_514",
    x1: 3022.85,
    y1: 2555.49,
    x2: 3016.72,
    y2: 2538.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_71_514",
    x1: 3044.38,
    y1: 2571.31,
    x2: 3072.78,
    y2: 2571.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_71_514",
    x1: 3058.77,
    y1: 2576.34,
    x2: 3052.64,
    y2: 2559.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_71_514",
    x1: 3080.3,
    y1: 2592.17,
    x2: 3108.7,
    y2: 2592.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_71_514",
    x1: 3094.69,
    y1: 2597.19,
    x2: 3088.56,
    y2: 2580.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_71_514",
    x1: 3116.22,
    y1: 2613.03,
    x2: 3144.62,
    y2: 2613.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_71_514",
    x1: 3130.61,
    y1: 2618.04,
    x2: 3124.48,
    y2: 2601.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_71_514",
    x1: 3152.14,
    y1: 2633.89,
    x2: 3180.55,
    y2: 2634.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_71_514",
    x1: 3166.54,
    y1: 2638.91,
    x2: 3160.4,
    y2: 2622.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_71_514",
    x1: 3188.06,
    y1: 2654.74,
    x2: 3216.47,
    y2: 2655.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_71_514",
    x1: 3202.46,
    y1: 2659.76,
    x2: 3196.32,
    y2: 2643.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_71_514",
    x1: 3223.27,
    y1: 2673.77,
    x2: 3251.68,
    y2: 2674.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_71_514",
    x1: 3237.67,
    y1: 2678.8,
    x2: 3231.54,
    y2: 2662.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_71_514",
    x1: 2760.28,
    y1: 2444.26,
    x2: 2788.69,
    y2: 2444.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_71_514",
    x1: 2774.68,
    y1: 2449.27,
    x2: 2768.54,
    y2: 2432.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_71_514",
    x1: 2796.2,
    y1: 2465.11,
    x2: 2824.61,
    y2: 2465.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_71_514",
    x1: 2810.6,
    y1: 2470.14,
    x2: 2804.47,
    y2: 2453.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_71_514",
    x1: 2832.12,
    y1: 2485.97,
    x2: 2860.53,
    y2: 2486.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_71_514",
    x1: 2846.52,
    y1: 2490.99,
    x2: 2840.39,
    y2: 2474.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_71_514",
    x1: 2868.05,
    y1: 2506.83,
    x2: 2896.45,
    y2: 2507.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_71_514",
    x1: 2882.44,
    y1: 2511.85,
    x2: 2876.31,
    y2: 2495.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_71_514",
    x1: 2903.97,
    y1: 2527.68,
    x2: 2932.37,
    y2: 2527.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_71_514",
    x1: 2918.36,
    y1: 2532.71,
    x2: 2912.23,
    y2: 2516.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_71_514",
    x1: 2939.89,
    y1: 2548.54,
    x2: 2968.29,
    y2: 2548.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_71_514",
    x1: 2954.28,
    y1: 2553.56,
    x2: 2948.15,
    y2: 2537.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_71_514",
    x1: 2975.81,
    y1: 2569.39,
    x2: 3004.21,
    y2: 2569.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_71_514",
    x1: 2990.2,
    y1: 2574.42,
    x2: 2984.07,
    y2: 2557.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_71_514",
    x1: 3011.73,
    y1: 2590.26,
    x2: 3040.13,
    y2: 2590.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_71_514",
    x1: 3026.13,
    y1: 2595.29,
    x2: 3019.99,
    y2: 2578.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_71_514",
    x1: 3047.65,
    y1: 2611.11,
    x2: 3076.06,
    y2: 2611.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_71_514",
    x1: 3062.04,
    y1: 2616.14,
    x2: 3055.91,
    y2: 2599.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_71_514",
    x1: 3083.57,
    y1: 2631.96,
    x2: 3111.98,
    y2: 2632.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_71_514",
    x1: 3097.97,
    y1: 2636.99,
    x2: 3091.83,
    y2: 2620.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_71_514",
    x1: 3119.49,
    y1: 2652.83,
    x2: 3147.9,
    y2: 2653.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_71_514",
    x1: 3133.89,
    y1: 2657.84,
    x2: 3127.75,
    y2: 2641.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_71_514",
    x1: 3155.41,
    y1: 2673.69,
    x2: 3183.82,
    y2: 2673.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_71_514",
    x1: 3169.81,
    y1: 2678.71,
    x2: 3163.68,
    y2: 2662.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_71_514",
    x1: 3191.33,
    y1: 2694.54,
    x2: 3219.74,
    y2: 2694.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_71_514",
    x1: 3205.73,
    y1: 2699.56,
    x2: 3199.6,
    y2: 2683.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_71_514",
    x1: 2727.63,
    y1: 2463.19,
    x2: 2756.04,
    y2: 2463.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_71_514",
    x1: 2742.03,
    y1: 2468.22,
    x2: 2735.9,
    y2: 2451.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_71_514",
    x1: 2763.56,
    y1: 2484.06,
    x2: 2791.96,
    y2: 2484.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_71_514",
    x1: 2777.95,
    y1: 2489.07,
    x2: 2771.82,
    y2: 2472.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_71_514",
    x1: 2799.48,
    y1: 2504.91,
    x2: 2827.88,
    y2: 2505.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_71_514",
    x1: 2813.87,
    y1: 2509.94,
    x2: 2807.74,
    y2: 2493.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_71_514",
    x1: 2835.4,
    y1: 2525.77,
    x2: 2863.8,
    y2: 2526.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_71_514",
    x1: 2849.79,
    y1: 2530.79,
    x2: 2843.66,
    y2: 2514.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_71_514",
    x1: 2871.32,
    y1: 2546.63,
    x2: 2899.72,
    y2: 2546.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_71_514",
    x1: 2885.71,
    y1: 2551.64,
    x2: 2879.58,
    y2: 2535.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_71_514",
    x1: 2907.24,
    y1: 2567.49,
    x2: 2935.64,
    y2: 2567.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_71_514",
    x1: 2921.63,
    y1: 2572.51,
    x2: 2915.5,
    y2: 2555.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_71_514",
    x1: 2943.16,
    y1: 2588.34,
    x2: 2971.56,
    y2: 2588.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_71_514",
    x1: 2957.56,
    y1: 2593.37,
    x2: 2951.42,
    y2: 2576.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_71_514",
    x1: 2979.08,
    y1: 2609.19,
    x2: 3007.49,
    y2: 2609.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_71_514",
    x1: 2993.48,
    y1: 2614.22,
    x2: 2987.34,
    y2: 2597.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_71_514",
    x1: 3015,
    y1: 2630.06,
    x2: 3043.41,
    y2: 2630.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_71_514",
    x1: 3029.4,
    y1: 2635.09,
    x2: 3023.26,
    y2: 2618.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_71_514",
    x1: 3050.92,
    y1: 2650.91,
    x2: 3079.33,
    y2: 2651.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_71_514",
    x1: 3065.32,
    y1: 2655.94,
    x2: 3059.19,
    y2: 2639.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_71_514",
    x1: 3086.84,
    y1: 2671.77,
    x2: 3115.25,
    y2: 2672.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_71_514",
    x1: 3101.24,
    y1: 2676.79,
    x2: 3095.11,
    y2: 2660.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_71_514",
    x1: 3122.77,
    y1: 2692.63,
    x2: 3151.17,
    y2: 2692.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_71_514",
    x1: 3137.16,
    y1: 2697.66,
    x2: 3131.03,
    y2: 2681.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_71_514",
    x1: 3158.69,
    y1: 2713.48,
    x2: 3187.09,
    y2: 2713.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_71_514",
    x1: 3173.08,
    y1: 2718.51,
    x2: 3166.95,
    y2: 2701.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_71_514",
    x1: 2695.27,
    y1: 2481.78,
    x2: 2723.68,
    y2: 2482.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_71_514",
    x1: 2709.67,
    y1: 2486.8,
    x2: 2703.54,
    y2: 2470.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_71_514",
    x1: 2730.91,
    y1: 2502.99,
    x2: 2759.31,
    y2: 2503.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_71_514",
    x1: 2745.3,
    y1: 2508.02,
    x2: 2739.17,
    y2: 2491.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_71_514",
    x1: 2766.83,
    y1: 2523.86,
    x2: 2795.23,
    y2: 2524.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_71_514",
    x1: 2781.22,
    y1: 2528.88,
    x2: 2775.09,
    y2: 2512.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_71_514",
    x1: 2802.75,
    y1: 2544.71,
    x2: 2831.15,
    y2: 2544.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_71_514",
    x1: 2817.14,
    y1: 2549.74,
    x2: 2811.01,
    y2: 2533.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_71_514",
    x1: 2838.67,
    y1: 2565.57,
    x2: 2867.08,
    y2: 2565.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_71_514",
    x1: 2853.06,
    y1: 2570.59,
    x2: 2846.93,
    y2: 2554.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_71_514",
    x1: 2874.59,
    y1: 2586.43,
    x2: 2903,
    y2: 2586.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_71_514",
    x1: 2888.99,
    y1: 2591.45,
    x2: 2882.85,
    y2: 2574.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_71_514",
    x1: 2910.51,
    y1: 2607.28,
    x2: 2938.92,
    y2: 2607.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_71_514",
    x1: 2924.91,
    y1: 2612.31,
    x2: 2918.77,
    y2: 2595.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_71_514",
    x1: 2946.43,
    y1: 2628.14,
    x2: 2974.84,
    y2: 2628.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_71_514",
    x1: 2960.83,
    y1: 2633.16,
    x2: 2954.7,
    y2: 2616.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_71_514",
    x1: 2982.35,
    y1: 2648.99,
    x2: 3010.76,
    y2: 2649.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_71_514",
    x1: 2996.75,
    y1: 2654.02,
    x2: 2990.62,
    y2: 2637.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_71_514",
    x1: 3018.27,
    y1: 2669.86,
    x2: 3046.68,
    y2: 2670.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_71_514",
    x1: 3032.67,
    y1: 2674.88,
    x2: 3026.54,
    y2: 2658.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_71_514",
    x1: 3054.2,
    y1: 2690.71,
    x2: 3082.6,
    y2: 2690.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_71_514",
    x1: 3068.59,
    y1: 2695.74,
    x2: 3062.46,
    y2: 2679.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_71_514",
    x1: 3090.12,
    y1: 2711.57,
    x2: 3118.52,
    y2: 2711.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_71_514",
    x1: 3104.51,
    y1: 2716.59,
    x2: 3098.38,
    y2: 2700.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_71_514",
    x1: 3126.04,
    y1: 2732.43,
    x2: 3154.44,
    y2: 2732.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_71_514",
    x1: 3140.43,
    y1: 2737.46,
    x2: 3134.3,
    y2: 2720.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95979E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainanimation);
export default __webpack_public_path__ + "static/media/mainanimation.b73ae468.svg";
export { ForwardRef as ReactComponent };